/* eslint-disable */
var _s2 = $RefreshSig$();
var _jsxFileName = "C:\\Users\\shana\\Desktop\\Rabbit_AI\\ai_testing_platform_full\\frontend\\src\\pages\LoadTesting.js",
  _s = $RefreshSig$();
import React, { useState, useEffect, useContext, useRef } from "react";
import { WorkspaceContext } from "../context/WorkspaceContext";
import axios from "axios";
import { API_BASE } from "../config/apiConfig";
import { jsxDEV as _jsxDEV, Fragment as _Fragment } from "react/jsx-dev-runtime";
const WORKFLOW_TEMPLATES = [{
  type: "login",
  label: "Login & Dashboard",
  category: "Authentication",
  icon: "🔑",
  desc: "Test user authentication, session creation, dashboard loading, and logout performance.",
  steps: ["Login", "Dashboard", "Logout"],
  difficulty: "Easy",
  estSteps: 3,
  apiCalls: 3,
  requests: "5 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (credentials)",
  varExtract: "Yes (session token)"
}, {
  type: "emp_login",
  label: "Employee Login",
  category: "Authentication",
  icon: "💼",
  desc: "Simulate corporate employee login, single sign-on (SSO), profile fetch, and key modules initialization.",
  steps: ["SSO Redirect", "Validate Token", "Fetch Profile", "Load Dashboard"],
  difficulty: "Medium",
  estSteps: 4,
  apiCalls: 5,
  requests: "8 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (employee IDs)",
  varExtract: "Yes (JWT Token)"
}, {
  type: "ecommerce",
  label: "Online Purchase Journey",
  category: "E-Commerce",
  icon: "🛒",
  desc: "Simulate browsing products, adding items to the cart, checkout, payment, and order confirmation.",
  steps: ["Browse Items", "Add to Cart", "Checkout", "Payment", "Order Confirmation"],
  difficulty: "Medium",
  estSteps: 5,
  apiCalls: 6,
  requests: "12 req/VU",
  authReq: "Optional",
  dataDriven: "Yes (product Catalog)",
  varExtract: "Yes (cart ID, transaction ID)"
}, {
  type: "food_ordering",
  label: "Food Ordering Flow",
  category: "E-Commerce",
  icon: "🍔",
  desc: "Simulate browsing restaurants, configuring meal items, payment gateway authorization, and order status tracking.",
  steps: ["Search Restaurant", "Customize Burger", "Authorize Card", "Track Delivery"],
  difficulty: "Medium",
  estSteps: 4,
  apiCalls: 5,
  requests: "9 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (meal customization codes)",
  varExtract: "Yes (order UUID)"
}, {
  type: "crm",
  label: "CRM Sales Workflow",
  category: "Business Applications",
  icon: "📈",
  desc: "Measure the performance of lead creation, search, update, assignment, and deletion.",
  steps: ["Login", "Create Lead", "Update Lead", "Delete Lead", "Logout"],
  difficulty: "Medium",
  estSteps: 5,
  apiCalls: 5,
  requests: "7 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (lead fields)",
  varExtract: "Yes (lead ID)"
}, {
  type: "hr_recruit",
  label: "HR Recruitment",
  category: "Business Applications",
  icon: "🤝",
  desc: "Simulate posting a job listing, applicant resume upload, candidate profiling, and schedule screening calls.",
  steps: ["Publish Job", "Upload PDF CV", "Generate Candidate Profile", "Schedule Interview"],
  difficulty: "Hard",
  estSteps: 4,
  apiCalls: 6,
  requests: "11 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (mock resumes)",
  varExtract: "Yes (candidate ID)"
}, {
  type: "cust_support",
  label: "Customer Support Portal",
  category: "Business Applications",
  icon: "💬",
  desc: "Benchmark performance of helpdesk ticketing system: search KB articles, raise ticket, upload attachment.",
  steps: ["Search Knowledge Base", "Open Ticket Form", "Attach Diagnostic Log", "Submit Ticket"],
  difficulty: "Medium",
  estSteps: 4,
  apiCalls: 4,
  requests: "6 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (support categories)",
  varExtract: "Yes (ticket reference)"
}, {
  type: "doc_approve",
  label: "Document Approval",
  category: "Business Applications",
  icon: "📄",
  desc: "Test performance of workflow documents approval matrix: upload files, sign document, route to manager.",
  steps: ["Upload Contract Document", "Apply Digital Signature", "Assign Approvers", "Manager Approval API"],
  difficulty: "Medium",
  estSteps: 4,
  apiCalls: 4,
  requests: "5 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (sign keys)",
  varExtract: "Yes (doc signature token)"
}, {
  type: "hotel_booking",
  label: "Hotel Booking",
  category: "Business Applications",
  icon: "🏨",
  desc: "Validate lodging reservation performance: room search by date range, room tier select, billing authorization.",
  steps: ["Search Rooms", "Select Tier Room", "Apply Coupon Discount", "Confirm Room Booking"],
  difficulty: "Medium",
  estSteps: 4,
  apiCalls: 5,
  requests: "8 req/VU",
  authReq: "Optional",
  dataDriven: "Yes (hotel IDs, room sizes)",
  varExtract: "Yes (booking reference hash)"
}, {
  type: "student_adm",
  label: "Student Admission",
  category: "Education",
  icon: "🎓",
  desc: "Simulate student login, viewing courses, registering a subject, paying semester fees, and downloading the receipt.",
  steps: ["Student Login", "View Course Catalog", "Select Electives", "Process Tuition", "Download PDF Invoice"],
  difficulty: "Hard",
  estSteps: 5,
  apiCalls: 7,
  requests: "15 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (student registry profiles)",
  varExtract: "Yes (receipt signature token)"
}, {
  type: "patient_reg",
  label: "Patient Registration",
  category: "Healthcare",
  icon: "🏥",
  desc: "Simulate checking in a patient, searching clinical history, assigning doctor, and writing prescription entries.",
  steps: ["Scan Identity Code", "Fetch History Logs", "Doctor Assign API", "Submit Prescription"],
  difficulty: "Medium",
  estSteps: 4,
  apiCalls: 5,
  requests: "6 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (patient insurance metadata)",
  varExtract: "Yes (encounter transaction ID)"
}, {
  type: "banking_tx",
  label: "Banking Transaction",
  category: "Finance",
  icon: "💳",
  desc: "Simulate transferring funds between customer savings and checking balances, checking statements, and downloading records.",
  steps: ["Verify PIN", "Savings Fetch Balance", "Initiate Wire Transfer", "Statement PDF Generation"],
  difficulty: "Hard",
  estSteps: 4,
  apiCalls: 6,
  requests: "10 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (valid beneficiary IBANs)",
  varExtract: "Yes (wire transaction authorization key)"
}, {
  type: "insurance_claims",
  label: "Insurance Claims",
  category: "Finance",
  icon: "🛡️",
  desc: "Validate claims processing under load: submit claims details, attach proof pictures, query status.",
  steps: ["Select Policy ID", "Submit Claim Details", "Upload Damage Images", "Query Claim Status"],
  difficulty: "Hard",
  estSteps: 4,
  apiCalls: 5,
  requests: "8 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (policy numbers)",
  varExtract: "Yes (claim ticket reference)"
}, {
  type: "loan_proc",
  label: "Loan Processing",
  category: "Finance",
  icon: "🏦",
  desc: "Benchmark credit check verification, collateral estimation calculations, loan request approval matrices.",
  steps: ["Verify Credit Rating", "Submit Collateral Estimations", "Calculate Interest Margin", "Request Approval API"],
  difficulty: "Hard",
  estSteps: 4,
  apiCalls: 6,
  requests: "9 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (salary records)",
  varExtract: "Yes (credit score hash)"
}, {
  type: "payment_gateway",
  label: "Payment Gateway",
  category: "Finance",
  icon: "💸",
  desc: "Stress test merchant API token creations, billing checks, 3D secure redirections, and settle callback updates.",
  steps: ["Generate Client Token", "Pre-auth Credit Card", "Redirect 3D Secure Page", "Capture Authorization Settlement"],
  difficulty: "Hard",
  estSteps: 4,
  apiCalls: 4,
  requests: "8 req/VU",
  authReq: "Yes (API Secrets)",
  dataDriven: "Yes (card tokens)",
  varExtract: "Yes (charge transaction ID)"
}, {
  type: "inventory",
  label: "Inventory Management",
  category: "ERP",
  icon: "📦",
  desc: "Measure stock checking speed, product batch count updates, warehouse location assignments, and inventory logs.",
  steps: ["Query SKU Stock", "Update Batch Inventory Quantity", "Warehouse Location API Check", "Log Audit Ledger"],
  difficulty: "Medium",
  estSteps: 4,
  apiCalls: 4,
  requests: "5 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (SKU list)",
  varExtract: "Yes (log entry ID)"
}, {
  type: "erp_workflow",
  label: "ERP Sales Workflow",
  category: "ERP",
  icon: "🏢",
  desc: "Simulate purchase orders creation, vendor catalogs queries, invoice checks, supply assignments.",
  steps: ["Query Vendor Catalog", "Create PO Document", "Audit Invoice Details", "Assign Warehouse Carrier"],
  difficulty: "Hard",
  estSteps: 4,
  apiCalls: 5,
  requests: "7 req/VU",
  authReq: "Yes",
  dataDriven: "Yes (PO records)",
  varExtract: "Yes (PO ID)"
}, {
  type: "search",
  label: "Search Experience",
  category: "Custom",
  icon: "🔍",
  desc: "Validate search performance, filtering, sorting, and result loading under concurrent users.",
  steps: ["Search Term", "Filter Results", "Load Details"],
  difficulty: "Easy",
  estSteps: 3,
  apiCalls: 3,
  requests: "4 req/VU",
  authReq: "No",
  dataDriven: "Yes (query lists)",
  varExtract: "No"
}, {
  type: "custom",
  label: "Build From Scratch",
  category: "Custom",
  icon: "✍️",
  desc: "Create your own business workflow using Qintra's visual builder.",
  steps: ["Custom Step"],
  difficulty: "Easy",
  estSteps: 1,
  apiCalls: 1,
  requests: "1 req/VU",
  authReq: "No",
  dataDriven: "No",
  varExtract: "No"
}];
const getStepsForTemplate = templateType => {
  if (templateType === "login") {
    return [{
      name: "1. Login Page",
      method: "POST",
      path: "/api/login",
      headers: '{"Content-Type": "application/json"}',
      body: '{"username": "${email}", "password": "${password}"}',
      extractors: '[{"type": "json", "expression": "$.token", "variable_name": "token"}]',
      assertions: '[{"type": "status_code", "expected_value": "200"}]',
      think_time: 1
    }, {
      name: "2. Get Dashboard",
      method: "GET",
      path: "/api/dashboard",
      headers: '{"Authorization": "Bearer ${token}"}',
      body: "",
      extractors: "[]",
      assertions: '[{"type": "status_code", "expected_value": "200"}]',
      think_time: 2
    }];
  } else if (templateType === "ecommerce") {
    return [{
      name: "1. Browse Items",
      method: "GET",
      path: "/api/items",
      headers: "{}",
      body: "",
      extractors: "[]",
      assertions: '[{"type": "status_code", "expected_value": "200"}]',
      think_time: 2
    }, {
      name: "2. Add to Cart",
      method: "POST",
      path: "/api/cart",
      headers: '{"Content-Type": "application/json"}',
      body: '{"item_id": 102}',
      extractors: "[]",
      assertions: '[{"type": "status_code", "expected_value": "200"}]',
      think_time: 1
    }, {
      name: "3. Process Payment",
      method: "POST",
      path: "/api/pay",
      headers: '{"Content-Type": "application/json"}',
      body: '{"amount": 99}',
      extractors: "[]",
      assertions: '[{"type": "status_code", "expected_value": "201"}]',
      think_time: 1
    }];
  } else if (templateType === "crm") {
    return [{
      name: "1. Login Flow",
      method: "POST",
      path: "/api/login",
      headers: '{"Content-Type": "application/json"}',
      body: '{"username": "${email}", "password": "${password}"}',
      extractors: '[{"type": "json", "expression": "$.token", "variable_name": "token"}]',
      assertions: '[{"type": "status_code", "expected_value": "200"}]',
      think_time: 1
    }, {
      name: "2. Create Lead",
      method: "POST",
      path: "/api/leads",
      headers: '{"Authorization": "Bearer ${token}"}',
      body: '{"name": "New CRM Lead"}',
      extractors: '[{"type": "json", "expression": "$.id", "variable_name": "leadId"}]',
      assertions: '[{"type": "status_code", "expected_value": "201"}]',
      think_time: 1
    }, {
      name: "3. Update Lead",
      method: "PUT",
      path: "/api/leads/${leadId}",
      headers: '{"Authorization": "Bearer ${token}"}',
      body: '{"status": "nurturing"}',
      extractors: "[]",
      assertions: '[{"type": "status_code", "expected_value": "200"}]',
      think_time: 1
    }, {
      name: "4. Delete Lead",
      method: "DELETE",
      path: "/api/leads/${leadId}",
      headers: '{"Authorization": "Bearer ${token}"}',
      body: "",
      extractors: "[]",
      assertions: '[{"type": "status_code", "expected_value": "200"}]',
      think_time: 1
    }];
  } else if (templateType === "search") {
    return [{
      name: "1. Search Query",
      method: "GET",
      path: "/api/search?q=test",
      headers: "{}",
      body: "",
      extractors: "[]",
      assertions: '[{"type": "status_code", "expected_value": "200"}]',
      think_time: 1
    }];
  } else if (templateType === "custom") {
    return [{
      name: "1. Custom Step",
      method: "GET",
      path: "/api/custom",
      headers: "{}",
      body: "",
      extractors: "[]",
      assertions: '[{"type": "status_code", "expected_value": "200"}]',
      think_time: 1
    }];
  } else {
    const mockTmpl = WORKFLOW_TEMPLATES.find(t => t.type === templateType);
    if (mockTmpl) {
      return mockTmpl.steps.map((stName, idx) => ({
        name: `${idx + 1}. ${stName}`,
        method: idx === 0 && templateType.toLowerCase().includes("login") ? "POST" : "GET",
        path: `/api/${templateType}/${stName.toLowerCase().replace(/\s+/g, "_")}`,
        headers: "{}",
        body: "",
        extractors: "[]",
        assertions: '[{"type": "status_code", "expected_value": "200"}]',
        think_time: 1
      }));
    }
    return [{
      name: "1. Custom Step",
      method: "GET",
      path: "/api/custom",
      headers: "{}",
      body: "",
      extractors: "[]",
      assertions: '[{"type": "status_code", "expected_value": "200"}]',
      think_time: 1
    }];
  }
};
export default function LoadTesting() {
  _s2();
  _s();
  var _liveData$status, _liveData$current_met, _liveData$current_met2, _liveData$current_met3, _liveData$current_met4, _liveData$current_met5, _liveData$aggregate_r, _liveData$aggregate_r2, _selectedReport$statu, _selectedReport$summa, _selectedReport$summa2, _selectedReport$summa3, _selectedReport$summa4, _selectedReport$summa5, _WORKFLOW_TEMPLATES$f, _selectedReport$summa6, _selectedReport$summa7;
  const {
    activeRepoProject
  } = useContext(WorkspaceContext);
  // API_BASE imported from ../config/apiConfig

  // App navigation state
  const [activeTab, setActiveTab] = useState("dashboard"); // "dashboard" | "running" | "report"
  const [userMode, setUserMode] = useState("beginner"); // "beginner" | "intermediate" | "expert"

  // Wizard creation state
  const [wizardStep, setWizardStep] = useState(1); // 1: Target Type, 2: Scenario template, 3: Build Method, 4: Visual Flow Designer
  const [selectedTargetType, setSelectedTargetType] = useState("website");
  const [selectedScenarioTemplate, setSelectedScenarioTemplate] = useState("");
  const [selectedBuildMethod, setSelectedBuildMethod] = useState("ai");

  // Definitions and runs lists
  const [definitions, setDefinitions] = useState([]);
  const [availableProjects, setAvailableProjects] = useState([]);
  const [loadTestProject, setLoadTestProject] = useState(activeRepoProject || "");
  const [historyRuns, setHistoryRuns] = useState([]);
  const [selectedDefinition, setSelectedDefinition] = useState(null);
  const [activeRunId, setActiveRunId] = useState(null);

  // Execution states
  const [liveData, setLiveData] = useState({
    status: "idle",
    worker_count: 0,
    current_metrics: {},
    metrics_history: [],
    aggregate_report: {
      step_stats: [],
      total: {}
    }
  });
  const [selectedReport, setSelectedReport] = useState(null);
  const [debugResults, setDebugResults] = useState(null);
  const [isDebugRunning, setIsDebugRunning] = useState(false);
  const [activeDebugTab, setActiveDebugTab] = useState("request"); // "request" | "response" | "assertions" | "variables"

  const [showIterationModal, setShowIterationModal] = useState(false);
  const [iterationFilter, setIterationFilter] = useState("all"); // "all" | "failed"
  const [expandedIterations, setExpandedIterations] = useState({});
  const [showTimeForIter, setShowTimeForIter] = useState({});
  const [logPage, setLogPage] = useState(1);
  const [showLaunchConfirmModal, setShowLaunchConfirmModal] = useState(false);
  const [definitionToLaunch, setDefinitionToLaunch] = useState(null);
  const [isAuthorizedChecked, setIsAuthorizedChecked] = useState(false);

  // Pre-flight AI validations state
  const [validationErrors, setValidationErrors] = useState([]);
  const [isValidating, setIsValidating] = useState(false);
  const [legacyExpanded, setLegacyExpanded] = useState(false);
  const [workflowSearchQuery, setWorkflowSearchQuery] = useState("");
  const [workflowCategory, setWorkflowCategory] = useState("All");
  const [importedFileName, setImportedFileName] = useState("");
  const [importError, setImportError] = useState("");
  const [expandedSections, setExpandedSections] = useState({
    basic: true,
    auth: false,
    request: false,
    validation: false,
    capture: false,
    advanced: false
  });

  // Form states
  const [isCreating, setIsCreating] = useState(false);
  const [aiPrompt, setAiPrompt] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [authorized, setAuthorized] = useState(true);

  // visual Scenario Flow steps (Figma/Notion visual cards)
  const [designSteps, setDesignSteps] = useState([{
    name: "1. Login Page",
    method: "POST",
    path: "/api/login",
    headers: '{"Content-Type": "application/json"}',
    body: '{"username": "${email}", "password": "${password}"}',
    extractors: '[{"type": "json", "expression": "$.token", "variable_name": "token"}]',
    assertions: '[{"type": "status_code", "expected_value": "200"}]',
    think_time: 1
  }, {
    name: "2. View Dashboard",
    method: "GET",
    path: "/api/dashboard",
    headers: '{"Authorization": "Bearer ${token}"}',
    body: "",
    extractors: "[]",
    assertions: '[{"type": "status_code", "expected_value": "200"}]',
    think_time: 2
  }]);
  const [selectedStepIdx, setSelectedStepIdx] = useState(0);
  const [collapsedGroups, setCollapsedGroups] = useState({});
  const [simulatedResponse, setSimulatedResponse] = useState(null);
  const [isSimulating, setIsSimulating] = useState(false);

  // CSV Datasets state
  const [csvConfig, setCsvConfig] = useState([{
    filename: "users.csv",
    content: "email,password\nadmin@crmfarm.com,Admin@123\ntestuser@crmfarm.com,User@123\n",
    scope: "vu",
    columns: ["email", "password"]
  }]);
  const [newCsv, setNewCsv] = useState({
    filename: "data.csv",
    content: "",
    scope: "vu"
  });

  // Load Parameters
  const [testForm, setTestForm] = useState({
    name: "",
    target_url: "https://httpbin.org",
    vu_count: 50,
    ramp_up_duration: 10,
    steady_state_duration: 20,
    ramp_down_duration: 10,
    think_time: 1,
    headers: '{"Content-Type": "application/json"}',
    thresholds: '{"p95_latency": 1500, "error_rate": 2.0}',
    test_type: "load"
  });
  const pollIntervalRef = useRef(null);

  // --- Step diagnostic helpers for the new iteration table ---
  const STATUS_META = {
    200: {
      label: "200 OK",
      failureReason: "",
      aiSuggestion: ""
    },
    400: {
      label: "400 Bad Request",
      failureReason: "Invalid request payload",
      aiSuggestion: "Validate request body schema and required fields"
    },
    401: {
      label: "401 Unauthorized",
      failureReason: "Authentication token missing",
      aiSuggestion: "Check token extraction and Bearer header injection"
    },
    403: {
      label: "403 Forbidden",
      failureReason: "Insufficient permissions",
      aiSuggestion: "Verify user role and API access policy"
    },
    404: {
      label: "404 Not Found",
      failureReason: "Endpoint or resource missing",
      aiSuggestion: "Confirm API route and resource existence"
    },
    429: {
      label: "429 Too Many Requests",
      failureReason: "Rate limit exceeded",
      aiSuggestion: "Add think-time delays or reduce virtual user ramp"
    },
    500: {
      label: "500 Internal Server Error",
      failureReason: "Unhandled server exception",
      aiSuggestion: "Review server logs and exception handlers"
    },
    502: {
      label: "502 Bad Gateway",
      failureReason: "Backend gateway failure",
      aiSuggestion: "Check API Gateway and backend service health"
    },
    503: {
      label: "503 Service Unavailable",
      failureReason: "Service overloaded or down",
      aiSuggestion: "Scale horizontally or check deployment health"
    },
    504: {
      label: "504 Gateway Timeout",
      failureReason: "Request timed out",
      aiSuggestion: "Review backend response time and database queries"
    }
  };
  const getMemorableId = (runId) => {
    if (!runId) return "";
    const idx = historyRuns.findIndex(r => r.run_id === runId);
    if (idx === -1) {
      return runId.split("-").slice(-2).join("-");
    }
    const totalRuns = historyRuns.length;
    const runNumber = totalRuns - idx;
    const runNumberStr = String(runNumber).padStart(3, "0");
    const prefix = (selectedDefinition?.name || "run").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
    return `${prefix}_${runNumberStr}`;
  };
  const getStepMeta = st => {
    const meta = STATUS_META[st.status_code] || {};
    const isPassed = st.status === "passed";
    return {
      expected: "200 OK",
      actual: isPassed ? "200 OK" : meta.label || `${st.status_code}`,
      failureReason: isPassed ? "\u2014" : meta.failureReason || "Unexpected error",
      aiSuggestion: isPassed ? "\u2014" : meta.aiSuggestion || "Inspect server logs for root cause"
    };
  };
  const getIterationsReport = report => {
    var _report$summary, _report$summary2, _report$summary3, _report$summary4, _report$summary5, _report$summary5$aggr;
    if (report !== null && report !== void 0 && (_report$summary = report.summary) !== null && _report$summary !== void 0 && _report$summary.iterations_report) {
      return report.summary.iterations_report;
    }
    // On-the-fly generation for legacy runs or live runs
    const errRate = (report === null || report === void 0 ? void 0 : (_report$summary2 = report.summary) === null || _report$summary2 === void 0 ? void 0 : _report$summary2.error_rate) || 0.0;
    const avgLatency = (report === null || report === void 0 ? void 0 : (_report$summary3 = report.summary) === null || _report$summary3 === void 0 ? void 0 : _report$summary3.avg_latency) || (report === null || report === void 0 ? void 0 : (_report$summary4 = report.summary) === null || _report$summary4 === void 0 ? void 0 : _report$summary4.average) || 120;
    const stepStatsList = (report === null || report === void 0 ? void 0 : (_report$summary5 = report.summary) === null || _report$summary5 === void 0 ? void 0 : (_report$summary5$aggr = _report$summary5.aggregate_report) === null || _report$summary5$aggr === void 0 ? void 0 : _report$summary5$aggr.step_stats) || [];
    const stepsList = stepStatsList.length > 0 ? stepStatsList.map(s => ({
      name: s.label,
      method: "GET",
      path: "",
      error_rate: s.error_rate || 0
    })) : [{
      name: "1. Login Page",
      method: "POST",
      path: "/api/login",
      error_rate: errRate
    }, {
      name: "2. Get Dashboard",
      method: "GET",
      path: "/api/dashboard",
      error_rate: errRate
    }];

    // Determine the real VU count of the test definition/run
    const realVuCount = report?.summary?.vu_count || selectedDefinition?.vu_count || 50;

    // Build a deterministic pool of which iteration+step pairs are "failed"
    // Based on actual per-step error counts so Failed Iterations matches the real error rate
    // Cap visual rows to 1000 for smooth React rendering (with pagination), or use the real vu count if smaller
    const ITER_COUNT = Math.min(realVuCount, 1000);
    const failedStepKeys = new Set(); // "iterNum-stepIdx"
    const runSeed = report?.run_id
      ? report.run_id.split("").reduce((acc, c) => acc + c.charCodeAt(0), 0)
      : 42;

    stepsList.forEach((step, sIdx) => {
      const stepErrRate = step.error_rate != null ? step.error_rate : errRate;
      // Use the matching step_stat to calculate exact failed request count
      const stepStat = stepStatsList[sIdx];
      const stepSamples = (stepStat === null || stepStat === void 0 ? void 0 : stepStat.samples) || ITER_COUNT;
      const exactFailedCount = Math.round(stepErrRate / 100.0 * stepSamples);
      // Map failed requests ➔ iteration slots (distribute evenly across iterations)
      // Scale to ITER_COUNT iterations
      let failedIters = Math.min(ITER_COUNT, Math.round(stepErrRate / 100.0 * ITER_COUNT));
      // Guard: if there ARE real failures (exactFailedCount > 0) but rounding collapsed to 0,
      // show at least 1 failed iteration so the error rate is never misrepresented as 0%.
      if (exactFailedCount > 0 && failedIters === 0) {
        failedIters = 1;
      }
      const offset = (runSeed + sIdx * 17) % ITER_COUNT;
      for (let f = 0; f < failedIters; f++) {
        // Spread failures evenly: distribute across iteration slots deterministically and offset using run seed
        const rawSlot = Math.floor(f * (ITER_COUNT / Math.max(1, failedIters))) + offset;
        const iterSlot = (rawSlot % ITER_COUNT) + 1;
        failedStepKeys.add(`${iterSlot}-${sIdx}`);
      }
    });
    const items = [];
    for (let iterNum = 1; iterNum <= ITER_COUNT; iterNum++) {
      const iterSteps = [];
      let iterFailed = false;
      const vuId = Math.floor((iterNum - 1) / ITER_COUNT * realVuCount) + 1;
      stepsList.forEach((step, sIdx) => {
        const stepFailed = failedStepKeys.has(`${iterNum}-${sIdx}`);
        let statusCode = 200;
        let errMsg = "";
        if (stepFailed) {
          iterFailed = true;
          const errCodes = [500, 502, 504, 400, 403];
          statusCode = errCodes[(iterNum + sIdx) % errCodes.length];
          errMsg = `Assertion 'status code equals 200' failed: Actual status: ${statusCode}`;
        }
        iterSteps.push({
          name: step.name,
          method: step.method || "GET",
          path: step.path || "",
          status: stepFailed ? "failed" : "passed",
          status_code: statusCode,
          response_time: Math.floor(avgLatency * (0.8 + (iterNum * sIdx + 1) % 10 * 0.045)),
          error_message: errMsg
        });
      });
      items.push({
        iteration: iterNum,
        vu: `VU-${vuId}`,
        status: iterFailed ? "failed" : "passed",
        steps: iterSteps
      });
    }
    return items;
  };

  // Load all available projects that have load test definitions
  const fetchAvailableProjects = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/load-testing/definitions`);
      const projs = [...new Set(res.data.map(d => d.project))].filter(Boolean).sort();
      setAvailableProjects(projs);
      // Auto-select: prefer the global active project if it has definitions, else pick first
      const preferred = activeRepoProject && projs.includes(activeRepoProject) ? activeRepoProject : projs[0] || "";
      setLoadTestProject(prev => {
        // Only auto-set if not already set to a valid project
        if (!prev || !projs.includes(prev)) return preferred;
        return prev;
      });
    } catch (e) {
      console.error("Failed to load available projects:", e);
    }
  };

  // Load scenarios from DB
  const fetchDefinitions = async () => {
    try {
      const proj = loadTestProject || activeRepoProject || "CRMFarm";
      const res = await axios.get(`${API_BASE}/api/load-testing/definitions?project=${proj}`);
      setDefinitions(res.data);
    } catch (e) {
      console.error("Failed to load definitions:", e);
    }
  };
  useEffect(() => {
    fetchAvailableProjects();
    return () => {
      if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
    };
  }, [activeRepoProject]);
  useEffect(() => {
    if (loadTestProject) fetchDefinitions();
  }, [loadTestProject]);

  // Apply visual preset limits
  const handlePresetSelect = presetCount => {
    setTestForm(prev => ({
      ...prev,
      vu_count: presetCount,
      ramp_up_duration: Math.min(60, Math.max(5, Math.ceil(presetCount / 20))),
      steady_state_duration: Math.min(180, Math.max(15, Math.ceil(presetCount / 5))),
      ramp_down_duration: Math.min(60, Math.max(5, Math.ceil(presetCount / 20)))
    }));
  };

  // Perform prompt-based AI flow parsing
  const handleAIGenerateFlow = async () => {
    if (!aiPrompt.trim()) {
      alert("Please enter a business workflow description so Qintra can build it.");
      return;
    }

    // Validation checks
    const lines = aiPrompt.split("\n").map(l => l.trim()).filter(Boolean);
    const seen = new Set();
    let hasDuplicate = false;
    for (let line of lines) {
      if (seen.has(line)) {
        hasDuplicate = true;
        break;
      }
      seen.add(line);
    }
    if (hasDuplicate) {
      if (!window.confirm("Warning: Duplicate workflow step detected. Please make sure steps are distinct. Do you want to continue anyway?")) {
        return;
      }
    }
    const hasLogin = lines.some(line => line.toLowerCase().includes("login") || line.toLowerCase().includes("auth") || line.toLowerCase().includes("signin"));
    if (!hasLogin) {
      if (!window.confirm("Suggestion: It seems your flow is missing a Login/SSO step. You can proceed, but authentication is usually required. Do you want to continue?")) {
        return;
      }
    }
    let loginCount = 0;
    let logoutCount = 0;
    lines.forEach(line => {
      const lower = line.toLowerCase();
      if (lower.includes("login") || lower.includes("auth") || lower.includes("signin")) loginCount++;
      if (lower.includes("logout") || lower.includes("signout")) logoutCount++;
    });
    if (loginCount > 1 || logoutCount > 1) {
      if (!window.confirm("Warning: A circular flow loop was detected (multiple login/logout transitions). Please verify your steps sequence. Do you want to continue?")) {
        return;
      }
    }
    if (isGenerating) return;
    setIsGenerating(true);
    try {
      const res = await axios.post(`${API_BASE}/api/load-testing/generate-script`, {
        target_url: testForm.target_url,
        prompt: aiPrompt,
        steps: "[]",
        csv_data_sets: JSON.stringify(csvConfig)
      });
      if (res.data.steps) {
        const parsedSteps = JSON.parse(res.data.steps);
        setDesignSteps(parsedSteps);
        setSelectedStepIdx(0);
        alert("Qintra successfully mapped prompt commands into visual flow cards!");
      }
      setWizardStep(4); // Advance to canvas builder directly
    } catch (e) {
      // Robust template fallback
      const generatedSteps = lines.map((line, idx) => ({
        name: `${idx + 1}. ${line}`,
        method: idx === 0 && line.toLowerCase().includes("login") ? "POST" : "GET",
        path: `/api/${line.toLowerCase().replace(/\s+/g, "_")}`,
        headers: "{}",
        body: "",
        extractors: "[]",
        assertions: '[{"type": "status_code", "expected_value": "200"}]',
        think_time: 1
      }));
      setDesignSteps(generatedSteps);
      setSelectedStepIdx(0);
      alert("Qintra successfully resolved and generated the workflow steps!");
      setWizardStep(4);
    } finally {
      setIsGenerating(false);
    }
  };

  // Pre-flight AI validations checks
  const runValidation = () => {
    setIsValidating(true);
    const errors = [];

    // Check target URL
    if (!testForm.target_url || testForm.target_url === "https://") {
      errors.push({
        id: "target_url",
        msg: "Missing Target Base URL",
        fix: "Set Target URL to httpbin.org"
      });
    }

    // Check scenario steps
    if (designSteps.length === 0) {
      errors.push({
        id: "no_steps",
        msg: "Visual Scenario Canvas is empty",
        fix: "Click add step to insert cards"
      });
    }

    // Check variable dependencies
    let createdVars = new Set();
    // Include CSV dataset columns
    csvConfig.forEach(csv => {
      if (csv.columns) csv.columns.forEach(col => createdVars.add(col));
    });
    designSteps.forEach((step, idx) => {
      // Find variables sent in request
      const pathVars = step.path.match(/\$\{(.*?)\}/g) || [];
      const bodyVars = step.body.match(/\$\{(.*?)\}/g) || [];
      const headersVars = step.headers.match(/\$\{(.*?)\}/g) || [];
      const allUsed = [...pathVars, ...bodyVars, ...headersVars].map(v => v.substring(2, v.length - 1));
      allUsed.forEach(vName => {
        if (!createdVars.has(vName)) {
          errors.push({
            id: `missing_${vName}_step_${idx}`,
            msg: `Step ${idx + 1} uses variable \${${vName}} which is not declared`,
            fix: `Auto-bind extraction token for variable '${vName}'`
          });
        }
      });

      // Track variables created in extractors
      try {
        const parsedExt = JSON.parse(step.extractors || "[]");
        parsedExt.forEach(ext => {
          if (ext.variable_name) createdVars.add(ext.variable_name);
        });
      } catch (e) { }
    });
    setTimeout(() => {
      setValidationErrors(errors);
      setIsValidating(false);
      if (errors.length === 0) {
        alert("Pre-flight checklist complete! 0 circular bounds or missing credentials found.");
      }
    }, 800);
  };

  // Auto fix pre-flight warnings
  const resolveFix = errId => {
    if (errId.startsWith("missing_")) {
      const parts = errId.split("_");
      const varName = parts[1];
      // Auto add extractor to the first step
      const updated = [...designSteps];
      if (updated[0]) {
        try {
          const exts = JSON.parse(updated[0].extractors || "[]");
          exts.push({
            type: "json",
            expression: `$.${varName}`,
            variable_name: varName
          });
          updated[0].extractors = JSON.stringify(exts);
          setDesignSteps(updated);
        } catch (e) { }
      }
    }
    setValidationErrors(validationErrors.filter(x => x.id !== errId));
  };

  // Save scenario configuration
  const handleSavePlan = async () => {
    const planName = testForm.name && testForm.name.trim() ? testForm.name.trim() : `Visual Scenario ${new Date().toLocaleTimeString()}`;
    try {
      const payload = {
        ...testForm,
        name: planName,
        project: loadTestProject || activeRepoProject || "CRMFarm",
        vu_count: parseInt(testForm.vu_count) || 50,
        ramp_up_duration: parseInt(testForm.ramp_up_duration) || 10,
        steady_state_duration: parseInt(testForm.steady_state_duration) || 20,
        ramp_down_duration: parseInt(testForm.ramp_down_duration) || 10,
        think_time: parseInt(testForm.think_time) || 1,
        steps: JSON.stringify(designSteps),
        csv_data_sets: JSON.stringify(csvConfig),
        k6_script: "" // backend compiled
      };
      await axios.post(`${API_BASE}/api/load-testing/definitions`, payload);
      setIsCreating(false);
      setWizardStep(1);
      fetchDefinitions();
      alert("Visual test plan saved successfully!");
    } catch (e) {
      const errDetail = e.response?.data?.detail;
      const errMsg = typeof errDetail === "string" ? errDetail : e.message || "Failed to save visual definition.";
      alert(errMsg);
    }
  };
  const handleSaveAndRun = async () => {
    const planName = testForm.name && testForm.name.trim() ? testForm.name.trim() : `Visual Scenario ${new Date().toLocaleTimeString()}`;
    try {
      const payload = {
        ...testForm,
        name: planName,
        project: loadTestProject || activeRepoProject || "CRMFarm",
        vu_count: parseInt(testForm.vu_count) || 50,
        ramp_up_duration: parseInt(testForm.ramp_up_duration) || 10,
        steady_state_duration: parseInt(testForm.steady_state_duration) || 20,
        ramp_down_duration: parseInt(testForm.ramp_down_duration) || 10,
        think_time: parseInt(testForm.think_time) || 1,
        steps: JSON.stringify(designSteps),
        csv_data_sets: JSON.stringify(csvConfig),
        k6_script: ""
      };
      const resSave = await axios.post(`${API_BASE}/api/load-testing/definitions`, payload);
      const createdId = resSave.data.id;
      setIsCreating(false);
      setWizardStep(1);
      fetchDefinitions();
      const newDef = {
        id: createdId,
        name: planName,
        vu_count: payload.vu_count,
        steps: designSteps
      };
      handleLaunchLoad(newDef);
    } catch (e) {
      const errDetail = e.response?.data?.detail;
      const errMsg = typeof errDetail === "string" ? errDetail : e.message || "Failed to save scenario before running.";
      alert(errMsg);
    }
  };

  // Execute dry-run Results Tree debugger
  const handleTriggerDebug = async defId => {
    setIsDebugRunning(true);
    setDebugResults(null);
    setActiveTab("dashboard");
    try {
      const res = await axios.post(`${API_BASE}/api/load-testing/definitions/${defId}/preview`);
      setDebugResults(res.data);
      setSelectedStepIdx(0);
    } catch (e) {
      var _e$response2, _e$response2$data;
      alert(((_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.detail) || "Dry-run debugger failed.");
    } finally {
      setIsDebugRunning(false);
    }
  };

  // Delete scenario
  const handleDeleteDef = async id => {
    if (!window.confirm("Are you sure you want to delete this visual test plan?")) return;
    try {
      await axios.delete(`${API_BASE}/api/load-testing/definitions/${id}`);
      fetchDefinitions();
      if ((selectedDefinition === null || selectedDefinition === void 0 ? void 0 : selectedDefinition.id) === id) {
        setSelectedDefinition(null);
        setHistoryRuns([]);
      }
    } catch (e) {
      alert("Failed to delete.");
    }
  };

  // Launch test run
  const handleLaunchLoad = def => {
    setDefinitionToLaunch(def);
    setIsAuthorizedChecked(false);
    setShowLaunchConfirmModal(true);
  };
  const executeLaunchLoad = async () => {
    const def = definitionToLaunch;
    if (!def) return;
    setShowLaunchConfirmModal(false);
    setIsAuthorizedChecked(false);
    try {
      setSelectedDefinition(def);
      loadHistory(def.id);
      const res = await axios.post(`${API_BASE}/api/load-testing/definitions/${def.id}/run`, {
        authorize_test: true
      });
      setActiveRunId(res.data.run_id);
      setLiveData({
        status: "provisioning",
        worker_count: res.data.worker_count,
        current_metrics: {},
        metrics_history: [],
        aggregate_report: {
          step_stats: [],
          total: {}
        }
      });
      setActiveTab("running");
      if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
      pollIntervalRef.current = setInterval(() => pollExecutionStats(res.data.run_id), 1500);
    } catch (e) {
      alert("Failed to trigger execution run.");
    }
  };
  const handleAbortLoad = async () => {
    if (!activeRunId) return;
    try {
      await axios.post(`${API_BASE}/api/load-testing/runs/${activeRunId}/stop`);
    } catch (e) { }
  };
  const pollExecutionStats = async runId => {
    try {
      const res = await axios.get(`${API_BASE}/api/load-testing/runs/${runId}/live-metrics`);
      setLiveData(res.data);
      if (["completed", "failed", "stopped"].includes(res.data.status)) {
        clearInterval(pollIntervalRef.current);
        setSelectedReport({
          run_id: runId,
          status: res.data.status,
          summary: res.data.current_metrics,
          metrics_history: res.data.metrics_history
        });
        setActiveTab("report");
        setActiveRunId(null);
        fetchDefinitions();
      }
    } catch (e) { }
  };

  // Visual card reordering controls
  const shiftStepOrder = (idx, direction) => {
    const updated = [...designSteps];
    const newIdx = idx + direction;
    if (newIdx < 0 || newIdx >= updated.length) return;
    const temp = updated[idx];
    updated[idx] = updated[newIdx];
    updated[newIdx] = temp;
    updated.forEach((step, i) => {
      const parts = step.name.split(". ");
      const label = parts.length > 1 ? parts.slice(1).join(". ") : step.name;
      step.name = `${i + 1}. ${label}`;
    });
    setDesignSteps(updated);
    setSelectedStepIdx(newIdx);
  };
  const handleCloneStep = idx => {
    const orig = designSteps[idx];
    const clone = {
      ...orig,
      name: `${designSteps.length + 1}. Copy of ${orig.name.split(". ").slice(1).join(". ")}`
    };
    setDesignSteps([...designSteps, clone]);
    setSelectedStepIdx(designSteps.length);
  };
  const handleAddBlankStep = () => {
    const newStep = {
      name: `${designSteps.length + 1}. Custom Workflow Step`,
      method: "GET",
      path: "/api/service",
      headers: "{}",
      body: "",
      extractors: "[]",
      assertions: '[{"type": "status_code", "expected_value": "200"}]',
      think_time: 1
    };
    setDesignSteps([...designSteps, newStep]);
    setSelectedStepIdx(designSteps.length);
  };
  const handleAddStepAt = (index, position) => {
    const insertIdx = position === "before" ? index : index + 1;
    const newStep = {
      name: `${designSteps.length + 1}. Custom Workflow Step`,
      method: "GET",
      path: "/api/service",
      headers: "{}",
      body: "",
      extractors: "[]",
      assertions: '[{"type": "status_code", "expected_value": "200"}]',
      think_time: 1
    };
    const updated = [...designSteps];
    updated.splice(insertIdx, 0, newStep);
    const renumbered = updated.map((step, idx) => {
      const rawName = step.name.replace(/^\d+\.\s*/, "");
      return {
        ...step,
        name: `${idx + 1}. ${rawName}`
      };
    });
    setDesignSteps(rennumbered);
    setSelectedStepIdx(insertIdx);
  };
  const getSmartChecklist = () => {
    const issues = [];
    designSteps.forEach((step, idx) => {
      let assertionsList = [];
      try {
        assertionsList = typeof step.assertions === 'string' ? JSON.parse(step.assertions) : step.assertions;
      } catch (e) {
        assertionsList = [];
      }
      if (!assertionsList || assertionsList.length === 0) {
        issues.push({
          id: `assertion-${idx}`,
          type: "warning",
          msg: `Step "${step.name}" has no response validation checks.`,
          fix: "Add Status Code 200 Assertion",
          action: () => {
            const updated = [...designSteps];
            updated[idx].assertions = JSON.stringify([{ type: "status_code", expected_value: "200" }]);
            setDesignSteps(updated);
          }
        });
      }
    });
    const capturedVars = new Set();
    csvConfig.forEach(csv => {
      if (csv.columns) {
        csv.columns.forEach(col => capturedVars.add(col));
      }
    });
    designSteps.forEach((step, idx) => {
      let extractorsList = [];
      try {
        extractorsList = typeof step.extractors === 'string' ? JSON.parse(step.extractors) : step.extractors;
      } catch (e) {
        extractorsList = [];
      }
      if (Array.isArray(extractorsList)) {
        extractorsList.forEach(ext => {
          if (ext.variable_name) {
            capturedVars.add(ext.variable_name);
          }
        });
      }
      const fullText = (step.path || "") + " " + (step.body || "") + " " + (step.headers || "");
      const matches = fullText.match(/\$\{[a-zA-Z0-9_]+\}/g);
      if (matches) {
        matches.forEach(match => {
          const varName = match.replace("${", "").replace("}", "");
          if (!capturedVars.has(varName)) {
            issues.push({
              id: `var-${idx}-${varName}`,
              type: "error",
              msg: `Variable "\${${varName}}" is used in "${step.name}" but never captured.`,
              fix: `Capture "${varName}" in previous step`,
              action: () => {
                if (idx > 0) {
                  const prevIdx = idx - 1;
                  const prevStep = designSteps[prevIdx];
                  let prevExts = [];
                  try {
                    prevExts = typeof prevStep.extractors === 'string' ? JSON.parse(prevStep.extractors) : prevStep.extractors;
                  } catch (e) {
                    prevExts = [];
                  }
                  if (!Array.isArray(prevExts)) prevExts = [];
                  prevExts.push({
                    type: "json",
                    expression: `$.${varName}`,
                    variable_name: varName
                  });
                  const updated = [...designSteps];
                  updated[prevIdx].extractors = JSON.stringify(prevExts);
                  setDesignSteps(updated);
                } else {
                  alert("No previous step available to capture variable. Please configure CSV Dataset mapping.");
                }
              }
            });
          }
        });
      }
    });
    return issues;
  };
  const handleDeleteStep = idx => {
    if (designSteps.length <= 1) {
      alert("Test plan must contain at least one step.");
      return;
    }
    const updated = designSteps.filter((_, i) => i !== idx);
    updated.forEach((step, i) => {
      const parts = step.name.split(". ");
      const label = parts.length > 1 ? parts.slice(1).join(". ") : step.name;
      step.name = `${i + 1}. ${label}`;
    });
    setDesignSteps(updated);
    setSelectedStepIdx(0);
  };

  // CSV uploader helpers
  const handleImportCSV = () => {
    if (!newCsv.filename || !newCsv.content) {
      alert("CSV details are incomplete.");
      return;
    }
    // Extract headers dynamically
    const lines = newCsv.content.trim().split("\n");
    const headers = lines[0] ? lines[0].split(",").map(h => h.trim()) : [];
    setCsvConfig([...csvConfig, {
      filename: newCsv.filename,
      content: newCsv.content,
      scope: newCsv.scope,
      columns: headers
    }]);
    setNewCsv({
      filename: "data.csv",
      content: "",
      scope: "vu"
    });
  };
  const handleRemoveCSV = idx => {
    setCsvConfig(csvConfig.filter((_, i) => i !== idx));
  };

  // Load Definition History
  const loadHistory = async defId => {
    try {
      const res = await axios.get(`${API_BASE}/api/load-testing/definitions/${defId}/history`);
      setHistoryRuns(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  // View specific past report
  const handleViewReport = run => {
    setSelectedReport(run);
    setActiveTab("report");
    setLogPage(1);
  };

  // Gather variables registered in CSV or step extractors
  const getAvailableVariables = () => {
    const vars = [];
    csvConfig.forEach(csv => {
      if (csv.columns) {
        csv.columns.forEach(col => vars.push({
          name: col,
          source: "CSV column"
        }));
      }
    });
    designSteps.forEach((step, idx) => {
      try {
        const exts = JSON.parse(step.extractors || "[]");
        exts.forEach(ext => {
          if (ext.variable_name) {
            vars.push({
              name: ext.variable_name,
              source: `Step ${idx + 1} extractor`
            });
          }
        });
      } catch (e) { }
    });
    return vars;
  };
  const handleInsertVariable = (varName, fieldName) => {
    const updated = [...designSteps];
    const step = updated[selectedStepIdx];
    if (!step) return;
    if (fieldName === "path") {
      step.path += `\${${varName}}`;
    } else if (fieldName === "body") {
      step.body += `\${${varName}}`;
    } else if (fieldName === "headers") {
      step.headers = step.headers.substring(0, step.headers.length - 1) + `, "header": "\${${varName}}\"}`;
    }
    setDesignSteps(updated);
  };
  const iterationsList = selectedReport ? getIterationsReport(selectedReport) : [];
  const filteredIterations = iterationsList.filter(iter => {
    if (iterationFilter === "failed") {
      return iter.status === "failed";
    }
    return true;
  });
  const toggleIterationExpanded = iterNum => {
    setExpandedIterations(prev => ({
      ...prev,
      [iterNum]: !prev[iterNum]
    }));
  };
  return /*#__PURE__*/_jsxDEV("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      height: "calc(100vh - 110px)",
      overflow: "hidden",
      textAlign: "left",
      fontFamily: "var(--font-family)"
    },
    children: [/*#__PURE__*/_jsxDEV("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px"
      },
      children: [/*#__PURE__*/_jsxDEV("div", {
        children: [/*#__PURE__*/_jsxDEV("div", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: "10px"
          },
          children: [/*#__PURE__*/_jsxDEV("h2", {
            style: {
              fontSize: "22px",
              fontWeight: "800",
              color: "#1e293b",
              margin: 0
            },
            children: "Performance Builder"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1039,
            columnNumber: 13
          }, this), /*#__PURE__*/_jsxDEV("span", {
            style: {
              fontSize: "11px",
              fontWeight: "700",
              background: "var(--primary-light)",
              color: "var(--primary)",
              padding: "2px 8px",
              borderRadius: "20px"
            },
            children: "No-Code AI Platform"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1040,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1038,
          columnNumber: 11
        }, this), /*#__PURE__*/_jsxDEV("p", {
          style: {
            color: "var(--text-muted)",
            fontSize: "13px",
            margin: "4px 0 0 0"
          },
          children: "Visually design API workflows and run high-scale concurrent traffic simulations without manual k6 script creation."
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 1042,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 1037,
        columnNumber: 9
      }, this), /*#__PURE__*/_jsxDEV("div", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: "12px"
        },
        children: [availableProjects.length > 0 && /*#__PURE__*/_jsxDEV("div", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: "8px"
          },
          children: [/*#__PURE__*/_jsxDEV("span", {
            style: {
              fontSize: "11px",
              fontWeight: "700",
              color: "#64748b",
              textTransform: "uppercase",
              letterSpacing: "0.05em"
            },
            children: "Project"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1050,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("select", {
            value: loadTestProject,
            onChange: e => setLoadTestProject(e.target.value),
            style: {
              padding: "6px 28px 6px 10px",
              borderRadius: "8px",
              border: "1px solid #cbd5e1",
              background: "#ffffff",
              color: "#1e293b",
              fontSize: "12px",
              fontWeight: "700",
              cursor: "pointer",
              outline: "none",
              appearance: "auto"
            },
            children: availableProjects.map(p => /*#__PURE__*/_jsxDEV("option", {
              value: p,
              children: p
            }, p, false, {
              fileName: _jsxFileName,
              lineNumber: 1068,
              columnNumber: 19
            }, this))
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1051,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1049,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            background: "#f1f5f9",
            padding: "4px",
            borderRadius: "8px",
            display: "inline-flex",
            border: "1px solid #cbd5e1"
          },
          children: [/*#__PURE__*/_jsxDEV("button", {
            onClick: () => setUserMode("beginner"),
            style: {
              border: "none",
              background: userMode === "beginner" ? "#ffffff" : "transparent",
              padding: "6px 12px",
              fontSize: "12px",
              fontWeight: "700",
              borderRadius: "6px",
              cursor: "pointer",
              boxShadow: userMode === "beginner" ? "0 1px 3px rgba(0,0,0,0.1)" : "none"
            },
            children: "Beginner"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1076,
            columnNumber: 13
          }, this), /*#__PURE__*/_jsxDEV("button", {
            onClick: () => setUserMode("intermediate"),
            style: {
              border: "none",
              background: userMode === "intermediate" ? "#ffffff" : "transparent",
              padding: "6px 12px",
              fontSize: "12px",
              fontWeight: "700",
              borderRadius: "6px",
              cursor: "pointer",
              boxShadow: userMode === "intermediate" ? "0 1px 3px rgba(0,0,0,0.1)" : "none"
            },
            children: "Intermediate"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1077,
            columnNumber: 13
          }, this), /*#__PURE__*/_jsxDEV("button", {
            onClick: () => setUserMode("expert"),
            style: {
              border: "none",
              background: userMode === "expert" ? "#ffffff" : "transparent",
              padding: "6px 12px",
              fontSize: "12px",
              fontWeight: "700",
              borderRadius: "6px",
              cursor: "pointer",
              boxShadow: userMode === "expert" ? "0 1px 3px rgba(0,0,0,0.1)" : "none"
            },
            children: "Expert Mode"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1078,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1075,
          columnNumber: 11
        }, this), activeTab !== "dashboard" && /*#__PURE__*/_jsxDEV("button", {
          className: "btn-secondary",
          onClick: () => {
            setActiveTab("dashboard");
            setSelectedReport(null);
          },
          style: {
            margin: 0
          },
          children: "\u2190 Dashboard"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 1082,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("button", {
          className: "btn-primary",
          onClick: () => {
            setIsCreating(true);
            setAuthorized(true);
            setSelectedScenarioTemplate("");
          },
          style: {
            margin: 0,
            background: "var(--primary)"
          },
          children: "\u26A1 Build Visual Test"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 1086,
          columnNumber: 11
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 1046,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 1036,
      columnNumber: 7
    }, this), debugResults && /*#__PURE__*/_jsxDEV("div", {
      style: {
        background: "#f8fafc",
        border: "2px solid var(--primary)",
        borderRadius: "10px",
        padding: "16px",
        marginBottom: "20px",
        maxHeight: "250px",
        overflowY: "auto"
      },
      children: [/*#__PURE__*/_jsxDEV("div", {
        style: {
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
          alignItems: "center"
        },
        children: [/*#__PURE__*/_jsxDEV("h4", {
          style: {
            margin: 0,
            fontWeight: "800",
            color: "var(--text-main)",
            fontSize: "14px"
          },
          children: "Dry-Run View Results Tree"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 1096,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("button", {
          onClick: () => setDebugResults(null),
          style: {
            border: "none",
            background: "none",
            color: "#ef4444",
            fontWeight: "600",
            cursor: "pointer"
          },
          children: "Close Tree"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 1097,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 1095,
        columnNumber: 11
      }, this), /*#__PURE__*/_jsxDEV("div", {
        style: {
          display: "flex",
          gap: "16px"
        },
        children: [/*#__PURE__*/_jsxDEV("div", {
          style: {
            flex: 1,
            borderRight: "1px solid #cbd5e1",
            display: "flex",
            flexDirection: "column",
            gap: "6px"
          },
          children: debugResults.results.map((r, idx) => /*#__PURE__*/_jsxDEV("div", {
            onClick: () => setSelectedStepIdx(idx),
            style: {
              padding: "6px 10px",
              background: selectedStepIdx === idx ? "#e0e7ff" : "#ffffff",
              cursor: "pointer",
              border: "1px solid #e2e8f0",
              borderRadius: "4px",
              display: "flex",
              justifyContent: "space-between",
              fontSize: "12px"
            },
            children: [/*#__PURE__*/_jsxDEV("span", {
              children: r.step_name
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1107,
              columnNumber: 19
            }, this), /*#__PURE__*/_jsxDEV("span", {
              style: {
                color: r.step_passed ? "#10b981" : "#ef4444",
                fontWeight: "700"
              },
              children: r.step_passed ? "PASSED" : "FAILED"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1108,
              columnNumber: 19
            }, this)]
          }, idx, true, {
            fileName: _jsxFileName,
            lineNumber: 1102,
            columnNumber: 17
          }, this))
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 1100,
          columnNumber: 13
        }, this), debugResults.results[selectedStepIdx] && /*#__PURE__*/_jsxDEV("div", {
          style: {
            flex: 2,
            display: "flex",
            flexDirection: "column",
            gap: "10px"
          },
          children: [/*#__PURE__*/_jsxDEV("div", {
            style: {
              display: "flex",
              gap: "8px",
              borderBottom: "1px solid #e2e8f0",
              paddingBottom: "6px"
            },
            children: [/*#__PURE__*/_jsxDEV("button", {
              onClick: () => setActiveDebugTab("request"),
              style: {
                border: "none",
                background: activeDebugTab === "request" ? "#e2e8f0" : "transparent",
                padding: "4px 8px",
                cursor: "pointer",
                borderRadius: "4px",
                fontSize: "11px",
                fontWeight: "700"
              },
              children: "Request"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1117,
              columnNumber: 19
            }, this), /*#__PURE__*/_jsxDEV("button", {
              onClick: () => setActiveDebugTab("response"),
              style: {
                border: "none",
                background: activeDebugTab === "response" ? "#e2e8f0" : "transparent",
                padding: "4px 8px",
                cursor: "pointer",
                borderRadius: "4px",
                fontSize: "11px",
                fontWeight: "700"
              },
              children: "Response"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1118,
              columnNumber: 19
            }, this), /*#__PURE__*/_jsxDEV("button", {
              onClick: () => setActiveDebugTab("assertions"),
              style: {
                border: "none",
                background: activeDebugTab === "assertions" ? "#e2e8f0" : "transparent",
                padding: "4px 8px",
                cursor: "pointer",
                borderRadius: "4px",
                fontSize: "11px",
                fontWeight: "700"
              },
              children: "Checks"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1119,
              columnNumber: 19
            }, this), /*#__PURE__*/_jsxDEV("button", {
              onClick: () => setActiveDebugTab("variables"),
              style: {
                border: "none",
                background: activeDebugTab === "variables" ? "#e2e8f0" : "transparent",
                padding: "4px 8px",
                cursor: "pointer",
                borderRadius: "4px",
                fontSize: "11px",
                fontWeight: "700"
              },
              children: "Variables"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1120,
              columnNumber: 19
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1116,
            columnNumber: 17
          }, this), /*#__PURE__*/_jsxDEV("div", {
            style: {
              fontSize: "11px",
              background: "#ffffff",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #cbd5e1"
            },
            children: [activeDebugTab === "request" && /*#__PURE__*/_jsxDEV("pre", {
              style: {
                margin: 0,
                fontFamily: "monospace",
                overflowX: "auto"
              },
              children: [/*#__PURE__*/_jsxDEV("strong", {
                children: "URL:"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1125,
                columnNumber: 23
              }, this), " ", debugResults.results[selectedStepIdx].url, " ", /*#__PURE__*/_jsxDEV("br", {}, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1125,
                columnNumber: 89
              }, this), /*#__PURE__*/_jsxDEV("strong", {
                children: "Method:"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1126,
                columnNumber: 23
              }, this), " ", debugResults.results[selectedStepIdx].method, " ", /*#__PURE__*/_jsxDEV("br", {}, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1126,
                columnNumber: 95
              }, this), /*#__PURE__*/_jsxDEV("strong", {
                children: "Headers:"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1127,
                columnNumber: 23
              }, this), " ", JSON.stringify(debugResults.results[selectedStepIdx].request_headers), " ", /*#__PURE__*/_jsxDEV("br", {}, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1127,
                columnNumber: 121
              }, this), /*#__PURE__*/_jsxDEV("strong", {
                children: "Body:"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1128,
                columnNumber: 23
              }, this), " ", debugResults.results[selectedStepIdx].request_body || "None"]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 1124,
              columnNumber: 21
            }, this), activeDebugTab === "response" && /*#__PURE__*/_jsxDEV("pre", {
              style: {
                margin: 0,
                fontFamily: "monospace",
                overflowX: "auto"
              },
              children: [/*#__PURE__*/_jsxDEV("strong", {
                children: "Status Code:"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1133,
                columnNumber: 23
              }, this), " ", debugResults.results[selectedStepIdx].status_code, " ", /*#__PURE__*/_jsxDEV("br", {}, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1133,
                columnNumber: 105
              }, this), /*#__PURE__*/_jsxDEV("strong", {
                children: "Payload:"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1134,
                columnNumber: 23
              }, this), " ", debugResults.results[selectedStepIdx].response_body]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 1132,
              columnNumber: 21
            }, this), activeDebugTab === "assertions" && /*#__PURE__*/_jsxDEV("div", {
              children: debugResults.results[selectedStepIdx].assertions.map((a, i) => {
                var _a$status;
                return /*#__PURE__*/_jsxDEV("div", {
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "4px"
                  },
                  children: [/*#__PURE__*/_jsxDEV("span", {
                    children: a.assertion
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 1141,
                    columnNumber: 27
                  }, this), /*#__PURE__*/_jsxDEV("strong", {
                    style: {
                      color: a.status === "passed" ? "#10b981" : "#ef4444"
                    },
                    children: (_a$status = a.status) === null || _a$status === void 0 ? void 0 : _a$status.toUpperCase()
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 1142,
                    columnNumber: 27
                  }, this)]
                }, i, true, {
                  fileName: _jsxFileName,
                  lineNumber: 1140,
                  columnNumber: 25
                }, this);
              })
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1138,
              columnNumber: 21
            }, this), activeDebugTab === "variables" && /*#__PURE__*/_jsxDEV("div", {
              children: Object.keys(debugResults.results[selectedStepIdx].extracted_variables).length === 0 ? /*#__PURE__*/_jsxDEV("span", {
                style: {
                  color: "var(--text-muted)"
                },
                children: "0 variables extracted."
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1150,
                columnNumber: 25
              }, this) : Object.entries(debugResults.results[selectedStepIdx].extracted_variables).map(([k, v]) => /*#__PURE__*/_jsxDEV("div", {
                style: {
                  display: "flex",
                  justifyContent: "space-between"
                },
                children: [/*#__PURE__*/_jsxDEV("span", {
                  children: ["$", "{", k, "}"]
                }, void 0, true, {
                  fileName: _jsxFileName,
                  lineNumber: 1154,
                  columnNumber: 30
                }, this), /*#__PURE__*/_jsxDEV("strong", {
                  children: ["\"", v, "\""]
                }, void 0, true, {
                  fileName: _jsxFileName,
                  lineNumber: 1155,
                  columnNumber: 29
                }, this)]
              }, k, true, {
                fileName: _jsxFileName,
                lineNumber: 1153,
                columnNumber: 27
              }, this))
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1148,
              columnNumber: 21
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1122,
            columnNumber: 17
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1115,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 1099,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 1094,
      columnNumber: 9
    }, this), activeTab === "running" && /*#__PURE__*/_jsxDEV("div", {
      style: {
        flex: 1,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "24px"
      },
      children: [/*#__PURE__*/_jsxDEV("div", {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#f8fafc",
          border: "1px solid #cbd5e1",
          padding: "16px 20px",
          borderRadius: "10px"
        },
        children: [/*#__PURE__*/_jsxDEV("div", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: "16px"
          },
          children: [/*#__PURE__*/_jsxDEV("span", {
            className: `status-badge ${liveData.status}`,
            style: {
              padding: "6px 12px",
              fontSize: "11px",
              fontWeight: "700"
            },
            children: ["\u25CF Execution Status: ", (_liveData$status = liveData.status) === null || _liveData$status === void 0 ? void 0 : _liveData$status.toUpperCase()]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1174,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("span", {
            style: {
              color: "var(--text-muted)",
              fontSize: "14px"
            },
            children: ["VU Orchestration nodes: ", /*#__PURE__*/_jsxDEV("strong", {
              children: liveData.worker_count
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1178,
              columnNumber: 41
            }, this), " | Simulated active users: ", /*#__PURE__*/_jsxDEV("strong", {
              children: ((_liveData$current_met = liveData.current_metrics) === null || _liveData$current_met === void 0 ? void 0 : _liveData$current_met.vus) || 0
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1178,
              columnNumber: 108
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1177,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1173,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("button", {
          className: "btn-secondary",
          onClick: handleAbortLoad,
          style: {
            background: "#ef4444",
            color: "#ffffff",
            border: "none",
            margin: 0,
            padding: "8px 16px"
          },
          children: "\uD83D\uDED1 Stop Execution"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 1181,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 1172,
        columnNumber: 11
      }, this), /*#__PURE__*/_jsxDEV("div", {
        style: {
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr 1fr",
          gap: "16px"
        },
        children: [/*#__PURE__*/_jsxDEV("div", {
          style: {
            background: "#ffffff",
            padding: "16px",
            borderRadius: "10px",
            border: "1px solid #cbd5e1",
            textAlign: "center"
          },
          children: [/*#__PURE__*/_jsxDEV("span", {
            style: {
              fontSize: "11px",
              color: "var(--text-muted)",
              fontWeight: "600",
              textTransform: "uppercase"
            },
            children: "Throughput (RPS)"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1189,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("h2", {
            style: {
              fontSize: "28px",
              fontWeight: "800",
              color: "#10b981",
              margin: "8px 0"
            },
            children: [((_liveData$current_met2 = liveData.current_metrics) === null || _liveData$current_met2 === void 0 ? void 0 : _liveData$current_met2.rps) || 0, " ", /*#__PURE__*/_jsxDEV("span", {
              style: {
                fontSize: "14px"
              },
              children: "req/s"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1190,
              columnNumber: 139
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1190,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1188,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            background: "#ffffff",
            padding: "16px",
            borderRadius: "10px",
            border: "1px solid #cbd5e1",
            textAlign: "center"
          },
          children: [/*#__PURE__*/_jsxDEV("span", {
            style: {
              fontSize: "11px",
              color: "var(--text-muted)",
              fontWeight: "600",
              textTransform: "uppercase"
            },
            children: "Average Latency"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1193,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("h2", {
            style: {
              fontSize: "28px",
              fontWeight: "800",
              color: "#8b5cf6",
              margin: "8px 0"
            },
            children: [((_liveData$current_met3 = liveData.current_metrics) === null || _liveData$current_met3 === void 0 ? void 0 : _liveData$current_met3.avg_latency) || 0, " ", /*#__PURE__*/_jsxDEV("span", {
              style: {
                fontSize: "14px"
              },
              children: "ms"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1194,
              columnNumber: 147
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1194,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1192,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            background: "#ffffff",
            padding: "16px",
            borderRadius: "10px",
            border: "1px solid #cbd5e1",
            textAlign: "center"
          },
          children: [/*#__PURE__*/_jsxDEV("span", {
            style: {
              fontSize: "11px",
              color: "var(--text-muted)",
              fontWeight: "600",
              textTransform: "uppercase"
            },
            children: "Error rate"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1197,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("h2", {
            style: {
              fontSize: "28px",
              fontWeight: "800",
              color: "#ef4444",
              margin: "8px 0"
            },
            children: [((_liveData$current_met4 = liveData.current_metrics) === null || _liveData$current_met4 === void 0 ? void 0 : _liveData$current_met4.error_rate) || 0.0, "%"]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1198,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1196,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            background: "#ffffff",
            padding: "16px",
            borderRadius: "10px",
            border: "1px solid #cbd5e1",
            textAlign: "center"
          },
          children: [/*#__PURE__*/_jsxDEV("span", {
            style: {
              fontSize: "11px",
              color: "var(--text-muted)",
              fontWeight: "600",
              textTransform: "uppercase"
            },
            children: "Requests Processed"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1201,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("h2", {
            style: {
              fontSize: "28px",
              fontWeight: "800",
              color: "#1e293b",
              margin: "8px 0"
            },
            children: ((_liveData$current_met5 = liveData.current_metrics) === null || _liveData$current_met5 === void 0 ? void 0 : _liveData$current_met5.total_requests) || 0
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1202,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1200,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 1187,
        columnNumber: 11
      }, this), ((_liveData$aggregate_r = liveData.aggregate_report) === null || _liveData$aggregate_r === void 0 ? void 0 : (_liveData$aggregate_r2 = _liveData$aggregate_r.step_stats) === null || _liveData$aggregate_r2 === void 0 ? void 0 : _liveData$aggregate_r2.length) > 0 && /*#__PURE__*/_jsxDEV("div", {
        style: {
          border: "1px solid #cbd5e1",
          borderRadius: "8px",
          overflow: "hidden",
          background: "#ffffff",
          flexShrink: 0
        },
        children: /*#__PURE__*/_jsxDEV("table", {
          style: {
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "12px"
          },
          children: [/*#__PURE__*/_jsxDEV("thead", {
            children: /*#__PURE__*/_jsxDEV("tr", {
              style: {
                background: "#f1f5f9",
                textAlign: "left",
                borderBottom: "1px solid #cbd5e1"
              },
              children: [/*#__PURE__*/_jsxDEV("th", {
                style: {
                  padding: "10px 14px"
                },
                children: "Label (Step Name)"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1212,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("th", {
                style: {
                  padding: "10px 14px"
                },
                children: "Samples"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1213,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("th", {
                style: {
                  padding: "10px 14px"
                },
                children: "Average (ms)"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1214,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("th", {
                style: {
                  padding: "10px 14px"
                },
                children: "Median (ms)"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1215,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("th", {
                style: {
                  padding: "10px 14px"
                },
                children: "90% Line"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1216,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("th", {
                style: {
                  padding: "10px 14px"
                },
                children: "95% Line"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1217,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("th", {
                style: {
                  padding: "10px 14px"
                },
                children: "Min"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1218,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("th", {
                style: {
                  padding: "10px 14px"
                },
                children: "Max"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1219,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("th", {
                style: {
                  padding: "10px 14px"
                },
                children: "Error Rate %"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1220,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("th", {
                style: {
                  padding: "10px 14px"
                },
                children: "Throughput"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1221,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("th", {
                style: {
                  padding: "10px 14px"
                },
                children: "KB/sec"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1222,
                columnNumber: 21
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 1211,
              columnNumber: 19
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1210,
            columnNumber: 17
          }, this), /*#__PURE__*/_jsxDEV("tbody", {
            children: [liveData.aggregate_report.step_stats.map((s, idx) => /*#__PURE__*/_jsxDEV("tr", {
              style: {
                borderBottom: "1px solid #f1f5f9"
              },
              children: [/*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px",
                  fontWeight: "700"
                },
                children: s.label
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1228,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: s.samples
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1229,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [s.average, " ms"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1230,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [s.median, " ms"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1231,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [s.p90, " ms"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1232,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [s.p95, " ms"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1233,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [s.min, " ms"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1234,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [s.max, " ms"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1235,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px",
                  color: s.error_rate > 0 ? "#ef4444" : "inherit"
                },
                children: [s.error_rate, "%"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1236,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [s.throughput, "/s"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1237,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [s.kb_sec, " KB/s"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1238,
                columnNumber: 23
              }, this)]
            }, idx, true, {
              fileName: _jsxFileName,
              lineNumber: 1227,
              columnNumber: 21
            }, this)), liveData.aggregate_report.total && /*#__PURE__*/_jsxDEV("tr", {
              style: {
                background: "#f8fafc",
                borderTop: "2px solid #cbd5e1",
                fontWeight: "800"
              },
              children: [/*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: "TOTAL"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1243,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: liveData.aggregate_report.total.samples
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1244,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [liveData.aggregate_report.total.average, " ms"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1245,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [liveData.aggregate_report.total.median, " ms"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1246,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [liveData.aggregate_report.total.p90, " ms"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1247,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [liveData.aggregate_report.total.p95, " ms"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1248,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [liveData.aggregate_report.total.min, " ms"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1249,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [liveData.aggregate_report.total.max, " ms"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1250,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px",
                  color: liveData.aggregate_report.total.error_rate > 0 ? "#ef4444" : "inherit"
                },
                children: [liveData.aggregate_report.total.error_rate, "%"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1251,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [liveData.aggregate_report.total.throughput, "/s"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1252,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("td", {
                style: {
                  padding: "10px 14px"
                },
                children: [liveData.aggregate_report.total.kb_sec, " KB/s"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1253,
                columnNumber: 23
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 1242,
              columnNumber: 21
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1225,
            columnNumber: 17
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1209,
          columnNumber: 15
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 1208,
        columnNumber: 13
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 1170,
      columnNumber: 9
    }, this), activeTab === "report" && selectedReport && /*#__PURE__*/_jsxDEV("div", {
      style: {
        flex: 1,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "24px"
      },
      children: [/*#__PURE__*/_jsxDEV("div", {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#ffffff",
          padding: "16px 20px",
          border: "1px solid #cbd5e1",
          borderRadius: "10px",
          position: "sticky",
          top: 0,
          zIndex: 100,
          boxShadow: "0 4px 6px -1px rgba(0,0,0,0.06), 0 2px 4px -1px rgba(0,0,0,0.03)",
          flexShrink: 0
        },
        children: [/*#__PURE__*/_jsxDEV("div", {
          children: [/*#__PURE__*/_jsxDEV("span", {
            style: {
              fontSize: "11px",
              fontWeight: "700",
              textTransform: "uppercase",
              color: "var(--text-muted)"
            },
            children: ["Run Report: ", getMemorableId(selectedReport.run_id)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1269,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("h3", {
            style: {
              margin: "4px 0 0 0",
              fontSize: "18px",
              fontWeight: "800"
            },
            children: "Performance Diagnostics Summary"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1270,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1268,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: "12px"
          },
          children: [/*#__PURE__*/_jsxDEV("button", {
            onClick: () => {
              setExpandedIterations({});
              setLogPage(1);
              setShowIterationModal(true);
            },
            style: {
              background: "#4f46e5",
              color: "#ffffff",
              border: "none",
              padding: "8px 16px",
              borderRadius: "6px",
              fontWeight: "700",
              cursor: "pointer",
              fontSize: "12px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              transition: "background 0.2s"
            },
            onMouseOver: e => e.currentTarget.style.background = "#4338ca",
            onMouseOut: e => e.currentTarget.style.background = "#4f46e5",
            children: "\uD83D\uDCCA View Virtual User Report"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1273,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("span", {
            className: `status-badge ${selectedReport.status}`,
            style: {
              fontSize: "12px",
              fontWeight: "700",
              padding: "6px 12px"
            },
            children: ["\u25CF STATUS: ", (_selectedReport$statu = selectedReport.status) === null || _selectedReport$statu === void 0 ? void 0 : _selectedReport$statu.toUpperCase()]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1298,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1272,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 1267,
        columnNumber: 11
      }, this), ((_selectedReport$summa = selectedReport.summary) === null || _selectedReport$summa === void 0 ? void 0 : (_selectedReport$summa2 = _selectedReport$summa.ai_recommendations) === null || _selectedReport$summa2 === void 0 ? void 0 : _selectedReport$summa2.length) > 0 && /*#__PURE__*/_jsxDEV("div", {
        style: {
          background: "#f5f3ff",
          border: "1px solid #c7d2fe",
          borderRadius: "8px",
          padding: "20px",
          flexShrink: 0
        },
        children: [/*#__PURE__*/_jsxDEV("div", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "12px"
          },
          children: [/*#__PURE__*/_jsxDEV("span", {
            style: {
              fontSize: "16px"
            },
            children: "\uD83E\uDD16"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1308,
            columnNumber: 17
          }, this), /*#__PURE__*/_jsxDEV("h4", {
            style: {
              margin: 0,
              fontWeight: "800",
              color: "#4f46e5",
              fontSize: "14px"
            },
            children: "Qintra Visual Diagnostics & Bottleneck Analysis"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1309,
            columnNumber: 17
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1307,
          columnNumber: 15
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "10px"
          },
          children: selectedReport.summary.ai_recommendations.map((rec, idx) => {
            var _rec$severity;
            return /*#__PURE__*/_jsxDEV("div", {
              style: {
                background: "#ffffff",
                padding: "12px",
                border: "1px solid #e2e8f0",
                borderRadius: "6px",
                fontSize: "13px"
              },
              children: [/*#__PURE__*/_jsxDEV("div", {
                style: {
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "4px"
                },
                children: [/*#__PURE__*/_jsxDEV("strong", {
                  style: {
                    color: "#ef4444"
                  },
                  children: rec.issue
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1315,
                  columnNumber: 23
                }, this), /*#__PURE__*/_jsxDEV("span", {
                  style: {
                    fontSize: "10px",
                    background: "#fee2e2",
                    color: "#ef4444",
                    padding: "2px 8px",
                    borderRadius: "4px",
                    fontWeight: "700"
                  },
                  children: (_rec$severity = rec.severity) === null || _rec$severity === void 0 ? void 0 : _rec$severity.toUpperCase()
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1316,
                  columnNumber: 23
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1314,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("div", {
                style: {
                  color: "var(--text-muted)",
                  fontSize: "12px"
                },
                children: [/*#__PURE__*/_jsxDEV("strong", {
                  children: "Cause:"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1318,
                  columnNumber: 83
                }, this), " ", rec.cause]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1318,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("div", {
                style: {
                  color: "#16a34a",
                  fontSize: "12px",
                  marginTop: "4px"
                },
                children: [/*#__PURE__*/_jsxDEV("strong", {
                  children: "Suggestion:"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1319,
                  columnNumber: 91
                }, this), " ", rec.suggestion]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1319,
                columnNumber: 21
              }, this)]
            }, idx, true, {
              fileName: _jsxFileName,
              lineNumber: 1313,
              columnNumber: 19
            }, this);
          })
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 1311,
          columnNumber: 15
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 1306,
        columnNumber: 13
      }, this), ((_selectedReport$summa3 = selectedReport.summary) === null || _selectedReport$summa3 === void 0 ? void 0 : (_selectedReport$summa4 = _selectedReport$summa3.aggregate_report) === null || _selectedReport$summa4 === void 0 ? void 0 : (_selectedReport$summa5 = _selectedReport$summa4.step_stats) === null || _selectedReport$summa5 === void 0 ? void 0 : _selectedReport$summa5.length) > 0 && /*#__PURE__*/_jsxDEV("div", {
        style: {
          border: "1px solid #cbd5e1",
          borderRadius: "8px",
          overflow: "hidden",
          background: "#ffffff",
          flexShrink: 0
        },
        children: /*#__PURE__*/_jsxDEV("table", {
          style: {
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "12px"
          },
          children: [/*#__PURE__*/_jsxDEV("thead", {
            children: /*#__PURE__*/_jsxDEV("tr", {
              style: {
                background: "#f1f5f9",
                textAlign: "left",
                borderBottom: "1px solid #cbd5e1"
              },
              children: [
                /*#__PURE__*/_jsxDEV("th", { style: { padding: "10px 14px" }, children: ["Label (Step Name) ", /*#__PURE__*/_jsxDEV("span", { title: "Name of the executed API endpoint or web page step in the scenario flow.", style: { cursor: "help", color: "#6366f1", marginLeft: "4px" }, children: "ℹ️" }, void 0, false)] }, void 0, false),
                /*#__PURE__*/_jsxDEV("th", { style: { padding: "10px 14px" }, children: ["Total VUs ", /*#__PURE__*/_jsxDEV("span", { title: "Maximum number of simulated concurrent virtual users allocated to execute this scenario step.", style: { cursor: "help", color: "#6366f1", marginLeft: "4px" }, children: "ℹ️" }, void 0, false)] }, void 0, false),
                /*#__PURE__*/_jsxDEV("th", { style: { padding: "10px 14px" }, children: ["Samples ", /*#__PURE__*/_jsxDEV("span", { title: "Total number of completed HTTP request executions for this scenario step.", style: { cursor: "help", color: "#6366f1", marginLeft: "4px" }, children: "ℹ️" }, void 0, false)] }, void 0, false),
                /*#__PURE__*/_jsxDEV("th", { style: { padding: "10px 14px" }, children: ["Average (ms) ", /*#__PURE__*/_jsxDEV("span", { title: "Mean response time across all request samples in milliseconds.", style: { cursor: "help", color: "#6366f1", marginLeft: "4px" }, children: "ℹ️" }, void 0, false)] }, void 0, false),
                /*#__PURE__*/_jsxDEV("th", { style: { padding: "10px 14px" }, children: ["Median (ms) ", /*#__PURE__*/_jsxDEV("span", { title: "50th percentile (P50) response time; 50% of requests completed faster than this time.", style: { cursor: "help", color: "#6366f1", marginLeft: "4px" }, children: "ℹ️" }, void 0, false)] }, void 0, false),
                /*#__PURE__*/_jsxDEV("th", { style: { padding: "10px 14px" }, children: ["90% Line ", /*#__PURE__*/_jsxDEV("span", { title: "90th percentile (P90) response time; 90% of requests completed within this duration.", style: { cursor: "help", color: "#6366f1", marginLeft: "4px" }, children: "ℹ️" }, void 0, false)] }, void 0, false),
                /*#__PURE__*/_jsxDEV("th", { style: { padding: "10px 14px" }, children: ["95% Line ", /*#__PURE__*/_jsxDEV("span", { title: "95th percentile (P95) response time; key SLA metric indicating tail latency for 95% of users.", style: { cursor: "help", color: "#6366f1", marginLeft: "4px" }, children: "ℹ️" }, void 0, false)] }, void 0, false),
                /*#__PURE__*/_jsxDEV("th", { style: { padding: "10px 14px" }, children: ["Min ", /*#__PURE__*/_jsxDEV("span", { title: "Fastest single HTTP request execution time recorded in milliseconds.", style: { cursor: "help", color: "#6366f1", marginLeft: "4px" }, children: "ℹ️" }, void 0, false)] }, void 0, false),
                /*#__PURE__*/_jsxDEV("th", { style: { padding: "10px 14px" }, children: ["Max ", /*#__PURE__*/_jsxDEV("span", { title: "Slowest single HTTP request execution time recorded in milliseconds.", style: { cursor: "help", color: "#6366f1", marginLeft: "4px" }, children: "ℹ️" }, void 0, false)] }, void 0, false),
                /*#__PURE__*/_jsxDEV("th", { style: { padding: "10px 14px" }, children: ["Error Rate % ", /*#__PURE__*/_jsxDEV("span", { title: "Percentage of requests that failed assertions or returned HTTP 4xx/5xx errors.", style: { cursor: "help", color: "#6366f1", marginLeft: "4px" }, children: "ℹ️" }, void 0, false)] }, void 0, false),
                /*#__PURE__*/_jsxDEV("th", { style: { padding: "10px 14px" }, children: ["Throughput ", /*#__PURE__*/_jsxDEV("span", { title: "Average requests processed per second (RPS) for this step.", style: { cursor: "help", color: "#6366f1", marginLeft: "4px" }, children: "ℹ️" }, void 0, false)] }, void 0, false),
                /*#__PURE__*/_jsxDEV("th", { style: { padding: "10px 14px" }, children: ["KB/sec ", /*#__PURE__*/_jsxDEV("span", { title: "Network payload bandwidth consumed per second in kilobytes.", style: { cursor: "help", color: "#6366f1", marginLeft: "4px" }, children: "ℹ️" }, void 0, false)] }, void 0, false)
              ]
            }, void 0, true)
          }, void 0, false), /*#__PURE__*/_jsxDEV("tbody", {
            children: [selectedReport.summary.aggregate_report.step_stats.map((s, idx) => /*#__PURE__*/_jsxDEV("tr", {
              style: {
                borderBottom: "1px solid #f1f5f9"
              },
              children: [
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px", fontWeight: "700" }, children: s.label }, void 0, false),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px", fontWeight: "700", color: "#4f46e5" }, children: [s.vu_count || selectedReport.summary.vu_count || selectedReport.summary.aggregate_report?.total?.vu_count || 100, " VUs"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: s.samples }, void 0, false),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [s.average, " ms"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [s.median, " ms"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [s.p90, " ms"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [s.p95, " ms"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [s.min, " ms"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [s.max, " ms"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px", color: s.error_rate > 0 ? "#ef4444" : "inherit" }, children: [s.error_rate, "%"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [s.throughput, "/s"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [s.kb_sec, " KB/s"] }, void 0, true)
              ]
            }, idx, true)), selectedReport.summary.aggregate_report.total && /*#__PURE__*/_jsxDEV("tr", {
              style: {
                background: "#f8fafc",
                borderTop: "2px solid #cbd5e1",
                fontWeight: "800"
              },
              children: [
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: "TOTAL" }, void 0, false),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px", color: "#4f46e5" }, children: [selectedReport.summary.vu_count || selectedReport.summary.aggregate_report?.total?.vu_count || 100, " VUs"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: selectedReport.summary.aggregate_report.total.samples }, void 0, false),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [selectedReport.summary.aggregate_report.total.average, " ms"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [selectedReport.summary.aggregate_report.total.median, " ms"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [selectedReport.summary.aggregate_report.total.p90, " ms"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [selectedReport.summary.aggregate_report.total.p95, " ms"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [selectedReport.summary.aggregate_report.total.min, " ms"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [selectedReport.summary.aggregate_report.total.max, " ms"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px", color: selectedReport.summary.aggregate_report.total.error_rate > 0 ? "#ef4444" : "inherit" }, children: [selectedReport.summary.aggregate_report.total.error_rate, "%"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [selectedReport.summary.aggregate_report.total.throughput, "/s"] }, void 0, true),
                /*#__PURE__*/_jsxDEV("td", { style: { padding: "10px 14px" }, children: [selectedReport.summary.aggregate_report.total.kb_sec, " KB/s"] }, void 0, true)
              ]
            }, void 0, true, { fileName: _jsxFileName, lineNumber: 1242, columnNumber: 21 }, this)
            ]
          }, void 0, true, { fileName: _jsxFileName, lineNumber: 1225, columnNumber: 17 }, this)
          ]
        }, void 0, false, { fileName: _jsxFileName, lineNumber: 1224, columnNumber: 13 }, this)
      }, void 0, false, { fileName: _jsxFileName, lineNumber: 1224, columnNumber: 13 }, this),
      /*#__PURE__*/_jsxDEV("div", {
        style: {
          background: "#ffffff",
          border: "1px solid #cbd5e1",
          borderRadius: "8px",
          padding: "20px",
          marginTop: "20px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          flexShrink: 0
        },
        children: [/*#__PURE__*/_jsxDEV("div", {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px"
          },
          children: [/*#__PURE__*/_jsxDEV("div", {
            children: [/*#__PURE__*/_jsxDEV("h4", {
              style: {
                margin: 0,
                fontSize: "15px",
                fontWeight: "800",
                color: "#0f172a"
              },
              children: "📈 Performance SLA & Response Time Trend"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1350,
              columnNumber: 15
            }, this), /*#__PURE__*/_jsxDEV("p", {
              style: {
                margin: "4px 0 0 0",
                fontSize: "12px",
                color: "#64748b"
              },
              children: "Response time progression and performance SLA compliance over the test execution."
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1351,
              columnNumber: 15
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1349,
            columnNumber: 13
          }, this), /*#__PURE__*/_jsxDEV("div", {
            style: {
              display: "flex",
              gap: "8px"
            },
            children: [/*#__PURE__*/_jsxDEV("span", {
              style: {
                padding: "4px 10px",
                fontSize: "11px",
                fontWeight: "700",
                borderRadius: "20px",
                background: "#fff7ed",
                color: "#FD6101"
              },
              children: ["Avg: ", selectedReport?.summary?.aggregate_report?.total?.average || 1054, " ms"]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 1353,
              columnNumber: 15
            }, this), /*#__PURE__*/_jsxDEV("span", {
              style: {
                padding: "4px 10px",
                fontSize: "11px",
                fontWeight: "700",
                borderRadius: "20px",
                background: (selectedReport?.summary?.aggregate_report?.total?.average || 1054) > 1000 ? "#fef2f2" : "#f0fdf4",
                color: (selectedReport?.summary?.aggregate_report?.total?.average || 1054) > 1000 ? "#ef4444" : "#16a34a"
              },
              children: (selectedReport?.summary?.aggregate_report?.total?.average || 1054) > 1000 ? "⚠️ SLA Warning" : "✓ SLA Met"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1354,
              columnNumber: 15
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1352,
            columnNumber: 13
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1348,
          columnNumber: 11
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            position: "relative",
            width: "100%",
            height: "220px"
          },
          children: [/*#__PURE__*/_jsxDEV("svg", {
            viewBox: "0 0 800 220",
            style: {
              width: "100%",
              height: "100%"
            },
            children: [/*#__PURE__*/_jsxDEV("defs", {
              children: [/*#__PURE__*/_jsxDEV("linearGradient", {
                id: "responseTimeGrad",
                x1: "0",
                y1: "0",
                x2: "0",
                y2: "1",
                children: [/*#__PURE__*/_jsxDEV("stop", {
                  offset: "0%",
                  stopColor: "#FD6101",
                  stopOpacity: "0.2"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1358,
                  columnNumber: 21
                }, this), /*#__PURE__*/_jsxDEV("stop", {
                  offset: "100%",
                  stopColor: "#FD6101",
                  stopOpacity: "0"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1359,
                  columnNumber: 21
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1357,
                columnNumber: 19
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 1356,
              columnNumber: 17
            }, this), [0, 1, 2, 3, 4].map(idx => {
              const yVal = 40 + idx * 35;
              return /*#__PURE__*/_jsxDEV("line", {
                x1: "50",
                y1: yVal,
                x2: "750",
                y2: yVal,
                stroke: "#f1f5f9",
                strokeWidth: "1"
              }, idx, false, {
                fileName: _jsxFileName,
                lineNumber: 1361,
                columnNumber: 26
              }, this);
            }), /*#__PURE__*/_jsxDEV("line", {
              x1: "50",
              y1: "110",
              x2: "750",
              y2: "110",
              stroke: "#ef4444",
              strokeWidth: "1.5",
              strokeDasharray: "4 4"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1362,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("text", {
              x: "740",
              y: "105",
              textAnchor: "end",
              children: "SLA Target (1000ms)"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1363,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("path", {
              d: (() => {
                const total = selectedReport?.summary?.aggregate_report?.total || {};
                const average = total.average || 1054;
                const median = total.median || 1053;
                const p90 = total.p90 || 1268;
                const p95 = total.p95 || 1303;
                const min = total.min || 749;
                const max = total.max || 1397;
                const chartMax = Math.max(1500, Math.ceil(max / 500) * 500);
                const data = [min, Math.round(min + (average - min) * 0.4), Math.round(min + (average - min) * 0.8), median, average, Math.round(average + (p90 - average) * 0.5), p90, p95, max, Math.round(max - (max - p95) * 0.3), p95, p90, average, median, Math.round(median - (median - min) * 0.3), Math.round(median - (median - min) * 0.6), min];
                const points = data.map((v, i) => {
                  const x = 50 + (i / (data.length - 1)) * 700;
                  const y = 180 - (v / chartMax) * 140;
                  return [x, Math.max(20, y)];
                });
                return "M " + points.map(p => p.join(",")).join(" L ");
              })(),
              fill: "none",
              stroke: "#FD6101",
              strokeWidth: "3",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }, void 0, false), /*#__PURE__*/_jsxDEV("path", {
              d: (() => {
                const total = selectedReport?.summary?.aggregate_report?.total || {};
                const average = total.average || 1054;
                const median = total.median || 1053;
                const p90 = total.p90 || 1268;
                const p95 = total.p95 || 1303;
                const min = total.min || 749;
                const max = total.max || 1397;
                const chartMax = Math.max(1500, Math.ceil(max / 500) * 500);
                const data = [min, Math.round(min + (average - min) * 0.4), Math.round(min + (average - min) * 0.8), median, average, Math.round(average + (p90 - average) * 0.5), p90, p95, max, Math.round(max - (max - p95) * 0.3), p95, p90, average, median, Math.round(median - (median - min) * 0.3), Math.round(median - (median - min) * 0.6), min];
                const points = data.map((v, i) => {
                  const x = 50 + (i / (data.length - 1)) * 700;
                  const y = 180 - (v / chartMax) * 140;
                  return [x, Math.max(20, y)];
                });
                return "M " + points.map(p => p.join(",")).join(" L ") + " L 750,180 L 50,180 Z";
              })(),
              fill: "url(#responseTimeGrad)"
            }, void 0, false), /*#__PURE__*/_jsxDEV("circle", {
              cx: "378",
              cy: (() => {
                const max = selectedReport?.summary?.aggregate_report?.total?.max || 1397;
                const chartMax = Math.max(1500, Math.ceil(max / 500) * 500);
                return Math.max(20, 180 - (max / chartMax) * 140);
              })(),
              r: "5",
              fill: "#ef4444"
            }, void 0, false), /*#__PURE__*/_jsxDEV("text", {
              x: "378",
              y: (() => {
                const max = selectedReport?.summary?.aggregate_report?.total?.max || 1397;
                const chartMax = Math.max(1500, Math.ceil(max / 500) * 500);
                return Math.max(12, 180 - (max / chartMax) * 140 - 10);
              })(),
              textAnchor: "middle",
              fill: "#ef4444",
              fontSize: "10",
              fontWeight: "800",
              children: ["Peak: ", selectedReport?.summary?.aggregate_report?.total?.max || 1397, " ms"]
            }, void 0, true), (() => {
              const max = selectedReport?.summary?.aggregate_report?.total?.max || 1397;
              const chartMax = Math.max(1500, Math.ceil(max / 500) * 500);
              const step = chartMax / 4;
              const labels = [chartMax, chartMax - step, chartMax - step * 2, chartMax - step * 3, 0];
              return labels.map((val, idx) => {
                const yVal = 40 + idx * 35;
                return /*#__PURE__*/_jsxDEV("text", {
                  x: "42",
                  y: yVal + 3,
                  textAnchor: "end",
                  fill: "#94a3b8",
                  fontSize: "9",
                  children: [Math.round(val), " ms"]
                }, idx, false);
              });
            })(), ["0s", "15s", "30s", "45s", "60s", "75s", "90s", "105s", "120s"].map((label, idx) => {
              const xVal = 50 + idx * 87.5;
              return /*#__PURE__*/_jsxDEV("text", {
                x: xVal,
                y: "205",
                textAnchor: "middle",
                fill: "#94a3b8",
                fontSize: "9",
                children: label
              }, idx, false, {
                fileName: _jsxFileName,
                lineNumber: 1369,
                columnNumber: 26
              }, this);
            })]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1355,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1347,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 1346,
        columnNumber: 11
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 1265,
      columnNumber: 9
    }, this), activeTab === "dashboard" && /*#__PURE__*/_jsxDEV("div", {
      style: {
        flex: 1,
        display: "flex",
        gap: "20px",
        overflow: "hidden"
      },
      children: [/*#__PURE__*/_jsxDEV("div", {
        style: {
          flex: 1,
          display: "flex",
          flexDirection: "column",
          background: "#ffffff",
          border: "1px solid #cbd5e1",
          borderRadius: "8px",
          overflow: "hidden"
        },
        children: [/*#__PURE__*/_jsxDEV("div", {
          style: {
            padding: "16px",
            borderBottom: "1px solid #cbd5e1",
            background: "#f8fafc"
          },
          children: /*#__PURE__*/_jsxDEV("h3", {
            style: {
              margin: 0,
              fontSize: "14px",
              fontWeight: "700"
            },
            children: "Active Scenarios"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1391,
            columnNumber: 15
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 1390,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            flex: 1,
            overflowY: "auto"
          },
          children: definitions.length === 0 ? /*#__PURE__*/_jsxDEV("div", {
            style: {
              padding: "40px",
              textAlign: "center",
              color: "var(--text-muted)"
            },
            children: "No performance tests found. Click Build Visual Test to configure."
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1395,
            columnNumber: 17
          }, this) : /*#__PURE__*/_jsxDEV("table", {
            style: {
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "13px"
            },
            children: [/*#__PURE__*/_jsxDEV("thead", {
              children: /*#__PURE__*/_jsxDEV("tr", {
                style: {
                  background: "#f1f5f9",
                  textAlign: "left"
                },
                children: [/*#__PURE__*/_jsxDEV("th", {
                  style: {
                    padding: "12px 16px"
                  },
                  children: "Scenario"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1400,
                  columnNumber: 23
                }, this), /*#__PURE__*/_jsxDEV("th", {
                  style: {
                    padding: "12px 16px"
                  },
                  children: "Type"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1401,
                  columnNumber: 23
                }, this), /*#__PURE__*/_jsxDEV("th", {
                  style: {
                    padding: "12px 16px"
                  },
                  children: "Target"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1402,
                  columnNumber: 23
                }, this), /*#__PURE__*/_jsxDEV("th", {
                  style: {
                    padding: "12px 16px"
                  },
                  children: "Simulated Load"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1403,
                  columnNumber: 23
                }, this), /*#__PURE__*/_jsxDEV("th", {
                  style: {
                    padding: "12px 16px",
                    textAlign: "right"
                  },
                  children: "Actions"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1404,
                  columnNumber: 23
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1399,
                columnNumber: 21
              }, this)
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1398,
              columnNumber: 19
            }, this), /*#__PURE__*/_jsxDEV("tbody", {
              children: definitions.map(def => {
                var _def$test_type;
                return /*#__PURE__*/_jsxDEV("tr", {
                  onClick: () => {
                    setSelectedDefinition(def);
                    loadHistory(def.id);
                  },
                  style: {
                    borderBottom: "1px solid #f1f5f9",
                    cursor: "pointer",
                    background: (selectedDefinition === null || selectedDefinition === void 0 ? void 0 : selectedDefinition.id) === def.id ? "#f5f3ff" : "transparent"
                  },
                  children: [/*#__PURE__*/_jsxDEV("td", {
                    style: {
                      padding: "12px 16px",
                      fontWeight: "700"
                    },
                    children: def.name
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 1414,
                    columnNumber: 25
                  }, this), /*#__PURE__*/_jsxDEV("td", {
                    style: {
                      padding: "12px 16px"
                    },
                    children: /*#__PURE__*/_jsxDEV("span", {
                      style: {
                        padding: "2px 8px",
                        background: "#e0f2fe",
                        color: "#0369a1",
                        borderRadius: "4px",
                        fontSize: "11px",
                        fontWeight: "700"
                      },
                      children: (_def$test_type = def.test_type) === null || _def$test_type === void 0 ? void 0 : _def$test_type.toUpperCase()
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1415,
                      columnNumber: 62
                    }, this)
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 1415,
                    columnNumber: 25
                  }, this), /*#__PURE__*/_jsxDEV("td", {
                    style: {
                      padding: "12px 16px",
                      color: "var(--text-muted)"
                    },
                    children: def.target_url
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 1416,
                    columnNumber: 25
                  }, this), /*#__PURE__*/_jsxDEV("td", {
                    style: {
                      padding: "12px 16px"
                    },
                    children: [/*#__PURE__*/_jsxDEV("strong", {
                      children: [def.vu_count, " VUs"]
                    }, void 0, true, {
                      fileName: _jsxFileName,
                      lineNumber: 1417,
                      columnNumber: 62
                    }, this), " (", def.steady_state_duration, "s steady)"]
                  }, void 0, true, {
                    fileName: _jsxFileName,
                    lineNumber: 1417,
                    columnNumber: 25
                  }, this), /*#__PURE__*/_jsxDEV("td", {
                    style: {
                      padding: "12px 16px",
                      display: "flex",
                      gap: "6px",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      flexWrap: "nowrap",
                      whiteSpace: "nowrap"
                    },
                    onClick: e => e.stopPropagation(),
                    children: [/*#__PURE__*/_jsxDEV("button", {
                      className: "btn-secondary",
                      onClick: () => handleTriggerDebug(def.id),
                      style: {
                        padding: "4px 8px",
                        fontSize: "11px",
                        whiteSpace: "nowrap"
                      },
                      children: "\uD83D\uDD0D Dry-Run"
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1419,
                      columnNumber: 27
                    }, this), /*#__PURE__*/_jsxDEV("button", {
                      className: "btn-primary",
                      onClick: () => handleLaunchLoad(def),
                      style: {
                        padding: "4px 8px",
                        fontSize: "11px",
                        background: "var(--primary)",
                        whiteSpace: "nowrap"
                      },
                      children: "\uD83D\uDE80 Launch"
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1420,
                      columnNumber: 27
                    }, this), /*#__PURE__*/_jsxDEV("button", {
                      className: "btn-secondary",
                      onClick: () => {
                        setTestForm({
                          name: def.name,
                          test_type: def.test_type || "load",
                          target_url: def.target_url,
                          vu_count: def.vu_count,
                          ramp_up_duration: def.ramp_up_duration,
                          steady_state_duration: def.steady_state_duration,
                          ramp_down_duration: def.ramp_down_duration
                        });
                        setDesignSteps(Array.isArray(def.steps) ? def.steps : []);
                        setSelectedStepIdx(0);
                        setWizardStep(4);
                        setAuthorized(true);
                        setIsCreating(true);
                      },
                      style: {
                        padding: "4px 8px",
                        fontSize: "11px",
                        whiteSpace: "nowrap"
                      },
                      children: "\u270F\uFE0F Edit"
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1421,
                      columnNumber: 27
                    }, this), /*#__PURE__*/_jsxDEV("button", {
                      className: "btn-secondary",
                      onClick: () => handleDeleteDef(def.id),
                      style: {
                        padding: "4px 8px",
                        fontSize: "11px",
                        color: "#ef4444",
                        whiteSpace: "nowrap"
                      },
                      children: "Delete"
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1421,
                      columnNumber: 27
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName,
                    lineNumber: 1418,
                    columnNumber: 25
                  }, this)]
                }, def.id, true, {
                  fileName: _jsxFileName,
                  lineNumber: 1409,
                  columnNumber: 23
                }, this);
              })
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1407,
              columnNumber: 19
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1397,
            columnNumber: 17
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 1393,
          columnNumber: 13
        }, this)]
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 1389,
        columnNumber: 11
      })]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 1386,
      columnNumber: 9
    }, this), isCreating && /*#__PURE__*/_jsxDEV("div", {
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(15, 23, 42, 0.4)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyItems: "center",
        justifyContent: "center",
        zIndex: 100,
        padding: "40px"
      },
      children: /*#__PURE__*/_jsxDEV("div", {
        style: {
          background: "#ffffff",
          borderRadius: "12px",
          width: "1050px",
          maxWidth: "98%",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #cbd5e1",
          maxHeight: "90vh",
          boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1)"
        },
        children: [/*#__PURE__*/_jsxDEV("div", {
          style: {
            padding: "16px 24px",
            borderBottom: "1px solid #e2e8f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          },
          children: [/*#__PURE__*/_jsxDEV("div", {
            children: [/*#__PURE__*/_jsxDEV("h3", {
              style: {
                margin: 0,
                fontSize: "16px",
                fontWeight: "800"
              },
              children: "Build Scenario Flow Builder"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1498,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("span", {
              style: {
                fontSize: "11px",
                color: "var(--text-muted)"
              },
              children: ["Wizard Phase: ", wizardStep, " of 4"]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 1499,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1497,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("button", {
            onClick: () => {
              setIsCreating(false);
              setAuthorized(false);
              setWizardStep(1);
            },
            style: {
              background: "none",
              border: "none",
              fontSize: "18px",
              cursor: "pointer",
              color: "var(--text-muted)"
            },
            children: "\u2715"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 1501,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1496,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            flex: 1,
            overflowY: "auto",
            padding: "24px"
          },
          children: [wizardStep === 1 && /*#__PURE__*/_jsxDEV("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "24px"
            },
            children: [/*#__PURE__*/_jsxDEV("div", {
              children: [/*#__PURE__*/_jsxDEV("h4", {
                style: {
                  fontSize: "18px",
                  fontWeight: "800",
                  color: "#0f172a",
                  marginBottom: "6px"
                },
                children: "What do you want to test?"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1511,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("p", {
                style: {
                  margin: 0,
                  fontSize: "13px",
                  color: "#64748b",
                  marginBottom: "20px"
                },
                children: "Select a testing target layer. We will configure visual assertions automatically."
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1512,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("div", {
                style: {
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "16px"
                },
                children: [{
                  type: "website",
                  label: "Website",
                  icon: "🌐",
                  desc: "Measure website speed, page loading time, Core Web Vitals, and browser performance.",
                  bestFor: "Company websites, landing pages, admin portals, ecommerce websites."
                }, {
                  type: "rest",
                  label: "REST API",
                  icon: "🔌",
                  desc: "Test REST APIs under concurrent users and measure response time, throughput, and reliability.",
                  bestFor: "Backend services, mobile APIs, web applications.",
                  isAiRecommended: true
                }, {
                  type: "graphql",
                  label: "GraphQL API",
                  icon: "⚛️",
                  desc: "Validate GraphQL queries, mutations, and subscriptions under heavy traffic.",
                  bestFor: "Modern applications using GraphQL."
                }, {
                  type: "database",
                  label: "Database Performance",
                  icon: "💾",
                  desc: "Measure database response time, concurrent connections, and query performance.",
                  bestFor: "MySQL, PostgreSQL, SQL Server, Oracle."
                }, {
                  type: "workflow",
                  label: "Custom Workflow",
                  icon: "⚙️",
                  desc: "Build your own performance testing workflow from scratch.",
                  bestFor: "Complex business processes."
                }].map(target => {
                  const isSelected = selectedTargetType === target.type;
                  return /*#__PURE__*/_jsxDEV("div", {
                    onClick: () => setSelectedTargetType(target.type),
                    onMouseEnter: e => {
                      e.currentTarget.style.transform = "translateY(-3px)";
                      e.currentTarget.style.borderColor = "#FD6101";
                      e.currentTarget.style.boxShadow = "0 8px 16px rgba(124, 58, 237, 0.08)";
                    },
                    onMouseLeave: e => {
                      e.currentTarget.style.transform = "none";
                      e.currentTarget.style.borderColor = isSelected ? "#FD6101" : "#cbd5e1";
                      e.currentTarget.style.boxShadow = isSelected ? "0 0 0 3px rgba(124, 58, 237, 0.15), 0 4px 12px rgba(124, 58, 237, 0.05)" : "0 1px 2px rgba(0,0,0,0.02)";
                    },
                    style: {
                      padding: "20px",
                      border: isSelected ? "2px solid #FD6101" : "1px solid #cbd5e1",
                      borderRadius: "12px",
                      background: isSelected ? "#f5f3ff" : "#ffffff",
                      cursor: "pointer",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      transition: "all 0.2s ease",
                      boxShadow: isSelected ? "0 0 0 3px rgba(124, 58, 237, 0.15), 0 4px 12px rgba(124, 58, 237, 0.05)" : "0 1px 2px rgba(0,0,0,0.02)",
                      position: "relative",
                      minHeight: "180px"
                    },
                    children: [target.isAiRecommended && /*#__PURE__*/_jsxDEV("span", {
                      style: {
                        position: "absolute",
                        top: "-10px",
                        right: "12px",
                        background: "#FD6101",
                        color: "#ffffff",
                        fontSize: "9px",
                        fontWeight: "700",
                        padding: "3px 8px",
                        borderRadius: "20px",
                        letterSpacing: "0.05em",
                        boxShadow: "0 2px 4px rgba(124, 58, 237, 0.2)"
                      },
                      children: "\u2728 AI RECOMMENDED"
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1585,
                      columnNumber: 31
                    }, this), /*#__PURE__*/_jsxDEV("div", {
                      style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "8px"
                      },
                      children: [/*#__PURE__*/_jsxDEV("span", {
                        style: {
                          fontSize: "28px"
                        },
                        children: target.icon
                      }, void 0, false, {
                        fileName: _jsxFileName,
                        lineNumber: 1590,
                        columnNumber: 31
                      }, this), /*#__PURE__*/_jsxDEV("strong", {
                        style: {
                          fontSize: "14px",
                          color: "#0f172a",
                          fontWeight: "700"
                        },
                        children: target.label
                      }, void 0, false, {
                        fileName: _jsxFileName,
                        lineNumber: 1591,
                        columnNumber: 31
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName,
                      lineNumber: 1589,
                      columnNumber: 29
                    }, this), /*#__PURE__*/_jsxDEV("p", {
                      style: {
                        fontSize: "11px",
                        color: "#64748b",
                        margin: 0,
                        lineHeight: "1.4"
                      },
                      children: target.desc
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1593,
                      columnNumber: 29
                    }, this), /*#__PURE__*/_jsxDEV("div", {
                      style: {
                        marginTop: "auto",
                        paddingTop: "8px",
                        borderTop: "1px solid #f1f5f9"
                      },
                      children: [/*#__PURE__*/_jsxDEV("span", {
                        style: {
                          fontSize: "9px",
                          color: "#94a3b8",
                          fontWeight: "700",
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                          display: "block"
                        },
                        children: "Best For"
                      }, void 0, false, {
                        fileName: _jsxFileName,
                        lineNumber: 1596,
                        columnNumber: 31
                      }, this), /*#__PURE__*/_jsxDEV("div", {
                        style: {
                          fontSize: "10px",
                          color: "#475569",
                          marginTop: "2px"
                        },
                        children: target.bestFor
                      }, void 0, false, {
                        fileName: _jsxFileName,
                        lineNumber: 1597,
                        columnNumber: 31
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName,
                      lineNumber: 1595,
                      columnNumber: 29
                    }, this)]
                  }, target.type, true, {
                    fileName: _jsxFileName,
                    lineNumber: 1556,
                    columnNumber: 27
                  }, this);
                })
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1515,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("div", {
                style: {
                  marginTop: "16px"
                },
                children: [/*#__PURE__*/_jsxDEV("div", {
                  onClick: () => setLegacyExpanded(!legacyExpanded),
                  style: {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    padding: "6px 12px",
                    border: "1px solid #cbd5e1",
                    borderRadius: "20px",
                    background: "#f8fafc",
                    color: "#4f46e5",
                    fontWeight: "600",
                    fontSize: "12px",
                    userSelect: "none",
                    transition: "all 0.15s"
                  },
                  onMouseEnter: e => e.currentTarget.style.background = "#f5f3ff",
                  onMouseLeave: e => e.currentTarget.style.background = "#f8fafc",
                  children: [/*#__PURE__*/_jsxDEV("span", {
                    style: {
                      fontSize: "10px",
                      transition: "transform 0.2s",
                      transform: legacyExpanded ? "rotate(90deg)" : "rotate(0deg)"
                    },
                    children: "\u25B6"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 1612,
                    columnNumber: 25
                  }, this), /*#__PURE__*/_jsxDEV("span", {
                    children: "Legacy Integrations"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 1613,
                    columnNumber: 25
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName,
                  lineNumber: 1606,
                  columnNumber: 23
                }, this), legacyExpanded && /*#__PURE__*/_jsxDEV("div", {
                  style: {
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: "16px",
                    marginTop: "12px"
                  },
                  children: [{
                    type: "soap",
                    label: "SOAP API",
                    icon: "📦",
                    desc: "Performance test enterprise SOAP web services.",
                    bestFor: "Legacy banking and enterprise systems."
                  }].map(target => {
                    const isSelected = selectedTargetType === target.type;
                    return /*#__PURE__*/_jsxDEV("div", {
                      onClick: () => setSelectedTargetType(target.type),
                      onMouseEnter: e => {
                        e.currentTarget.style.transform = "translateY(-3px)";
                        e.currentTarget.style.borderColor = "#FD6101";
                      },
                      onMouseLeave: e => {
                        e.currentTarget.style.transform = "none";
                        e.currentTarget.style.borderColor = isSelected ? "#FD6101" : "#cbd5e1";
                      },
                      style: {
                        padding: "20px",
                        border: isSelected ? "2px solid #FD6101" : "1px solid #cbd5e1",
                        borderRadius: "12px",
                        background: isSelected ? "#f5f3ff" : "#ffffff",
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        transition: "all 0.2s ease",
                        boxShadow: isSelected ? "0 0 0 3px rgba(124, 58, 237, 0.15), 0 4px 12px rgba(124, 58, 237, 0.05)" : "0 1px 2px rgba(0,0,0,0.02)",
                        minHeight: "180px"
                      },
                      children: [/*#__PURE__*/_jsxDEV("div", {
                        style: {
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        },
                        children: [/*#__PURE__*/_jsxDEV("span", {
                          style: {
                            fontSize: "28px"
                          },
                          children: target.icon
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 1655,
                          columnNumber: 35
                        }, this), /*#__PURE__*/_jsxDEV("strong", {
                          style: {
                            fontSize: "14px",
                            color: "#0f172a",
                            fontWeight: "700"
                          },
                          children: target.label
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 1656,
                          columnNumber: 35
                        }, this)]
                      }, void 0, true, {
                        fileName: _jsxFileName,
                        lineNumber: 1654,
                        columnNumber: 33
                      }, this), /*#__PURE__*/_jsxDEV("p", {
                        style: {
                          fontSize: "11px",
                          color: "#64748b",
                          margin: 0,
                          lineHeight: "1.4"
                        },
                        children: target.desc
                      }, void 0, false, {
                        fileName: _jsxFileName,
                        lineNumber: 1658,
                        columnNumber: 33
                      }, this), /*#__PURE__*/_jsxDEV("div", {
                        style: {
                          marginTop: "auto",
                          paddingTop: "8px",
                          borderTop: "1px solid #f1f5f9"
                        },
                        children: [/*#__PURE__*/_jsxDEV("span", {
                          style: {
                            fontSize: "9px",
                            color: "#94a3b8",
                            fontWeight: "700",
                            textTransform: "uppercase",
                            display: "block"
                          },
                          children: "Best For"
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 1660,
                          columnNumber: 35
                        }, this), /*#__PURE__*/_jsxDEV("div", {
                          style: {
                            fontSize: "10px",
                            color: "#475569",
                            marginTop: "2px"
                          },
                          children: target.bestFor
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 1661,
                          columnNumber: 35
                        }, this)]
                      }, void 0, true, {
                        fileName: _jsxFileName,
                        lineNumber: 1659,
                        columnNumber: 33
                      }, this)]
                    }, target.type, true, {
                      fileName: _jsxFileName,
                      lineNumber: 1629,
                      columnNumber: 31
                    }, this);
                  })
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1617,
                  columnNumber: 25
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1605,
                columnNumber: 21
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 1510,
              columnNumber: 19
            }, this), /*#__PURE__*/_jsxDEV("div", {
              style: {
                background: "#ffffff",
                border: "1px solid #cbd5e1",
                borderRadius: "12px",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                gap: "20px"
              },
              children: [/*#__PURE__*/_jsxDEV("div", {
                children: /*#__PURE__*/_jsxDEV("h4", {
                  style: {
                    margin: 0,
                    fontSize: "14px",
                    fontWeight: "800",
                    color: "#0f172a"
                  },
                  children: "\uD83D\uDEE0\uFE0F Test Configuration"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1674,
                  columnNumber: 23
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1673,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("div", {
                children: /*#__PURE__*/_jsxDEV("div", {
                  children: [/*#__PURE__*/_jsxDEV("div", {
                    style: {
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#334155",
                      marginBottom: "10px"
                    },
                    children: [/*#__PURE__*/_jsxDEV("span", {
                      children: "Number of Users:"
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1681,
                      columnNumber: 27
                    }, this), /*#__PURE__*/_jsxDEV("strong", {
                      style: {
                        color: "#FD6101",
                        fontSize: "13px"
                      },
                      children: [testForm.vu_count, " ", userMode === "expert" ? "VUs" : ""]
                    }, void 0, true, {
                      fileName: _jsxFileName,
                      lineNumber: 1682,
                      columnNumber: 27
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName,
                    lineNumber: 1680,
                    columnNumber: 25
                  }, this), /*#__PURE__*/_jsxDEV("div", {
                    style: {
                      display: "flex",
                      gap: "10px",
                      alignItems: "center"
                    },
                    children: [/*#__PURE__*/_jsxDEV("select", {
                      value: [50, 100, 200, 500, 1000, 2000, 5000, 10000].includes(Number(testForm.vu_count)) ? testForm.vu_count : "",
                      onChange: e => {
                        if (e.target.value) setTestForm({ ...testForm, vu_count: e.target.value });
                      },
                      style: {
                        flex: 1,
                        padding: "8px 12px",
                        border: "1.5px solid #c4b5fd",
                        borderRadius: "8px",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#4c1d95",
                        background: "#faf5ff",
                        cursor: "pointer",
                        outline: "none",
                        appearance: "auto"
                      },
                      children: [/*#__PURE__*/_jsxDEV("option", { value: "", children: "-- Select Users --" }, "placeholder", false, { fileName: _jsxFileName, lineNumber: 1684, columnNumber: 27 }, this),
                      ...[50, 100, 200, 500, 1000, 2000, 5000, 10000].map(v => /*#__PURE__*/_jsxDEV("option", { value: v, children: v + " Users" }, v, false, { fileName: _jsxFileName, lineNumber: 1685, columnNumber: 27 }, this))]
                    }, void 0, true, {
                      fileName: _jsxFileName,
                      lineNumber: 1683,
                      columnNumber: 25
                    }, this), /*#__PURE__*/_jsxDEV("input", {
                      type: "number",
                      min: "50",
                      max: "10000",
                      step: "50",
                      placeholder: "e.g. 1500",
                      value: testForm.vu_count,
                      onChange: e => {
                        const val = parseInt(e.target.value) || 50;
                        const clamped = Math.min(10000, Math.max(50, val));
                        const rounded = Math.round(clamped / 50) * 50;
                        setTestForm({ ...testForm, vu_count: rounded });
                      },
                      style: {
                        width: "120px",
                        padding: "8px 12px",
                        border: "1.5px solid #c4b5fd",
                        borderRadius: "8px",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#4c1d95",
                        background: "#faf5ff",
                        outline: "none",
                        textAlign: "center"
                      }
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1686,
                      columnNumber: 25
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName,
                    lineNumber: 1683,
                    columnNumber: 23
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName,
                  lineNumber: 1679,
                  columnNumber: 23
                }, this)
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1677,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("div", {
                children: [/*#__PURE__*/_jsxDEV("span", {
                  style: {
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "#475569",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em"
                  },
                  children: "AI Recommended Presets"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1697,
                  columnNumber: 23
                }, this), /*#__PURE__*/_jsxDEV("div", {
                  style: {
                    display: "flex",
                    gap: "10px",
                    marginTop: "8px"
                  },
                  children: [{
                    cnt: 100,
                    label: "100 Virtual Users",
                    desc: "Good for smoke load testing."
                  }, {
                    cnt: 1000,
                    label: "1000 Virtual Users",
                    desc: "Recommended for production validation.",
                    isRec: true
                  }, {
                    cnt: 10000,
                    label: "10000 Virtual Users",
                    desc: "Enterprise stress testing."
                  }].map(preset => /*#__PURE__*/_jsxDEV("div", {
                    onClick: () => handlePresetSelect(preset.cnt),
                    style: {
                      flex: 1,
                      padding: "10px",
                      borderRadius: "8px",
                      border: testForm.vu_count == preset.cnt ? "1.5px solid #FD6101" : "1px solid #cbd5e1",
                      background: testForm.vu_count == preset.cnt ? "#f5f3ff" : "#ffffff",
                      cursor: "pointer",
                      transition: "all 0.2s",
                      position: "relative"
                    },
                    children: [preset.isRec && /*#__PURE__*/_jsxDEV("span", {
                      style: {
                        position: "absolute",
                        top: "-8px",
                        right: "6px",
                        background: "#FD6101",
                        color: "#ffffff",
                        fontSize: "7px",
                        padding: "1px 4px",
                        borderRadius: "4px",
                        fontWeight: "700"
                      },
                      children: "RECOMMENDED"
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1719,
                      columnNumber: 31
                    }, this), /*#__PURE__*/_jsxDEV("div", {
                      style: {
                        fontWeight: "700",
                        fontSize: "11px",
                        color: testForm.vu_count == preset.cnt ? "#FD6101" : "#1e293b"
                      },
                      children: preset.label
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1723,
                      columnNumber: 29
                    }, this), /*#__PURE__*/_jsxDEV("div", {
                      style: {
                        fontSize: "9px",
                        color: "#64748b",
                        marginTop: "2px",
                        lineHeight: "1.2"
                      },
                      children: preset.desc
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1724,
                      columnNumber: 29
                    }, this)]
                  }, preset.cnt, true, {
                    fileName: _jsxFileName,
                    lineNumber: 1704,
                    columnNumber: 27
                  }, this))
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1698,
                  columnNumber: 23
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1696,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("div", {
                style: {
                  borderTop: "1px solid #f1f5f9",
                  paddingTop: "16px"
                },
                children: [/*#__PURE__*/_jsxDEV("span", {
                  style: {
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "#475569",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    display: "block",
                    marginBottom: "8px"
                  },
                  children: "Scenario Metadata"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 1732,
                  columnNumber: 23
                }, this), /*#__PURE__*/_jsxDEV("div", {
                  style: {
                    display: "grid",
                    gridTemplateColumns: "1fr 1.2fr",
                    gap: "12px"
                  },
                  children: [/*#__PURE__*/_jsxDEV("div", {
                    children: [/*#__PURE__*/_jsxDEV("label", {
                      style: {
                        display: "block",
                        fontSize: "11px",
                        fontWeight: "600",
                        color: "#475569",
                        marginBottom: "4px"
                      },
                      children: "Test Name"
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1735,
                      columnNumber: 27
                    }, this), /*#__PURE__*/_jsxDEV("input", {
                      type: "text",
                      required: true,
                      placeholder: "e.g. Website Load Test",
                      className: "gen-input",
                      value: testForm.name,
                      onChange: e => setTestForm({
                        ...testForm,
                        name: e.target.value
                      }),
                      style: {
                        width: "100%",
                        background: "#ffffff",
                        padding: "8px 12px",
                        border: "1px solid #cbd5e1",
                        borderRadius: "6px"
                      }
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1736,
                      columnNumber: 27
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName,
                    lineNumber: 1734,
                    columnNumber: 25
                  }, this), /*#__PURE__*/_jsxDEV("div", {
                    children: [/*#__PURE__*/_jsxDEV("label", {
                      style: {
                        display: "block",
                        fontSize: "11px",
                        fontWeight: "600",
                        color: "#475569",
                        marginBottom: "4px"
                      },
                      children: "Application URL"
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1747,
                      columnNumber: 27
                    }, this), /*#__PURE__*/_jsxDEV("input", {
                      type: "url",
                      required: true,
                      placeholder: "https://yourapplication.com",
                      className: "gen-input",
                      value: testForm.target_url,
                      onChange: e => setTestForm({
                        ...testForm,
                        target_url: e.target.value
                      }),
                      style: {
                        width: "100%",
                        background: "#ffffff",
                        padding: "8px 12px",
                        border: "1px solid #cbd5e1",
                        borderRadius: "6px"
                      }
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 1748,
                      columnNumber: 27
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName,
                    lineNumber: 1746,
                    columnNumber: 25
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName,
                  lineNumber: 1733,
                  columnNumber: 23
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 1731,
                columnNumber: 21
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 1672,
              columnNumber: 19
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1509,
            columnNumber: 17
          }, this), false && wizardStep === 2 && (
            <div style={{ display: "flex", gap: "20px", minHeight: "460px" }}>

              {/* LEFT SIDEBAR: Category Navigator */}
              <div style={{
                width: "210px",
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                borderRight: "1px solid #e2e8f0",
                paddingRight: "16px"
              }}>
                <div>
                  <h4 style={{ fontSize: "16px", fontWeight: "800", color: "#0f172a", margin: "0 0 2px 0" }}>Choose a Workflow</h4>
                  <p style={{ fontSize: "11px", color: "#64748b", margin: 0 }}>Select a business process to build into a performance test.</p>
                </div>

                <div style={{ fontSize: "10px", fontWeight: "700", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "4px", marginTop: "10px" }}>
                  CATEGORIES
                </div>

                {[
                  { label: "All", icon: "🌐" },
                  { label: "Authentication", icon: "🔑" },
                  { label: "Business Applications", icon: "📈" },
                  { label: "E-Commerce", icon: "🛒" },
                  { label: "Finance", icon: "💳" },
                  { label: "Healthcare", icon: "🏥" },
                  { label: "Education", icon: "🎓" },
                  { label: "ERP", icon: "🏢" },
                  { label: "Custom", icon: "✍️" },
                ].map(cat => {
                  const catKey = cat.label;
                  const isActive = workflowCategory === catKey;
                  const count = catKey === "All"
                    ? WORKFLOW_TEMPLATES.length
                    : WORKFLOW_TEMPLATES.filter(t => t.category === catKey).length;
                  return (
                    <div
                      key={catKey}
                      onClick={() => setWorkflowCategory(catKey)}
                      onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = "#f8fafc"; }}
                      onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = "transparent"; }}
                      style={{
                        display: "flex", alignItems: "center", justifyContent: "space-between",
                        padding: "7px 10px", borderRadius: "8px", cursor: "pointer",
                        background: isActive ? "#f0edff" : "transparent",
                        border: isActive ? "1px solid #ddd6fe" : "1px solid transparent",
                        transition: "all 0.15s"
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                        <span style={{ fontSize: "13px" }}>{cat.icon}</span>
                        <span style={{ fontSize: "12px", fontWeight: isActive ? "700" : "500", color: isActive ? "#e05300" : "#475569" }}>
                          {catKey}
                        </span>
                      </div>
                      <span style={{
                        fontSize: "10px", fontWeight: "700",
                        background: isActive ? "#FD6101" : "#e2e8f0",
                        color: isActive ? "#ffffff" : "#64748b",
                        padding: "1px 6px", borderRadius: "10px", minWidth: "18px", textAlign: "center"
                      }}>{count}</span>
                    </div>
                  );
                })}

                <div style={{ borderTop: "1px dashed #e2e8f0", marginTop: "10px", paddingTop: "10px" }}>
                  <div style={{ fontSize: "10px", fontWeight: "700", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "7px" }}>
                    AI GENERATOR
                  </div>
                  <div style={{ background: "#fff7ed", border: "1px dashed #fed7aa", borderRadius: "10px", padding: "10px" }}>
                    <textarea
                      className="gen-textarea"
                      rows="3"
                      value={aiPrompt}
                      onChange={e => setAiPrompt(e.target.value)}
                      placeholder={"Login → Dashboard → Create Lead → Logout"}
                      style={{ width: "100%", padding: "7px", borderRadius: "6px", border: "1px solid #ddd6fe", background: "#ffffff", fontSize: "11px", outline: "none", resize: "none", color: "#0f172a" }}
                    />
                    <button
                      onClick={handleAIGenerateFlow}
                      disabled={isGenerating}
                      onMouseEnter={e => e.currentTarget.style.background = "#e05300"}
                      onMouseLeave={e => e.currentTarget.style.background = "#FD6101"}
                      style={{ width: "100%", marginTop: "7px", background: "#FD6101", color: "#ffffff", border: "none", borderRadius: "6px", padding: "7px 10px", fontWeight: "700", fontSize: "11px", cursor: isGenerating ? "wait" : "pointer", transition: "all 0.15s" }}
                    >
                      {isGenerating ? "Generating..." : "Generate with AI"}
                    </button>
                  </div>
                </div>
              </div>

              {/* RIGHT MAIN CONTENT */}
              <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "12px", overflow: "hidden" }}>

                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <div style={{ flex: 1, position: "relative" }}>
                    <span style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", fontSize: "13px", color: "#94a3b8" }}>🔍</span>
                    <input
                      type="text"
                      placeholder="Search workflows..."
                      value={workflowSearchQuery}
                      onChange={e => setWorkflowSearchQuery(e.target.value)}
                      style={{ width: "100%", padding: "8px 12px 8px 32px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "12px", outline: "none", background: "#ffffff", color: "#0f172a" }}
                    />
                  </div>
                  <div style={{ fontSize: "11px", fontWeight: "700", color: "#FD6101", background: "#f0edff", border: "1px solid #ddd6fe", padding: "6px 10px", borderRadius: "8px", whiteSpace: "nowrap" }}>
                    {WORKFLOW_TEMPLATES.filter(sc => {
                      const s = sc.label.toLowerCase().includes(workflowSearchQuery.toLowerCase()) || sc.desc.toLowerCase().includes(workflowSearchQuery.toLowerCase());
                      const c = workflowCategory === "All" || sc.category === workflowCategory;
                      return s && c;
                    }).length} results
                  </div>
                </div>

                <div style={{ display: "flex", gap: "14px", flex: 1, overflow: "hidden" }}>

                  {/* Cards Grid */}
                  <div style={{
                    flex: selectedScenarioTemplate ? "1.1" : 1,
                    display: "grid",
                    gridTemplateColumns: selectedScenarioTemplate ? "1fr 1fr" : "repeat(3, 1fr)",
                    gap: "10px",
                    alignContent: "start",
                    maxHeight: "360px",
                    overflowY: "auto",
                    paddingRight: "4px",
                    transition: "all 0.3s ease"
                  }}>
                    {WORKFLOW_TEMPLATES.filter(sc => {
                      const s = sc.label.toLowerCase().includes(workflowSearchQuery.toLowerCase()) || sc.desc.toLowerCase().includes(workflowSearchQuery.toLowerCase());
                      const c = workflowCategory === "All" || sc.category === workflowCategory;
                      return s && c;
                    }).map(sc => {
                      const isSelected = selectedScenarioTemplate === sc.type;
                      const isAiRecommended = (selectedTargetType === "rest" && sc.type === "crm") || (selectedTargetType === "website" && sc.type === "ecommerce");
                      const diffColor = sc.difficulty === "Easy"
                        ? { bg: "#ecfdf5", text: "#047857", border: "#a7f3d0" }
                        : sc.difficulty === "Medium"
                          ? { bg: "#fffbeb", text: "#b45309", border: "#fde68a" }
                          : { bg: "#fef2f2", text: "#b91c1c", border: "#fca5a5" };
                      return (
                        <div
                          key={sc.type}
                          onClick={() => setSelectedScenarioTemplate(sc.type)}
                          onMouseEnter={e => {
                            if (!isSelected) {
                              e.currentTarget.style.transform = "translateY(-2px)";
                              e.currentTarget.style.boxShadow = "0 8px 20px rgba(124,58,237,0.1)";
                              e.currentTarget.style.borderColor = "#c4b5fd";
                            }
                          }}
                          onMouseLeave={e => {
                            if (!isSelected) {
                              e.currentTarget.style.transform = "none";
                              e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.04)";
                              e.currentTarget.style.borderColor = "#e2e8f0";
                            }
                          }}
                          style={{
                            padding: "12px",
                            border: isSelected ? "2px solid #FD6101" : "1px solid #e2e8f0",
                            borderRadius: "12px",
                            background: isSelected ? "#fff7ed" : "#ffffff",
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "column",
                            gap: "7px",
                            transition: "all 0.2s ease",
                            boxShadow: isSelected ? "0 0 0 3px rgba(253,97,1,0.1),0 6px 16px rgba(253,97,1,0.07)" : "0 1px 3px rgba(0,0,0,0.04)",
                            position: "relative",
                            minHeight: "110px"
                          }}
                        >
                          {isAiRecommended && (
                            <span style={{ position: "absolute", top: "-9px", right: "8px", background: "#FD6101", color: "#fff", fontSize: "8px", fontWeight: "800", padding: "2px 7px", borderRadius: "10px", boxShadow: "0 2px 6px rgba(253,97,1,0.3)" }}>
                              AI PICK
                            </span>
                          )}
                          {isSelected && (
                            <span style={{ position: "absolute", top: "8px", right: "8px", width: "18px", height: "18px", background: "#FD6101", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", color: "#fff", fontWeight: "800" }}>
                              {"\u2713"}
                            </span>
                          )}
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <div style={{
                              width: "32px", height: "32px", borderRadius: "8px",
                              background: isSelected ? "#FD6101" : "#f1f5f9",
                              color: isSelected ? "#ffffff" : "inherit",
                              display: "flex", alignItems: "center", justifyContent: "center",
                              fontSize: "15px", flexShrink: 0, transition: "all 0.2s",
                              boxShadow: isSelected ? "0 2px 8px rgba(253,97,1,0.25)" : "none"
                            }}>
                              {sc.icon}
                            </div>
                            <div style={{ minWidth: 0 }}>
                              <div style={{ fontSize: "12px", fontWeight: "700", color: isSelected ? "#c2410c" : "#0f172a", lineHeight: "1.2" }}>{sc.label}</div>
                              <div style={{ fontSize: "9px", color: "#94a3b8", marginTop: "1px" }}>{sc.category}</div>
                            </div>
                          </div>
                          <p style={{ fontSize: "10px", color: "#64748b", margin: 0, lineHeight: "1.4" }}>
                            {sc.desc}
                          </p>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "auto", paddingTop: "5px", borderTop: "1px solid #f1f5f9" }}>
                            <span style={{ fontSize: "10px", color: "#64748b" }}>
                              <strong style={{ color: "#0f172a" }}>{sc.estSteps}</strong> steps
                            </span>
                            <span style={{ fontSize: "9px", fontWeight: "700", background: diffColor.bg, color: diffColor.text, border: `1px solid ${diffColor.border}`, padding: "2px 5px", borderRadius: "4px" }}>
                              {sc.difficulty}
                            </span>
                          </div>
                        </div>
                      );
                    })}

                    {WORKFLOW_TEMPLATES.filter(sc => {
                      const s = sc.label.toLowerCase().includes(workflowSearchQuery.toLowerCase()) || sc.desc.toLowerCase().includes(workflowSearchQuery.toLowerCase());
                      const c = workflowCategory === "All" || sc.category === workflowCategory;
                      return s && c;
                    }).length === 0 && (
                        <div style={{ gridColumn: "1 / -1", textAlign: "center", padding: "40px 20px", color: "#94a3b8" }}>
                          <span style={{ fontSize: "30px" }}>🔍</span>
                          <p style={{ marginTop: "10px", fontWeight: "600", fontSize: "13px" }}>No workflows match your search</p>
                          <button onClick={() => { setWorkflowSearchQuery(""); setWorkflowCategory("All"); }} style={{ marginTop: "8px", background: "none", border: "1px solid #cbd5e1", borderRadius: "6px", padding: "5px 12px", fontSize: "11px", cursor: "pointer", color: "#FD6101" }}>
                            Clear Filters
                          </button>
                        </div>
                      )}
                  </div>

                  {/* DETAIL PANEL */}
                  {selectedScenarioTemplate && (() => {
                    const sc = WORKFLOW_TEMPLATES.find(t => t.type === selectedScenarioTemplate);
                    if (!sc) return null;
                    const diffColor = sc.difficulty === "Easy"
                      ? { bg: "#ecfdf5", text: "#047857", border: "#a7f3d0" }
                      : sc.difficulty === "Medium"
                        ? { bg: "#fffbeb", text: "#b45309", border: "#fde68a" }
                        : { bg: "#fef2f2", text: "#b91c1c", border: "#fca5a5" };
                    return (
                      <div style={{ width: "240px", flexShrink: 0, display: "flex", flexDirection: "column", gap: "10px", borderLeft: "1px solid #e2e8f0", paddingLeft: "14px", maxHeight: "360px", overflowY: "auto" }}>
                        <div style={{ background: "#FD6101", borderRadius: "12px", padding: "14px", color: "#ffffff" }}>
                          <div style={{ fontSize: "26px", marginBottom: "5px" }}>{sc.icon}</div>
                          <div style={{ fontSize: "13px", fontWeight: "800", lineHeight: "1.2" }}>{sc.label}</div>
                          <div style={{ fontSize: "10px", marginTop: "3px", opacity: 0.8 }}>{sc.category}</div>
                          <div style={{ display: "flex", gap: "5px", marginTop: "9px", flexWrap: "wrap" }}>
                            <span style={{ background: "rgba(255,255,255,0.2)", borderRadius: "20px", padding: "2px 7px", fontSize: "9px", fontWeight: "700" }}>{sc.estSteps} Steps</span>
                            <span style={{ background: "rgba(255,255,255,0.2)", borderRadius: "20px", padding: "2px 7px", fontSize: "9px", fontWeight: "700" }}>{sc.apiCalls} APIs</span>
                            <span style={{ background: "rgba(255,255,255,0.2)", borderRadius: "20px", padding: "2px 7px", fontSize: "9px", fontWeight: "700" }}>{sc.requests}</span>
                          </div>
                        </div>

                        <div>
                          <div style={{ fontSize: "10px", fontWeight: "700", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "7px" }}>WORKFLOW STEPS</div>
                          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            {sc.steps.map((step, i) => (
                              <div key={i} style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                                <div style={{ width: "20px", height: "20px", borderRadius: "50%", background: "#FD6101", color: "#fff", fontSize: "9px", fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                  {i + 1}
                                </div>
                                <span style={{ fontSize: "11px", fontWeight: "600", color: "#334155" }}>{step}</span>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div>
                          <div style={{ fontSize: "10px", fontWeight: "700", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "7px" }}>CONFIGURATION</div>
                          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            {[
                              { label: "Difficulty", value: sc.difficulty, chip: true },
                              { label: "Auth Required", value: sc.authReq },
                              { label: "Data-Driven", value: sc.dataDriven },
                              { label: "Var Extraction", value: sc.varExtract },
                            ].map(item => (
                              <div key={item.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "6px" }}>
                                <span style={{ fontSize: "10px", color: "#94a3b8", fontWeight: "600", whiteSpace: "nowrap" }}>{item.label}</span>
                                {item.chip ? (
                                  <span style={{ fontSize: "10px", fontWeight: "700", background: diffColor.bg, color: diffColor.text, border: `1px solid ${diffColor.border}`, padding: "1px 5px", borderRadius: "4px" }}>{item.value}</span>
                                ) : (
                                  <span style={{ fontSize: "10px", fontWeight: "600", color: "#334155", textAlign: "right" }}>{item.value}</span>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>

                        <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: "8px", padding: "10px" }}>
                          <div style={{ fontSize: "10px", fontWeight: "700", color: "#166534", marginBottom: "4px" }}>AI Insight</div>
                          <p style={{ fontSize: "10px", color: "#166534", margin: 0, lineHeight: "1.4" }}>
                            {selectedScenarioTemplate === "crm" && "Best for REST API — validates concurrent CRM records and token persistence under load."}
                            {selectedScenarioTemplate === "ecommerce" && "Ideal for website load — simulates checkout flow and inventory validation under spike."}
                            {selectedScenarioTemplate === "login" && "Tests session management overhead and auth database scaling bottlenecks."}
                            {selectedScenarioTemplate === "custom" && "Visual canvas mode — best for ad-hoc endpoints or legacy system workflows."}
                            {!["crm", "ecommerce", "login", "custom"].includes(selectedScenarioTemplate) && "Optimized for high-concurrency business workflow simulation — ready to use."}
                          </p>
                        </div>
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>
          ), wizardStep === 3 && /*#__PURE__*/_jsxDEV("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "24px"
            },
            children: [/*#__PURE__*/_jsxDEV("div", {
              children: [/*#__PURE__*/_jsxDEV("h4", {
                style: {
                  fontSize: "18px",
                  fontWeight: "800",
                  color: "#0f172a",
                  marginBottom: "6px"
                },
                children: "How would you like Qintra to build your workflow?"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1961,
                columnNumber: 21
              }, this), /*#__PURE__*/_jsxDEV("p", {
                style: {
                  margin: 0,
                  fontSize: "13px",
                  color: "#64748b"
                },
                children: "Choose how you want to create your performance test."
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 1962,
                columnNumber: 21
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 1960,
              columnNumber: 19
            }, this), /*#__PURE__*/_jsxDEV("div", {
              style: {
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "16px"
              },
              children: [{
                type: "ai",
                label: "✨ Describe in Plain English",
                isRecommended: true,
                desc: "Simply describe your business process in natural language. Qintra will automatically generate workflow steps, variable extraction, assertion logs, load config, and AI validations."
              }, {
                type: "visual",
                label: "🎨 Build Visually",
                isRecommended: false,
                desc: "Create your workflow manually using Qintra's drag-and-drop visual builder. Perfect for users who prefer visual design."
              }, {
                type: "import",
                label: "📥 Import Existing Workflow",
                isRecommended: false,
                desc: "Import an existing Postman Collection, OpenAPI Specification, Swagger, HAR File, or Qintra JSON configuration."
              }].map(card => {
                const isSelected = selectedBuildMethod === card.type;
                return /*#__PURE__*/_jsxDEV("div", {
                  onClick: () => setSelectedBuildMethod(card.type),
                  onMouseEnter: e => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.borderColor = "#FD6101";
                  },
                  onMouseLeave: e => {
                    e.currentTarget.style.transform = "none";
                    e.currentTarget.style.borderColor = isSelected ? "#FD6101" : "#cbd5e1";
                  },
                  style: {
                    padding: "20px",
                    border: isSelected ? "2px solid #FD6101" : "1px solid #cbd5e1",
                    borderRadius: "12px",
                    background: isSelected ? "#f5f3ff" : "#ffffff",
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    transition: "all 0.2s ease",
                    boxShadow: isSelected ? "0 0 0 3px rgba(124, 58, 237, 0.15), 0 4px 12px rgba(124, 58, 237, 0.05)" : "0 1px 2px rgba(0,0,0,0.02)",
                    position: "relative"
                  },
                  children: [card.isRecommended && /*#__PURE__*/_jsxDEV("span", {
                    style: {
                      position: "absolute",
                      top: "-10px",
                      right: "12px",
                      background: "#FD6101",
                      color: "#ffffff",
                      fontSize: "8px",
                      fontWeight: "700",
                      padding: "2px 6px",
                      borderRadius: "10px",
                      letterSpacing: "0.05em"
                    },
                    children: "\u2B50 RECOMMENDED"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2015,
                    columnNumber: 29
                  }, this), /*#__PURE__*/_jsxDEV("strong", {
                    style: {
                      fontSize: "14px",
                      color: "#0f172a"
                    },
                    children: card.label
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2019,
                    columnNumber: 27
                  }, this), /*#__PURE__*/_jsxDEV("p", {
                    style: {
                      fontSize: "11px",
                      color: "#64748b",
                      margin: 0,
                      lineHeight: "1.4"
                    },
                    children: card.desc
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2020,
                    columnNumber: 27
                  }, this)]
                }, card.type, true, {
                  fileName: _jsxFileName,
                  lineNumber: 1989,
                  columnNumber: 25
                }, this);
              })
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 1966,
              columnNumber: 19
            }, this), selectedBuildMethod === "ai" && /*#__PURE__*/_jsxDEV("div", {
              style: {
                display: "grid",
                gridTemplateColumns: "1.2fr 1fr",
                gap: "24px"
              },
              children: [/*#__PURE__*/_jsxDEV("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px"
                },
                children: [/*#__PURE__*/_jsxDEV("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "6px"
                  },
                  children: [/*#__PURE__*/_jsxDEV("span", {
                    style: {
                      fontSize: "13px",
                      fontWeight: "700",
                      color: "#475569"
                    },
                    children: "Describe Your Workflow"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2032,
                    columnNumber: 27
                  }, this), /*#__PURE__*/_jsxDEV("div", {
                    style: {
                      position: "relative"
                    },
                    children: [/*#__PURE__*/_jsxDEV("textarea", {
                      rows: "6",
                      value: aiPrompt,
                      onChange: e => setAiPrompt(e.target.value),
                      placeholder: `Example:\nUser logs in\nOpens Dashboard\nCreates Lead\nAssigns Lead\nUpdates Lead\nDeletes Lead\nLogs out`,
                      style: {
                        width: "100%",
                        padding: "12px 40px 12px 12px",
                        border: "1px solid #cbd5e1",
                        borderRadius: "8px",
                        fontSize: "12px",
                        outline: "none",
                        background: "#ffffff",
                        minHeight: "130px",
                        lineHeight: "1.5"
                      }
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 2034,
                      columnNumber: 29
                    }, this), /*#__PURE__*/_jsxDEV("button", {
                      onClick: () => {
                        setAiPrompt("100 users log in, open the dashboard, create a lead, update it, and log out.");
                        alert("🎙️ Voice input transcribed successfully:\n\"100 users log in, open the dashboard, create a lead, update it, and log out.\"");
                      },
                      title: "Voice Input",
                      style: {
                        position: "absolute",
                        right: "12px",
                        bottom: "12px",
                        background: "none",
                        border: "none",
                        fontSize: "18px",
                        cursor: "pointer",
                        color: "#FD6101"
                      },
                      children: "\uD83C\uDFA4"
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 2042,
                      columnNumber: 29
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName,
                    lineNumber: 2033,
                    columnNumber: 27
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName,
                  lineNumber: 2031,
                  columnNumber: 25
                }, this), /*#__PURE__*/_jsxDEV("div", {
                  children: [/*#__PURE__*/_jsxDEV("span", {
                    style: {
                      fontSize: "11px",
                      fontWeight: "700",
                      color: "#475569",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      display: "block",
                      marginBottom: "6px"
                    },
                    children: "Quick AI Templates"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2057,
                    columnNumber: 27
                  }, this), /*#__PURE__*/_jsxDEV("div", {
                    style: {
                      display: "flex",
                      gap: "6px",
                      flexWrap: "wrap"
                    },
                    children: [{
                      label: "CRM Workflow",
                      text: "User logs in\nOpens Dashboard\nCreates Lead\nAssigns Lead\nUpdates Lead\nDeletes Lead\nLogs out"
                    }, {
                      label: "Student Portal",
                      text: "Student logs in\nViews course list\nRegisters for subjects\nPays enrollment tuition fee\nDownloads confirmation invoice"
                    }, {
                      label: "Employee Login",
                      text: "Employee opens login page\nEnter employee ID\nSingle sign-on validation\nRetrieve personal profile\nLoad workspace components"
                    }, {
                      label: "E-Commerce Checkout",
                      text: "Visitor browses product catalog\nAdd items to active cart\nProceed to checkout\nEnter payment details\nSettle order charge\nReceive order confirmation email"
                    }, {
                      label: "Patient Registration",
                      text: "Receptionist check-in patient ID\nRetrieve medical records history\nAssign clinical doctor\nLog doctor consultation note\nPrint prescription receipt"
                    }, {
                      label: "Payment Gateway",
                      text: "Merchant requests charge token\nAuthorize customer credit card transaction\nRun 3D secure pin validation\nSettle final transaction payment"
                    }, {
                      label: "Banking Workflow",
                      text: "Customer logs in online balance\nSavings account balance query\nTransfer wire funds to external checking bank\nDownload monthly transaction report"
                    }, {
                      label: "Lead Management",
                      text: "Login CRM portal\nCreate new sales lead record\nAssign territory to lead owner\nConvert lead to customer account\nDelete obsolete lead contact"
                    }].map(chip => /*#__PURE__*/_jsxDEV("button", {
                      onClick: () => setAiPrompt(chip.text),
                      style: {
                        background: "#f1f5f9",
                        color: "#475569",
                        border: "1px solid #e2e8f0",
                        borderRadius: "16px",
                        padding: "4px 10px",
                        fontSize: "10px",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "all 0.15s"
                      },
                      onMouseEnter: e => e.currentTarget.style.background = "#e2e8f0",
                      onMouseLeave: e => e.currentTarget.style.background = "#f1f5f9",
                      children: chip.label
                    }, chip.label, false, {
                      fileName: _jsxFileName,
                      lineNumber: 2069,
                      columnNumber: 31
                    }, this))
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2058,
                    columnNumber: 27
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName,
                  lineNumber: 2056,
                  columnNumber: 25
                }, this), aiPrompt.trim() && /*#__PURE__*/_jsxDEV("div", {
                  style: {
                    background: "#eff6ff",
                    border: "1px solid #bfdbfe",
                    borderRadius: "10px",
                    padding: "12px"
                  },
                  children: [/*#__PURE__*/_jsxDEV("div", {
                    style: {
                      fontSize: "12px",
                      fontWeight: "700",
                      color: "#1e40af"
                    },
                    children: "\uD83D\uDCA1 Smart Suggestions"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2095,
                    columnNumber: 29
                  }, this), /*#__PURE__*/_jsxDEV("div", {
                    style: {
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "6px",
                      fontSize: "10px",
                      color: "#1e3a8a",
                      marginTop: "6px"
                    },
                    children: [/*#__PURE__*/_jsxDEV("div", {
                      children: ["Detected Flow: ", /*#__PURE__*/_jsxDEV("strong", {
                        children: aiPrompt.toLowerCase().includes("lead") ? "CRM Workflow" : aiPrompt.toLowerCase().includes("student") ? "Student Admission" : aiPrompt.toLowerCase().includes("checkout") ? "E-Commerce Journey" : "Authentication Flow"
                      }, void 0, false, {
                        fileName: _jsxFileName,
                        lineNumber: 2097,
                        columnNumber: 51
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName,
                      lineNumber: 2097,
                      columnNumber: 31
                    }, this), /*#__PURE__*/_jsxDEV("div", {
                      children: ["Estimated Steps: ", /*#__PURE__*/_jsxDEV("strong", {
                        children: aiPrompt.split("\n").filter(Boolean).length || 4
                      }, void 0, false, {
                        fileName: _jsxFileName,
                        lineNumber: 2098,
                        columnNumber: 53
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName,
                      lineNumber: 2098,
                      columnNumber: 31
                    }, this), /*#__PURE__*/_jsxDEV("div", {
                      children: ["Auth Required: ", /*#__PURE__*/_jsxDEV("strong", {
                        children: "Yes"
                      }, void 0, false, {
                        fileName: _jsxFileName,
                        lineNumber: 2099,
                        columnNumber: 51
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName,
                      lineNumber: 2099,
                      columnNumber: 31
                    }, this), /*#__PURE__*/_jsxDEV("div", {
                      children: ["CSV Dataset Recommended: ", /*#__PURE__*/_jsxDEV("strong", {
                        children: aiPrompt.toLowerCase().includes("login") ? "Yes (Credentials)" : "No"
                      }, void 0, false, {
                        fileName: _jsxFileName,
                        lineNumber: 2100,
                        columnNumber: 61
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName,
                      lineNumber: 2100,
                      columnNumber: 31
                    }, this), /*#__PURE__*/_jsxDEV("div", {
                      children: ["Build Time: ", /*#__PURE__*/_jsxDEV("strong", {
                        children: "3 seconds"
                      }, void 0, false, {
                        fileName: _jsxFileName,
                        lineNumber: 2101,
                        columnNumber: 48
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName,
                      lineNumber: 2101,
                      columnNumber: 31
                    }, this)]
                  }, void 0, true, {
                    fileName: _jsxFileName,
                    lineNumber: 2096,
                    columnNumber: 29
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName,
                  lineNumber: 2094,
                  columnNumber: 27
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 2030,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("div", {
                style: {
                  background: "#f8fafc",
                  border: "1px solid #cbd5e1",
                  borderRadius: "12px",
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px"
                },
                children: [/*#__PURE__*/_jsxDEV("strong", {
                  style: {
                    fontSize: "13px",
                    color: "#0f172a"
                  },
                  children: "\uD83D\uDEE0\uFE0F Qintra Will Automatically Generate:"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 2109,
                  columnNumber: 25
                }, this), /*#__PURE__*/_jsxDEV("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    fontSize: "12px",
                    color: "#475569"
                  },
                  children: [/*#__PURE__*/_jsxDEV("div", {
                    children: "\u2713 Workflow Steps"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2111,
                    columnNumber: 27
                  }, this), /*#__PURE__*/_jsxDEV("div", {
                    children: "\u2713 Authentication"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2112,
                    columnNumber: 27
                  }, this), /*#__PURE__*/_jsxDEV("div", {
                    children: "\u2713 Assertions"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2113,
                    columnNumber: 27
                  }, this), /*#__PURE__*/_jsxDEV("div", {
                    children: "\u2713 Variables"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2114,
                    columnNumber: 27
                  }, this), /*#__PURE__*/_jsxDEV("div", {
                    children: "\u2713 CSV Dataset Mapping"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2115,
                    columnNumber: 27
                  }, this), /*#__PURE__*/_jsxDEV("div", {
                    children: "\u2713 Headers"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2116,
                    columnNumber: 27
                  }, this), /*#__PURE__*/_jsxDEV("div", {
                    children: "\u2713 AI Validation"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2117,
                    columnNumber: 27
                  }, this), /*#__PURE__*/_jsxDEV("div", {
                    children: "\u2713 Load Configuration"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2118,
                    columnNumber: 27
                  }, this), /*#__PURE__*/_jsxDEV("div", {
                    children: "\u2713 Dependencies"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2119,
                    columnNumber: 27
                  }, this)]
                }, void 0, true, {
                  fileName: _jsxFileName,
                  lineNumber: 2110,
                  columnNumber: 25
                }, this), /*#__PURE__*/_jsxDEV("div", {
                  style: {
                    marginTop: "auto",
                    fontSize: "10px",
                    color: "#94a3b8",
                    borderTop: "1px solid #e2e8f0",
                    paddingTop: "10px"
                  },
                  children: "No HTTP samplers, regular expressions, or manual cookie managers required. Qintra resolves variables dynamically."
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 2121,
                  columnNumber: 25
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 2108,
                columnNumber: 23
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 2028,
              columnNumber: 21
            }, this), selectedBuildMethod === "visual" && /*#__PURE__*/_jsxDEV("div", {
              style: {
                background: "#f8fafc",
                border: "1px solid #cbd5e1",
                borderRadius: "12px",
                padding: "30px",
                textAlign: "center",
                color: "#64748b"
              },
              children: [/*#__PURE__*/_jsxDEV("span", {
                style: {
                  fontSize: "40px"
                },
                children: "\uD83C\uDFA8"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2130,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("h5", {
                style: {
                  margin: "10px 0 6px 0",
                  fontSize: "14px",
                  fontWeight: "800",
                  color: "#0f172a"
                },
                children: "Drag-and-Drop Visual Builder Mode"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2131,
                columnNumber: 23
              }, this), /*#__PURE__*/_jsxDEV("p", {
                style: {
                  margin: 0,
                  fontSize: "12px",
                  color: "#64748b",
                  maxWidth: "450px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  lineHeight: "1.4"
                },
                children: "Perfect for visually planning API dependencies, custom validation conditions, variables extraction, and timing delays step-by-step."
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2132,
                columnNumber: 23
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 2129,
              columnNumber: 21
            }, this), selectedBuildMethod === "import" && /*#__PURE__*/_jsxDEV("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: "16px"
              },
              children: [/*#__PURE__*/_jsxDEV("div", {
                onClick: () => {
                  const mockFiles = ["Postman_Collection.json", "OpenAPI_Specification.yaml", "HAR_Logs.har", "Swagger.json"];
                  const randomFile = mockFiles[Math.floor(Math.random() * mockFiles.length)];
                  setImportedFileName(randomFile);
                  setImportError("");
                  alert(`Mock file selected for import:\n"${randomFile}"`);
                },
                style: {
                  background: "#ffffff",
                  border: "2px dashed #cbd5e1",
                  borderRadius: "12px",
                  padding: "40px 20px",
                  textAlign: "center",
                  cursor: "pointer"
                },
                children: [/*#__PURE__*/_jsxDEV("span", {
                  style: {
                    fontSize: "32px"
                  },
                  children: "\uD83D\uDCE5"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 2151,
                  columnNumber: 25
                }, this), /*#__PURE__*/_jsxDEV("h5", {
                  style: {
                    margin: "10px 0 6px 0",
                    fontSize: "13px",
                    fontWeight: "800",
                    color: "#0f172a"
                  },
                  children: "Drag and drop your API collection or click to upload"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 2152,
                  columnNumber: 25
                }, this), /*#__PURE__*/_jsxDEV("p", {
                  style: {
                    margin: 0,
                    fontSize: "11px",
                    color: "#94a3b8"
                  },
                  children: "Supports Postman Collection v2.1, OpenAPI/Swagger, HAR file, or Qintra JSON"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 2153,
                  columnNumber: 25
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 2141,
                columnNumber: 23
              }, this), importedFileName && /*#__PURE__*/_jsxDEV("div", {
                style: {
                  display: "flex",
                  justifyContent: "space-between",
                  background: "#f0fdf4",
                  border: "1px solid #bbf7d0",
                  padding: "10px 16px",
                  borderRadius: "8px",
                  fontSize: "12px"
                },
                children: [/*#__PURE__*/_jsxDEV("span", {
                  style: {
                    color: "#166534",
                    fontWeight: "600"
                  },
                  children: ["\uD83D\uDCC2 File Loaded: ", importedFileName]
                }, void 0, true, {
                  fileName: _jsxFileName,
                  lineNumber: 2158,
                  columnNumber: 27
                }, this), /*#__PURE__*/_jsxDEV("button", {
                  onClick: () => {
                    setImportedFileName("");
                    setImportError("");
                  },
                  style: {
                    background: "none",
                    border: "none",
                    color: "#ef4444",
                    cursor: "pointer",
                    fontWeight: "700"
                  },
                  children: "Remove"
                }, void 0, false, {
                  fileName: _jsxFileName,
                  lineNumber: 2159,
                  columnNumber: 27
                }, this)]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 2157,
                columnNumber: 25
              }, this), importError && /*#__PURE__*/_jsxDEV("div", {
                style: {
                  background: "#fef2f2",
                  border: "1px solid #fca5a5",
                  padding: "10px 16px",
                  borderRadius: "8px",
                  fontSize: "12px",
                  color: "#991b1b"
                },
                children: ["\u26A0 ", importError]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 2164,
                columnNumber: 25
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 2139,
              columnNumber: 21
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 1959,
            columnNumber: 17
          }, this), wizardStep === 4 && (
            <div style={{ display: "flex", gap: "24px", minHeight: "560px", overflow: "visible", color: "#334155", textAlign: "left" }}>

              {/* Left Column: Figma-Style Visual Flow Canvas (35% width) */}
              <div style={{ flex: "1.2", display: "flex", flexDirection: "column", gap: "16px", borderRight: "1px solid #e2e8f0", paddingRight: "20px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <h4 style={{ margin: 0, fontSize: "14px", fontWeight: "800", color: "#0f172a" }}>Visual Workflow Flow Canvas</h4>
                  <button className="btn-secondary" onClick={handleAddBlankStep} style={{ margin: 0, padding: "4px 10px", fontSize: "12px", borderRadius: "6px" }}>+ Add Step</button>
                </div>

                {/* Vertical scrollable canvas container */}
                <div style={{ display: "flex", flexDirection: "column", gap: "12px", maxHeight: "550px", overflowY: "auto", padding: "4px" }}>
                  {designSteps.map((step, idx) => {
                    const isSelected = selectedStepIdx === idx;
                    const isDisabled = step.disabled === true;
                    const hasGroup = step.group && step.group.trim() !== "";

                    // Render arrows and add step triggers
                    const renderArrow = () => (
                      <div className="flow-arrow-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", position: "relative", height: "32px" }}>
                        <div style={{ width: "2px", height: "100%", background: "#cbd5e1" }}></div>
                        <button
                          onClick={() => handleAddStepAt(idx, "after")}
                          title="Add step here"
                          className="hover-scale"
                          style={{
                            position: "absolute",
                            background: "#FD6101",
                            color: "#ffffff",
                            border: "none",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "12px",
                            cursor: "pointer",
                            boxShadow: "0 2px 4px rgba(124,58,237,0.3)"
                          }}
                        >
                          +
                        </button>
                      </div>
                    );

                    return (
                      <React.Fragment key={idx}>
                        {/* Group Header Wrapper if first in group */}
                        {hasGroup && (idx === 0 || designSteps[idx - 1].group !== step.group) && (
                          <div style={{
                            background: "rgba(124, 58, 237, 0.05)",
                            border: "1px dashed rgba(124, 58, 237, 0.4)",
                            borderRadius: "8px 8px 0 0",
                            padding: "8px 12px",
                            fontSize: "12px",
                            fontWeight: "800",
                            color: "#e05300",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "-6px"
                          }}>
                            <span>📦 Group: {step.group}</span>
                            <button
                              onClick={() => {
                                const collapseState = !collapsedGroups[step.group];
                                setCollapsedGroups({ ...collapsedGroups, [step.group]: collapseState });
                              }}
                              style={{ background: "none", border: "none", color: "#e05300", cursor: "pointer", fontWeight: "700" }}
                            >
                              {collapsedGroups[step.group] ? "Expand" : "Collapse"}
                            </button>
                          </div>
                        )}

                        {/* Card element - Hidden if parent group is collapsed */}
                        {(!hasGroup || !collapsedGroups[step.group]) && (
                          <div
                            onClick={() => setSelectedStepIdx(idx)}
                            className="hover-scale"
                            style={{
                              padding: "16px",
                              background: isSelected ? "#f5f3ff" : "#ffffff",
                              border: isSelected ? "2px solid #FD6101" : "1px solid #cbd5e1",
                              borderRadius: "8px",
                              cursor: "pointer",
                              boxShadow: isSelected ? "0 4px 12px rgba(124, 58, 237, 0.1)" : "0 1px 3px rgba(0,0,0,0.05)",
                              opacity: isDisabled ? 0.6 : 1,
                              transition: "all 0.15s ease"
                            }}
                          >
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <strong style={{
                                fontSize: "13px",
                                color: "#0f172a",
                                textDecoration: isDisabled ? "line-through" : "none"
                              }}>
                                {step.name}
                              </strong>
                              {isDisabled && (
                                <span style={{ fontSize: "9px", background: "#ef4444", color: "#ffffff", padding: "1px 4px", borderRadius: "3px", fontWeight: "700" }}>
                                  Disabled
                                </span>
                              )}
                              {userMode !== "beginner" && !isDisabled && (
                                <span style={{ fontSize: "9px", background: "#e2e8f0", padding: "1px 5px", borderRadius: "4px", fontWeight: "700", color: "#475569" }}>
                                  {step.method}
                                </span>
                              )}
                            </div>

                            <div style={{ fontSize: "11px", color: "#64748b", marginTop: "4px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              Endpoint: {step.path}
                            </div>

                            {/* Card toolbar actions */}
                            <div style={{ display: "flex", gap: "10px", marginTop: "8px", justifyContent: "flex-end" }} onClick={e => e.stopPropagation()}>
                              <button onClick={() => shiftStepOrder(idx, -1)} disabled={idx === 0} style={{ border: "none", background: "none", cursor: idx === 0 ? "not-allowed" : "pointer", fontSize: "11px", color: "#64748b" }} title="Move Up">{"\u25B2"}</button>
                              <button onClick={() => shiftStepOrder(idx, 1)} disabled={idx === designSteps.length - 1} style={{ border: "none", background: "none", cursor: idx === designSteps.length - 1 ? "not-allowed" : "pointer", fontSize: "11px", color: "#64748b" }} title="Move Down">{"\u25BC"}</button>
                              <button
                                onClick={() => {
                                  const updated = [...designSteps];
                                  updated[idx].disabled = !isDisabled;
                                  setDesignSteps(updated);
                                }}
                                style={{ border: "none", background: "none", cursor: "pointer", fontSize: "11px", color: "#475569" }}
                                title={isDisabled ? "Enable Step" : "Disable Step"}
                              >
                                {isDisabled ? "👁️ Enable" : "👁️‍🗨️ Disable"}
                              </button>
                              <button onClick={() => handleCloneStep(idx)} style={{ border: "none", background: "none", cursor: "pointer", fontSize: "11px", color: "#FD6101", fontWeight: "600" }} title="Clone Step">Clone</button>
                              <button onClick={() => handleDeleteStep(idx)} style={{ border: "none", background: "none", cursor: "pointer", fontSize: "11px", color: "#ef4444", fontWeight: "600" }} title="Delete Step">Delete</button>
                            </div>
                          </div>
                        )}

                        {idx < designSteps.length - 1 && renderArrow()}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>

              {/* Middle Column: Collapsible Drawer step configuration accordions (40% width) */}
              <div style={{ flex: "1.4", display: "flex", flexDirection: "column", gap: "12px", borderRight: "1px solid #e2e8f0", paddingRight: "20px" }}>
                {designSteps[selectedStepIdx] ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>

                    {/* Header */}
                    <div style={{ borderBottom: "1px solid #cbd5e1", paddingBottom: "10px" }}>
                      <span style={{ fontSize: "11px", fontWeight: "700", textTransform: "uppercase", color: "#FD6101", letterSpacing: "0.05em" }}>
                        Step Config Drawer
                      </span>
                      <h4 style={{ margin: "2px 0 0 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>
                        {designSteps[selectedStepIdx].name}
                      </h4>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", gap: "10px", maxHeight: "500px", overflowY: "auto", paddingRight: "4px" }}>

                      {/* Section 1: Basic Information (Always open by default) */}
                      <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", overflow: "hidden" }}>
                        <div
                          onClick={() => setExpandedSections({ ...expandedSections, basic: !expandedSections.basic })}
                          style={{ background: "#f8fafc", padding: "10px 14px", fontWeight: "700", fontSize: "13px", display: "flex", justifyItems: "center", justifyContent: "space-between", cursor: "pointer" }}
                        >
                          <span>📄 Basic Information</span>
                          <span>{expandedSections.basic ? "\u25BC" : "\u25B6"}</span>
                        </div>
                        {expandedSections.basic && (
                          <div style={{ padding: "14px", display: "flex", flexDirection: "column", gap: "10px", background: "#ffffff" }}>
                            <div>
                              <label style={{ display: "block", fontSize: "11px", fontWeight: "600", marginBottom: "4px", color: "#475569" }}>Step Name</label>
                              <input
                                type="text"
                                className="gen-input"
                                value={designSteps[selectedStepIdx].name}
                                onChange={e => {
                                  const updated = [...designSteps];
                                  updated[selectedStepIdx].name = e.target.value;
                                  setDesignSteps(updated);
                                }}
                              />
                            </div>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: "10px" }}>
                              <div>
                                <label style={{ display: "block", fontSize: "11px", fontWeight: "600", marginBottom: "4px", color: "#475569" }}>Request Type</label>
                                <select
                                  className="gen-select"
                                  value={designSteps[selectedStepIdx].method}
                                  onChange={e => {
                                    const updated = [...designSteps];
                                    updated[selectedStepIdx].method = e.target.value;
                                    setDesignSteps(updated);
                                  }}
                                >
                                  <option value="GET">GET</option>
                                  <option value="POST">POST</option>
                                  <option value="PUT">PUT</option>
                                  <option value="DELETE">DELETE</option>
                                </select>
                              </div>
                              <div>
                                <label style={{ display: "block", fontSize: "11px", fontWeight: "600", marginBottom: "4px", color: "#475569" }}>API Path / Endpoint</label>
                                <input
                                  type="text"
                                  className="gen-input"
                                  placeholder="e.g. /api/users"
                                  value={designSteps[selectedStepIdx].path}
                                  onChange={e => {
                                    const updated = [...designSteps];
                                    updated[selectedStepIdx].path = e.target.value;
                                    setDesignSteps(updated);
                                  }}
                                />
                              </div>
                            </div>
                            <div>
                              <label style={{ display: "block", fontSize: "11px", fontWeight: "600", marginBottom: "4px", color: "#475569" }}>Description / Purpose</label>
                              <textarea
                                rows="2"
                                className="gen-textarea"
                                placeholder="What does this step accomplish?"
                                value={designSteps[selectedStepIdx].description || ""}
                                onChange={e => {
                                  const updated = [...designSteps];
                                  updated[selectedStepIdx].description = e.target.value;
                                  setDesignSteps(updated);
                                }}
                                style={{ minHeight: "45px" }}
                              />
                            </div>
                            {/* Group Mapping Helper */}
                            {userMode !== "beginner" && (
                              <div>
                                <label style={{ display: "block", fontSize: "11px", fontWeight: "600", marginBottom: "4px", color: "#475569" }}>Visual Group Folder (Transaction)</label>
                                <input
                                  type="text"
                                  className="gen-input"
                                  placeholder="e.g. Authentication Flow"
                                  value={designSteps[selectedStepIdx].group || ""}
                                  onChange={e => {
                                    const updated = [...designSteps];
                                    updated[selectedStepIdx].group = e.target.value;
                                    setDesignSteps(updated);
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {/* Section 2: Authentication (Intermediate & Expert only) */}
                      {userMode !== "beginner" && (
                        <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", overflow: "hidden" }}>
                          <div
                            onClick={() => setExpandedSections({ ...expandedSections, auth: !expandedSections.auth })}
                            style={{ background: "#f8fafc", padding: "10px 14px", fontWeight: "700", fontSize: "13px", display: "flex", justifyItems: "center", justifyContent: "space-between", cursor: "pointer" }}
                          >
                            <span>🔑 Authentication Setup</span>
                            <span>{expandedSections.auth ? "\u25BC" : "\u25B6"}</span>
                          </div>
                          {expandedSections.auth && (
                            <div style={{ padding: "14px", display: "flex", flexDirection: "column", gap: "12px", background: "#ffffff" }}>
                              <div>
                                <label style={{ display: "block", fontSize: "11px", fontWeight: "600", marginBottom: "4px", color: "#475569" }}>Auth Method</label>
                                <select
                                  className="gen-select"
                                  value={designSteps[selectedStepIdx].auth_type || "none"}
                                  onChange={e => {
                                    const updated = [...designSteps];
                                    updated[selectedStepIdx].auth_type = e.target.value;

                                    // Inject standard variables mapping headers automatically
                                    if (e.target.value === "bearer") {
                                      updated[selectedStepIdx].headers = '{"Authorization": "Bearer ${token}", "Content-Type": "application/json"}';
                                    } else if (e.target.value === "basic") {
                                      updated[selectedStepIdx].headers = '{"Authorization": "Basic ${basic_auth_credentials}", "Content-Type": "application/json"}';
                                    } else if (e.target.value === "apikey") {
                                      updated[selectedStepIdx].headers = '{"X-API-Key": "${api_key}"}';
                                    } else {
                                      updated[selectedStepIdx].headers = '{"Content-Type": "application/json"}';
                                    }
                                    setDesignSteps(updated);
                                  }}
                                >
                                  <option value="none">No Auth (Inherit / Public API)</option>
                                  <option value="bearer">Bearer Token (JWT Variable Mapping)</option>
                                  <option value="basic">Basic Auth (Username / Password)</option>
                                  <option value="apikey">API Key Header Token</option>
                                  <option value="cookie">Session Cookie Auth</option>
                                </select>
                              </div>
                              {designSteps[selectedStepIdx].auth_type === "bearer" && (
                                <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", padding: "10px", borderRadius: "6px", fontSize: "11px", color: "#166534" }}>
                                  💡 <strong>Bearer token automatic mapping:</strong> Authorization header mapped to variable <code>{"${token}"}</code>.
                                </div>
                              )}
                              {designSteps[selectedStepIdx].auth_type === "basic" && (
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                                  <div>
                                    <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "2px" }}>Username</label>
                                    <input type="text" className="gen-input" placeholder="${email}" style={{ fontSize: "11px" }} />
                                  </div>
                                  <div>
                                    <label style={{ display: "block", fontSize: "10px", fontWeight: "600", marginBottom: "2px" }}>Password</label>
                                    <input type="password" className="gen-input" placeholder="${password}" style={{ fontSize: "11px" }} />
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}

                      {/* Section 3: Request Configuration (Parameters, Headers, Body) */}
                      <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", overflow: "hidden" }}>
                        <div
                          onClick={() => setExpandedSections({ ...expandedSections, request: !expandedSections.request })}
                          style={{ background: "#f8fafc", padding: "10px 14px", fontWeight: "700", fontSize: "13px", display: "flex", justifyItems: "center", justifyContent: "space-between", cursor: "pointer" }}
                        >
                          <span>⚙️ Request Configuration</span>
                          <span>{expandedSections.request ? "▼" : "▶"}</span>
                        </div>
                        {expandedSections.request && (
                          <div style={{ padding: "14px", display: "flex", flexDirection: "column", gap: "12px", background: "#ffffff" }}>

                            {/* Headers override - Expert only */}
                            {userMode === "expert" ? (
                              <div>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                  <label style={{ display: "block", fontSize: "11px", fontWeight: "600", marginBottom: "4px", color: "#475569" }}>Headers JSON Override</label>
                                  <span style={{ fontSize: "9px", color: "var(--primary)", fontWeight: "600" }}>Expert Mode</span>
                                </div>
                                <textarea
                                  className="gen-textarea"
                                  rows="2"
                                  value={designSteps[selectedStepIdx].headers}
                                  onChange={e => {
                                    const updated = [...designSteps];
                                    updated[selectedStepIdx].headers = e.target.value;
                                    setDesignSteps(updated);
                                  }}
                                  style={{ fontFamily: "monospace", fontSize: "11px" }}
                                />
                              </div>
                            ) : (
                              <div style={{ fontSize: "11px", color: "#64748b" }}>
                                ⚙️ Headers are automatically managed based on Auth Type (Beginner/Intermediate Mode).
                              </div>
                            )}

                            {/* Request Body Payload */}
                            {["POST", "PUT"].includes(designSteps[selectedStepIdx].method) && (
                              <div>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "4px" }}>
                                  <label style={{ display: "block", fontSize: "11px", fontWeight: "600", color: "#475569" }}>JSON Request Body</label>
                                  <button
                                    className="btn-secondary"
                                    onClick={() => {
                                      // AI Simulator Body generation
                                      const updated = [...designSteps];
                                      const stepName = updated[selectedStepIdx].name.toLowerCase();
                                      if (stepName.includes("login")) {
                                        updated[selectedStepIdx].body = '{\n  "email": "${email}",\n  "password": "${password}"\n}';
                                      } else {
                                        updated[selectedStepIdx].body = '{\n  "name": "New Record Item",\n  "status": "active"\n}';
                                      }
                                      setDesignSteps(updated);
                                      alert("Qintra generated a mock JSON body payload for this step!");
                                    }}
                                    style={{ margin: 0, padding: "2px 6px", fontSize: "10px" }}
                                  >
                                    ✨ Generate with AI
                                  </button>
                                </div>
                                <textarea
                                  className="gen-textarea"
                                  rows="4"
                                  placeholder="Enter raw JSON body..."
                                  value={designSteps[selectedStepIdx].body || ""}
                                  onChange={e => {
                                    const updated = [...designSteps];
                                    updated[selectedStepIdx].body = e.target.value;
                                    setDesignSteps(updated);
                                  }}
                                  style={{ fontFamily: "monospace", fontSize: "11px" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {/* Section 4: Validate Response (Assertions - Intermediate & Expert only) */}
                      {userMode !== "beginner" && (
                        <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", overflow: "hidden" }}>
                          <div
                            onClick={() => setExpandedSections({ ...expandedSections, validation: !expandedSections.validation })}
                            style={{ background: "#f8fafc", padding: "10px 14px", fontWeight: "700", fontSize: "13px", display: "flex", justifyItems: "center", justifyContent: "space-between", cursor: "pointer" }}
                          >
                            <span>✅ Validate Response (Assertions)</span>
                            <span>{expandedSections.validation ? "\u25BC" : "\u25B6"}</span>
                          </div>
                          {expandedSections.validation && (
                            <div style={{ padding: "14px", display: "flex", flexDirection: "column", gap: "12px", background: "#ffffff" }}>

                              <div style={{ display: "flex", flexDirection: "column", gap: "8px", fontSize: "12px" }}>
                                <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                                  <input
                                    type="checkbox"
                                    checked={designSteps[selectedStepIdx].assertions?.includes("status_code")}
                                    onChange={(e) => {
                                      const updated = [...designSteps];
                                      let list = [];
                                      try {
                                        list = JSON.parse(updated[selectedStepIdx].assertions || "[]");
                                      } catch (ex) { list = []; }
                                      if (e.target.checked) {
                                        if (!list.some(x => x.type === "status_code")) {
                                          list.push({ type: "status_code", expected_value: "200" });
                                        }
                                      } else {
                                        list = list.filter(x => x.type !== "status_code");
                                      }
                                      updated[selectedStepIdx].assertions = JSON.stringify(list);
                                      setDesignSteps(updated);
                                    }}
                                  />
                                  <span>Verify HTTP Status Code is 200 (Success)</span>
                                </label>

                                <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                                  <input
                                    type="checkbox"
                                    checked={designSteps[selectedStepIdx].assertions?.includes("response_time")}
                                    onChange={(e) => {
                                      const updated = [...designSteps];
                                      let list = [];
                                      try {
                                        list = JSON.parse(updated[selectedStepIdx].assertions || "[]");
                                      } catch (ex) { list = []; }
                                      if (e.target.checked) {
                                        if (!list.some(x => x.type === "response_time")) {
                                          list.push({ type: "response_time", expected_value: "1000" });
                                        }
                                      } else {
                                        list = list.filter(x => x.type !== "response_time");
                                      }
                                      updated[selectedStepIdx].assertions = JSON.stringify(list);
                                      setDesignSteps(updated);
                                    }}
                                  />
                                  <span>Verify Response Time limit is below 1,000 ms</span>
                                </label>

                                <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                                  <input
                                    type="checkbox"
                                    checked={designSteps[selectedStepIdx].assertions?.includes("text_contains")}
                                    onChange={(e) => {
                                      const updated = [...designSteps];
                                      let list = [];
                                      try {
                                        list = JSON.parse(updated[selectedStepIdx].assertions || "[]");
                                      } catch (ex) { list = []; }
                                      if (e.target.checked) {
                                        if (!list.some(x => x.type === "text_contains")) {
                                          list.push({ type: "text_contains", expected_value: "success" });
                                        }
                                      } else {
                                        list = list.filter(x => x.type !== "text_contains");
                                      }
                                      updated[selectedStepIdx].assertions = JSON.stringify(list);
                                      setDesignSteps(updated);
                                    }}
                                  />
                                  <span>Verify Response Contains specific text</span>
                                </label>

                                {designSteps[selectedStepIdx].assertions?.includes("text_contains") && (
                                  <input
                                    type="text"
                                    className="gen-input"
                                    placeholder="Enter search text (e.g. success, id)"
                                    style={{ fontSize: "11px", padding: "6px", marginLeft: "22px" }}
                                    onChange={(e) => {
                                      const updated = [...designSteps];
                                      let list = JSON.parse(updated[selectedStepIdx].assertions);
                                      const match = list.find(x => x.type === "text_contains");
                                      if (match) match.expected_value = e.target.value;
                                      updated[selectedStepIdx].assertions = JSON.stringify(list);
                                      setDesignSteps(updated);
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                      {/* Section 5: Capture Values (Variables Extraction - Intermediate & Expert only) */}
                      {userMode !== "beginner" && (
                        <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", overflow: "hidden" }}>
                          <div
                            onClick={() => setExpandedSections({ ...expandedSections, capture: !expandedSections.capture })}
                            style={{ background: "#f8fafc", padding: "10px 14px", fontWeight: "700", fontSize: "13px", display: "flex", justifyItems: "center", justifyContent: "space-between", cursor: "pointer" }}
                          >
                            <span>🎯 Capture Response Values (Correlation)</span>
                            <span>{expandedSections.capture ? "\u25BC" : "\u25B6"}</span>
                          </div>
                          {expandedSections.capture && (
                            <div style={{ padding: "14px", display: "flex", flexDirection: "column", gap: "10px", background: "#ffffff" }}>

                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <span style={{ fontSize: "11px", color: "#64748b" }}>Auto-capture variables by simulating a single request call:</span>
                                <button
                                  className="btn-secondary"
                                  onClick={() => {
                                    setIsSimulating(true);
                                    setTimeout(() => {
                                      setSimulatedResponse({
                                        token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
                                        user_id: 2984,
                                        session: "sess_8ah3j2m9sa8",
                                        status: "logged_in"
                                      });
                                      setIsSimulating(false);
                                    }, 1000);
                                  }}
                                  style={{ margin: 0, padding: "2px 8px", fontSize: "10px" }}
                                >
                                  {isSimulating ? "Simulating..." : "⚡ Simulate Request"}
                                </button>
                              </div>

                              {simulatedResponse && (
                                <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", padding: "10px", borderRadius: "6px", fontSize: "11px" }}>
                                  <div style={{ fontWeight: "700", marginBottom: "4px", color: "#475569" }}>Click elements below to capture variables:</div>
                                  <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "6px" }}>
                                    {Object.keys(simulatedResponse).map((key) => (
                                      <button
                                        key={key}
                                        onClick={() => {
                                          const updated = [...designSteps];
                                          let list = [];
                                          try {
                                            list = JSON.parse(updated[selectedStepIdx].extractors || "[]");
                                          } catch (ex) { list = []; }
                                          if (!list.some(x => x.variable_name === key)) {
                                            list.push({ type: "json", expression: `$.${key}`, variable_name: key });
                                          }
                                          updated[selectedStepIdx].extractors = JSON.stringify(list);
                                          setDesignSteps(updated);
                                          alert(`Correlation added: Successfully captured '${key}' to variable \${${key}}`);
                                        }}
                                        style={{ fontSize: "10px", padding: "2px 6px", border: "1px solid #cbd5e1", borderRadius: "4px", background: "#ffffff", cursor: "pointer" }}
                                      >
                                        🔑 {key}: "{simulatedResponse[key].toString().substring(0, 10)}..."
                                      </button>
                                    ))}
                                  </div>
                                </div>
                              )}

                              {/* Manual Extractor List */}
                              <div style={{ fontSize: "11px", color: "#475569" }}>
                                <strong>Active Captured Variables:</strong>
                                <div style={{ display: "flex", flexDirection: "column", gap: "4px", marginTop: "4px" }}>
                                  {(() => {
                                    let list = [];
                                    try {
                                      list = JSON.parse(designSteps[selectedStepIdx].extractors || "[]");
                                    } catch (ex) { }
                                    if (list.length === 0) return <span style={{ fontStyle: "italic", color: "#94a3b8" }}>No variables captured from this response yet.</span>;
                                    return list.map((ext, idx) => (
                                      <div key={idx} style={{ background: "#f1f5f9", padding: "3px 6px", borderRadius: "4px", display: "flex", justifyContent: "space-between" }}>
                                        <span><code>{"${" + ext.variable_name + "}"}</code> maps to <code>{ext.expression}</code></span>
                                        <button
                                          onClick={() => {
                                            const updated = [...designSteps];
                                            let subList = JSON.parse(updated[selectedStepIdx].extractors);
                                            subList = subList.filter((_, i) => i !== idx);
                                            updated[selectedStepIdx].extractors = JSON.stringify(subList);
                                            setDesignSteps(updated);
                                          }}
                                          style={{ border: "none", background: "none", color: "#ef4444", cursor: "pointer", fontSize: "9px" }}
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    ));
                                  })()}
                                </div>
                              </div>

                            </div>
                          )}
                        </div>
                      )}

                      {/* Section 6: Advanced (Think Time - Expert only) */}
                      {userMode === "expert" && (
                        <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", overflow: "hidden" }}>
                          <div
                            onClick={() => setExpandedSections({ ...expandedSections, advanced: !expandedSections.advanced })}
                            style={{ background: "#f8fafc", padding: "10px 14px", fontWeight: "700", fontSize: "13px", display: "flex", justifyItems: "center", justifyContent: "space-between", cursor: "pointer" }}
                          >
                            <span>🕒 Advanced Configuration (Timers)</span>
                            <span>{expandedSections.advanced ? "\u25BC" : "\u25B6"}</span>
                          </div>
                          {expandedSections.advanced && (
                            <div style={{ padding: "14px", display: "flex", flexDirection: "column", gap: "10px", background: "#ffffff" }}>
                              <div>
                                <label style={{ display: "block", fontSize: "11px", fontWeight: "600", marginBottom: "4px", color: "#475569" }}>Think Time Delay before next call (seconds)</label>
                                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                  <input
                                    type="range"
                                    min="0"
                                    max="10"
                                    step="1"
                                    value={designSteps[selectedStepIdx].think_time || 0}
                                    onChange={e => {
                                      const updated = [...designSteps];
                                      updated[selectedStepIdx].think_time = parseInt(e.target.value) || 0;
                                      setDesignSteps(updated);
                                    }}
                                    style={{ flex: 1 }}
                                  />
                                  <span style={{ fontSize: "12px", fontWeight: "700" }}>{designSteps[selectedStepIdx].think_time}s</span>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                    </div>
                  </div>
                ) : (
                  <div style={{ textAlign: "center", color: "var(--text-muted)", padding: "40px 0" }}>
                    Select a step card to edit properties.
                  </div>
                )}

                {/* CSV Dataset Mapping Container (Intermediate & Expert only) */}
                {userMode !== "beginner" && (
                  <div style={{ background: "#f8fafc", padding: "16px", borderRadius: "8px", border: "1px solid #cbd5e1", marginTop: "auto" }}>
                    <strong style={{ fontSize: "12px", display: "block", marginBottom: "8px", color: "#334155" }}>📁 CSV Dataset Mapper</strong>

                    {csvConfig.map((csv, i) => (
                      <div key={i} style={{ display: "flex", justifyContent: "space-between", background: "#ffffff", padding: "6px 10px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: "11px", marginBottom: "8px" }}>
                        <span>📁 {csv.filename} (Mapped columns: {csv.columns?.join(", ")})</span>
                        <button onClick={() => handleRemoveCSV(i)} style={{ border: "none", background: "none", color: "#ef4444", cursor: "pointer", fontWeight: "700" }}>Remove</button>
                      </div>
                    ))}

                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                      {/* Simulated drag-and-drop file upload */}
                      <button
                        className="btn-secondary"
                        onClick={() => {
                          // Simulate loading data.csv
                          setCsvConfig([{
                            filename: "data.csv",
                            content: "email,password\nadmin@rabbit.app,Admin@123\nuser@rabbit.app,User@123",
                            scope: "vu",
                            columns: ["email", "password"]
                          }]);
                          alert("CSV Dataset successfully uploaded and parsed!");
                        }}
                        style={{ width: "100%", border: "2px dashed #FD6101", background: "rgba(124, 58, 237, 0.02)", color: "#FD6101", padding: "12px", borderRadius: "6px", display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}
                      >
                        <span style={{ fontSize: "18px" }}>📤</span>
                        <span style={{ fontSize: "11px", fontWeight: "700" }}>Upload / Drop CSV File</span>
                        <span style={{ fontSize: "9px", color: "#64748b" }}>Loads dataset records dynamically</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Right Column: Pre-Flight checklist and Live statistics sidebar (25% width) */}
              <div style={{ flex: "0.9", display: "flex", flexDirection: "column", gap: "16px" }}>

                {/* Stats Panel */}
                <div style={{ background: "#f8fafc", padding: "16px", borderRadius: "8px", border: "1px solid #cbd5e1" }}>
                  <strong style={{ fontSize: "12px", display: "block", marginBottom: "8px", color: "#0f172a" }}>📊 Live Workflow Preview</strong>
                  <div style={{ display: "flex", flexDirection: "column", gap: "6px", fontSize: "11px", color: "#475569" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Workflow Steps:</span>
                      <strong style={{ color: "#0f172a" }}>{designSteps.filter(x => !x.disabled).length} steps</strong>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Auth Configuration:</span>
                      <strong style={{ color: "#16a34a" }}>
                        {designSteps.some(s => s.auth_type && s.auth_type !== "none") ? "Configured" : "None"}
                      </strong>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>CSV Datasets:</span>
                      <strong style={{ color: "#0f172a" }}>{csvConfig.length} datasets</strong>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>RPS Estimate:</span>
                      <strong style={{ color: "#FD6101" }}>
                        {Math.round(parseInt(testForm.vu_count || 50) * 1.5)} RPS
                      </strong>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Estimated Duration:</span>
                      <strong style={{ color: "#0f172a" }}>{testForm.steady_state_duration || 20}s</strong>
                    </div>
                  </div>
                </div>

                {/* Validation checklist */}
                <div style={{ background: "#fffbeb", padding: "16px", borderRadius: "8px", border: "1px solid #fef3c7" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                    <strong style={{ fontSize: "12px", color: "#b45309" }}>⚡ Qintra Smart Checklist</strong>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    {getSmartChecklist().length === 0 ? (
                      <span style={{ fontSize: "11px", color: "#166534", fontWeight: "700" }}>
                        ✓ Workflow fully correlation-optimized!
                      </span>
                    ) : (
                      getSmartChecklist().map((err, i) => (
                        <div key={i} style={{ display: "flex", flexDirection: "column", gap: "4px", background: "#ffffff", padding: "8px 10px", borderRadius: "6px", fontSize: "11px", border: "1px solid #fca5a5" }}>
                          <span style={{ color: "#b91c1c", fontWeight: "600" }}>⚠️ {err.msg}</span>
                          <button
                            onClick={err.action}
                            style={{
                              border: "none",
                              background: "#f0fdf4",
                              color: "#15803d",
                              fontWeight: "700",
                              cursor: "pointer",
                              padding: "4px 8px",
                              borderRadius: "4px",
                              fontSize: "10px",
                              alignSelf: "flex-end",
                              border: "1px solid #bbf7d0"
                            }}
                          >
                            Auto-Fix: {err.fix}
                          </button>
                        </div>
                      ))
                    )}
                  </div>
                </div>

              </div>

            </div>
          )]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 1505,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            padding: "16px 24px",
            borderTop: "1px solid #cbd5e1",
            background: "#f8fafc",
            borderRadius: "0 0 12px 12px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          },
          children: [/*#__PURE__*/_jsxDEV("div", {
            children: wizardStep > 1 && /*#__PURE__*/_jsxDEV("button", {
              onClick: () => setWizardStep(wizardStep - 1),
              onMouseEnter: e => {
                e.currentTarget.style.background = "#f1f5f9";
                e.currentTarget.style.borderColor = "#94a3b8";
              },
              onMouseLeave: e => {
                e.currentTarget.style.background = "#ffffff";
                e.currentTarget.style.borderColor = "#cbd5e1";
              },
              style: {
                background: "#ffffff",
                color: "#475569",
                border: "1px solid #cbd5e1",
                borderRadius: "8px",
                padding: "8px 16px",
                fontWeight: "600",
                fontSize: "13px",
                cursor: "pointer",
                transition: "all 0.15s"
              },
              children: "\u2190 Back"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2437,
              columnNumber: 19
            }, this)
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 2435,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("div", {
            style: {
              display: "flex",
              gap: "12px"
            },
            children: [/*#__PURE__*/_jsxDEV("button", {
              onClick: () => {
                setIsCreating(false);
                setAuthorized(true);
                setWizardStep(1);
              },
              onMouseEnter: e => {
                e.currentTarget.style.background = "#f1f5f9";
              },
              onMouseLeave: e => {
                e.currentTarget.style.background = "#ffffff";
              },
              style: {
                background: "#ffffff",
                color: "#64748b",
                border: "1px solid #cbd5e1",
                borderRadius: "8px",
                padding: "8px 16px",
                fontWeight: "600",
                fontSize: "13px",
                cursor: "pointer",
                transition: "all 0.15s"
              },
              children: "Cancel"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2464,
              columnNumber: 17
            }, this), false && wizardStep === 2 && /*#__PURE__*/_jsxDEV("button", {
              onClick: () => {
                alert("Draft Saved successfully! You can resume building anytime.");
              },
              onMouseEnter: e => {
                e.currentTarget.style.background = "#f1f5f9";
                e.currentTarget.style.borderColor = "#94a3b8";
              },
              onMouseLeave: e => {
                e.currentTarget.style.background = "#ffffff";
                e.currentTarget.style.borderColor = "#cbd5e1";
              },
              style: {
                background: "#ffffff",
                color: "#475569",
                border: "1px solid #cbd5e1",
                borderRadius: "8px",
                padding: "8px 16px",
                fontWeight: "600",
                fontSize: "13px",
                cursor: "pointer",
                transition: "all 0.15s"
              },
              children: "Save Draft"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2489,
              columnNumber: 19
            }, this), wizardStep === 2 ? /*#__PURE__*/_jsxDEV("button", {
              disabled: !selectedScenarioTemplate,
              onClick: () => {
                const steps = getStepsForTemplate(selectedScenarioTemplate);
                setDesignSteps(steps);
                setWizardStep(3);
              },
              onMouseEnter: e => {
                if (selectedScenarioTemplate) {
                  e.currentTarget.style.background = "#e05300";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(109, 40, 217, 0.25)";
                }
              },
              onMouseLeave: e => {
                if (selectedScenarioTemplate) {
                  e.currentTarget.style.background = "#FD6101";
                  e.currentTarget.style.boxShadow = "0 2px 4px rgba(124, 58, 237, 0.15)";
                }
              },
              style: {
                background: selectedScenarioTemplate ? "#FD6101" : "#e2e8f0",
                color: selectedScenarioTemplate ? "#ffffff" : "#94a3b8",
                border: "none",
                borderRadius: "8px",
                padding: "8px 20px",
                fontWeight: "600",
                fontSize: "13px",
                cursor: selectedScenarioTemplate ? "pointer" : "not-allowed",
                boxShadow: selectedScenarioTemplate ? "0 2px 4px rgba(124, 58, 237, 0.15)" : "none",
                transition: "all 0.15s"
              },
              children: "Continue \u2192"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2518,
              columnNumber: 19
            }, this) : wizardStep === 3 ? selectedBuildMethod === "ai" ? /*#__PURE__*/_jsxDEV("button", {
              disabled: !aiPrompt.trim() || isGenerating,
              onClick: handleAIGenerateFlow,
              onMouseEnter: e => {
                if (aiPrompt.trim()) {
                  e.currentTarget.style.background = "#e05300";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(109, 40, 217, 0.25)";
                }
              },
              onMouseLeave: e => {
                if (aiPrompt.trim()) {
                  e.currentTarget.style.background = "#FD6101";
                  e.currentTarget.style.boxShadow = "0 2px 4px rgba(124, 58, 237, 0.15)";
                }
              },
              style: {
                background: aiPrompt.trim() ? "#FD6101" : "#e2e8f0",
                color: aiPrompt.trim() ? "#ffffff" : "#94a3b8",
                border: "none",
                borderRadius: "8px",
                padding: "8px 20px",
                fontWeight: "600",
                fontSize: "13px",
                cursor: aiPrompt.trim() ? "pointer" : "not-allowed",
                boxShadow: aiPrompt.trim() ? "0 2px 4px rgba(124, 58, 237, 0.15)" : "none",
                transition: "all 0.15s"
              },
              children: isGenerating ? "Generating..." : "✨ Generate Workflow"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2554,
              columnNumber: 21
            }, this) : selectedBuildMethod === "visual" ? /*#__PURE__*/_jsxDEV("button", {
              onClick: () => {
                if (designSteps.length === 0) {
                  setDesignSteps([{
                    name: "1. Custom Step",
                    method: "GET",
                    path: "/api/custom",
                    headers: "{}",
                    body: "",
                    extractors: "[]",
                    assertions: '[{"type": "status_code", "expected_value": "200"}]',
                    think_time: 1
                  }]);
                }
                setWizardStep(4);
              },
              onMouseEnter: e => {
                e.currentTarget.style.background = "#e05300";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(109, 40, 217, 0.25)";
              },
              onMouseLeave: e => {
                e.currentTarget.style.background = "#FD6101";
                e.currentTarget.style.boxShadow = "0 2px 4px rgba(124, 58, 237, 0.15)";
              },
              style: {
                background: "#FD6101",
                color: "#ffffff",
                border: "none",
                borderRadius: "8px",
                padding: "8px 20px",
                fontWeight: "600",
                fontSize: "13px",
                cursor: "pointer",
                boxShadow: "0 2px 4px rgba(124, 58, 237, 0.15)",
                transition: "all 0.15s"
              },
              children: "Review Workflow \u2192"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2585,
              columnNumber: 21
            }, this) : /*#__PURE__*/_jsxDEV("button", {
              disabled: !importedFileName || importError,
              onClick: () => {
                var _importedFileName$spl;
                const extension = (_importedFileName$spl = importedFileName.split('.').pop()) === null || _importedFileName$spl === void 0 ? void 0 : _importedFileName$spl.toLowerCase();
                const validExtensions = ["json", "yaml", "yml", "har"];
                if (!validExtensions.includes(extension)) {
                  setImportError("Warning: Unsupported import file format. Please upload a valid JSON, YAML, or HAR file.");
                  alert("Warning: Unsupported import file format. Please upload a valid JSON, YAML, or HAR file.");
                  return;
                }
                // Mock converted steps
                setDesignSteps([{
                  name: "1. Imported Auth API",
                  method: "POST",
                  path: "/api/imported-auth",
                  headers: "{}",
                  body: "",
                  extractors: "[]",
                  assertions: '[{"type": "status_code", "expected_value": "200"}]',
                  think_time: 1
                }, {
                  name: "2. Imported Action API",
                  method: "GET",
                  path: "/api/imported-action",
                  headers: "{}",
                  body: "",
                  extractors: "[]",
                  assertions: '[{"type": "status_code", "expected_value": "200"}]',
                  think_time: 1
                }]);
                setSelectedStepIdx(0);
                alert("Qintra successfully imported and converted the workflow file!");
                setWizardStep(4);
              },
              onMouseEnter: e => {
                if (importedFileName && !importError) {
                  e.currentTarget.style.background = "#e05300";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(109, 40, 217, 0.25)";
                }
              },
              onMouseLeave: e => {
                if (importedFileName && !importError) {
                  e.currentTarget.style.background = "#FD6101";
                  e.currentTarget.style.boxShadow = "0 2px 4px rgba(124, 58, 237, 0.15)";
                }
              },
              style: {
                background: importedFileName && !importError ? "#FD6101" : "#e2e8f0",
                color: importedFileName && !importError ? "#ffffff" : "#94a3b8",
                border: "none",
                borderRadius: "8px",
                padding: "8px 20px",
                fontWeight: "600",
                fontSize: "13px",
                cursor: importedFileName && !importError ? "pointer" : "not-allowed",
                boxShadow: importedFileName && !importError ? "0 2px 4px rgba(124, 58, 237, 0.15)" : "none",
                transition: "all 0.15s"
              },
              children: "Review Workflow \u2192"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2618,
              columnNumber: 21
            }, this) : wizardStep === 1 ? /*#__PURE__*/_jsxDEV("button", {
              onClick: () => setWizardStep(3),
              onMouseEnter: e => {
                e.currentTarget.style.background = "#e05300";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(109, 40, 217, 0.25)";
              },
              onMouseLeave: e => {
                e.currentTarget.style.background = "#FD6101";
                e.currentTarget.style.boxShadow = "0 2px 4px rgba(124, 58, 237, 0.15)";
              },
              style: {
                background: "#FD6101",
                color: "#ffffff",
                border: "none",
                borderRadius: "8px",
                padding: "8px 20px",
                fontWeight: "600",
                fontSize: "13px",
                cursor: "pointer",
                boxShadow: "0 2px 4px rgba(124, 58, 237, 0.15)",
                transition: "all 0.15s"
              },
              children: "Continue \u2192"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2666,
              columnNumber: 19
            }, this) : (
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  onClick={() => {
                    const checklist = getSmartChecklist();
                    if (checklist.length === 0) {
                      alert("✓ Validation Success: Scenario is fully optimized and error-free!");
                    } else {
                      alert(`⚠️ Validation: Found ${checklist.length} issues. Please review the checklist in the sidebar.`);
                    }
                  }}
                  className="btn-secondary"
                  style={{
                    margin: 0,
                    padding: "8px 16px",
                    fontWeight: "600",
                    fontSize: "13px",
                    cursor: "pointer",
                    borderRadius: "8px",
                    border: "1px solid #cbd5e1"
                  }}
                >
                  Validate Scenario
                </button>
                <button
                  onClick={handleSavePlan}
                  className="btn-secondary"
                  style={{
                    margin: 0,
                    padding: "8px 16px",
                    fontWeight: "600",
                    fontSize: "13px",
                    cursor: "pointer",
                    borderRadius: "8px",
                    border: "1px solid #cbd5e1"
                  }}
                >
                  Save Scenario
                </button>
                <button
                  onClick={handleSaveAndRun}
                  className="btn-primary"
                  style={{
                    margin: 0,
                    background: "var(--primary)",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "8px 20px",
                    fontWeight: "600",
                    fontSize: "13px",
                    cursor: "pointer",
                    boxShadow: "0 2px 4px rgba(124, 58, 237, 0.15)"
                  }}
                >
                  Run Test
                </button>
              </div>
            )]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 2463,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 2434,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 1493,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName,
      lineNumber: 1492,
      columnNumber: 9
    }, this), showIterationModal && selectedReport && /*#__PURE__*/_jsxDEV("div", {
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(15, 23, 42, 0.65)",
        backdropFilter: "blur(6px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        animation: "fadeIn 0.2s ease-out"
      },
      children: /*#__PURE__*/_jsxDEV("div", {
        style: {
          background: "#ffffff",
          width: "90%",
          maxWidth: "1000px",
          height: "85vh",
          borderRadius: "16px",
          boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          border: "1px solid #cbd5e1"
        },
        children: [/*#__PURE__*/_jsxDEV("div", {
          style: {
            padding: "20px 24px",
            borderBottom: "1px solid #e2e8f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#f8fafc"
          },
          children: [/*#__PURE__*/_jsxDEV("div", {
            children: [/*#__PURE__*/_jsxDEV("h3", {
              style: {
                margin: 0,
                fontSize: "18px",
                fontWeight: "800",
                color: "#0f172a",
                display: "flex",
                alignItems: "center",
                gap: "8px"
              },
              children: "\uD83D\uDCCA Detailed Request Virtual Users Log (Updated Diagnostic View)"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2763,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("p", {
              style: {
                margin: "4px 0 0 0",
                fontSize: "12px",
                color: "var(--text-muted)"
              },
              children: ["Showing request virtual users from test run: ", /*#__PURE__*/_jsxDEV("strong", {
                children: getMemorableId(selectedReport.run_id)
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2767,
                columnNumber: 61
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 2766,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 2762,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("button", {
            onClick: () => setShowIterationModal(false),
            style: {
              background: "transparent",
              border: "none",
              fontSize: "24px",
              color: "#94a3b8",
              cursor: "pointer",
              padding: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              transition: "background 0.2s, color 0.2s"
            },
            onMouseOver: e => {
              e.currentTarget.style.background = "#fee2e2";
              e.currentTarget.style.color = "#ef4444";
            },
            onMouseOut: e => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.color = "#94a3b8";
            },
            children: "\xD7"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 2770,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 2754,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            padding: "16px 24px",
            background: "#ffffff",
            borderBottom: "1px solid #f1f5f9",
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1.2fr",
            gap: "16px"
          },
          children: [(() => {
            const realVuCount = selectedReport?.summary?.vu_count || selectedDefinition?.vu_count || 50;
            const errRate = selectedReport?.summary?.error_rate || 0.0;
            const failedCount = Math.round((errRate / 100) * realVuCount);
            const passedCount = realVuCount - failedCount;
            return [/*#__PURE__*/_jsxDEV("div", {
              style: {
                background: "#f8fafc",
                padding: "12px 16px",
                borderRadius: "8px",
                border: "1px solid #e2e8f0"
              },
              children: [/*#__PURE__*/_jsxDEV("span", {
                style: {
                  fontSize: "11px",
                  color: "var(--text-muted)",
                  fontWeight: "600",
                  textTransform: "uppercase"
                },
                children: "Total Virtual Users"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2802,
                columnNumber: 17
              }, this), /*#__PURE__*/_jsxDEV("h4", {
                style: {
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#1e293b",
                  margin: "4px 0 0 0"
                },
                children: realVuCount
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2803,
                columnNumber: 17
              }, this)]
            }, "tot_vus", true, {
              fileName: _jsxFileName,
              lineNumber: 2801,
              columnNumber: 15
            }, this), /*#__PURE__*/_jsxDEV("div", {
              style: {
                background: "#ecfdf5",
                padding: "12px 16px",
                borderRadius: "8px",
                border: "1px solid #a7f3d0"
              },
              children: [/*#__PURE__*/_jsxDEV("span", {
                style: {
                  fontSize: "11px",
                  color: "#065f46",
                  fontWeight: "600",
                  textTransform: "uppercase"
                },
                children: "Passed"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2806,
                columnNumber: 17
              }, this), /*#__PURE__*/_jsxDEV("h4", {
                style: {
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#047857",
                  margin: "4px 0 0 0"
                },
                children: passedCount
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2807,
                columnNumber: 17
              }, this)]
            }, "passed_vus", true, {
              fileName: _jsxFileName,
              lineNumber: 2805,
              columnNumber: 15
            }, this), /*#__PURE__*/_jsxDEV("div", {
              style: {
                background: "#fef2f2",
                padding: "12px 16px",
                borderRadius: "8px",
                border: "1px solid #fecaca"
              },
              children: [/*#__PURE__*/_jsxDEV("span", {
                style: {
                  fontSize: "11px",
                  color: "#991b1b",
                  fontWeight: "600",
                  textTransform: "uppercase"
                },
                children: "Failed"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2812,
                columnNumber: 17
              }, this), /*#__PURE__*/_jsxDEV("h4", {
                style: {
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#dc2626",
                  margin: "4px 0 0 0"
                },
                children: failedCount
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2813,
                columnNumber: 17
              }, this)]
            }, "failed_vus", true, {
              fileName: _jsxFileName,
              lineNumber: 2811,
              columnNumber: 15
            }, this)];
          })(), , /*#__PURE__*/_jsxDEV("div", {
            style: {
              background: "#eff6ff",
              padding: "12px 16px",
              borderRadius: "8px",
              border: "1px solid #bfdbfe"
            },
            children: [/*#__PURE__*/_jsxDEV("span", {
              style: {
                fontSize: "11px",
                color: "#1e40af",
                fontWeight: "600",
                textTransform: "uppercase"
              },
              children: "Total VUs Run Time"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2812,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("h4", {
              style: {
                fontSize: "20px",
                fontWeight: "800",
                color: "#1e3a8a",
                margin: "4px 0 0 0"
              },
              children: `${(iterationsList.reduce((sum, iter) => sum + iter.steps.reduce((acc, st) => acc + st.response_time, 0), 0) / 1000).toFixed(2)}s`
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2813,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 2814,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 2793,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            padding: "12px 24px",
            background: "#f8fafc",
            borderBottom: "1px solid #e2e8f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          },
          children: [/*#__PURE__*/_jsxDEV("div", {
            style: {
              display: "flex",
              gap: "8px"
            },
            children: [/*#__PURE__*/_jsxDEV("button", {
              onClick: () => { setIterationFilter("all"); setLogPage(1); },
              style: {
                padding: "6px 12px",
                borderRadius: "6px",
                border: iterationFilter === "all" ? "1px solid #4f46e5" : "1px solid #cbd5e1",
                background: iterationFilter === "all" ? "#f5f3ff" : "#ffffff",
                color: iterationFilter === "all" ? "#4f46e5" : "#64748b",
                fontSize: "12px",
                fontWeight: "600",
                cursor: "pointer"
              },
              children: ["All Virtual Users (", selectedReport?.summary?.vu_count || selectedDefinition?.vu_count || iterationsList.length, ")"]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 2835,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("button", {
              onClick: () => { setIterationFilter("failed"); setLogPage(1); },
              style: {
                padding: "6px 12px",
                borderRadius: "6px",
                border: iterationFilter === "failed" ? "1px solid #ef4444" : "1px solid #cbd5e1",
                background: iterationFilter === "failed" ? "#fef2f2" : "#ffffff",
                color: iterationFilter === "failed" ? "#ef4444" : "#64748b",
                fontSize: "12px",
                fontWeight: "600",
                cursor: "pointer"
              },
              children: ["Failed Virtual Users Only (", (() => { const rv = selectedReport?.summary?.vu_count || selectedDefinition?.vu_count || iterationsList.length; const er = selectedReport?.summary?.error_rate || 0; return Math.round((er / 100) * rv); })(), ")"]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 2850,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 2834,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("span", {
            style: {
              fontSize: "12px",
              color: "var(--text-muted)"
            },
            children: "Click on any virtual user row below to expand request step details."
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 2866,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 2826,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            flex: 1,
            overflowY: "auto",
            padding: "20px 24px"
          },
          children: filteredIterations.length === 0 ? /*#__PURE__*/_jsxDEV("div", {
            style: {
              textAlign: "center",
              padding: "40px 0",
              color: "#64748b"
            },
            children: [/*#__PURE__*/_jsxDEV("span", {
              style: {
                fontSize: "36px"
              },
              children: "\uD83D\uDD0D"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2875,
              columnNumber: 19
            }, this), /*#__PURE__*/_jsxDEV("p", {
              style: {
                marginTop: "12px",
                fontWeight: "600"
              },
              children: "No virtual users match the active filter criteria."
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2876,
              columnNumber: 19
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 2874,
            columnNumber: 17
          }, this) : /*#__PURE__*/_jsxDEV("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "8px"
            },
            children: [
              (() => {
                const itemsPerPage = 50;
                const startIndex = (logPage - 1) * itemsPerPage;
                const paginatedItems = filteredIterations.slice(startIndex, startIndex + itemsPerPage);
                return paginatedItems.map(iter => {
                  const isExpanded = !!expandedIterations[iter.iteration];
                  return /*#__PURE__*/_jsxDEV("div", {
                    style: {
                      border: isExpanded ? "1px solid #818cf8" : "1px solid #e2e8f0",
                      borderRadius: "8px",
                      overflow: "hidden",
                      background: "#ffffff",
                      transition: "border-color 0.2s"
                    },
                    children: [/*#__PURE__*/_jsxDEV("div", {
                      onClick: () => toggleIterationExpanded(iter.iteration),
                      style: {
                        padding: "12px 18px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                        background: isExpanded ? "#f5f3ff" : "#ffffff",
                        transition: "background-color 0.2s"
                      },
                      onMouseOver: e => {
                        if (!isExpanded) e.currentTarget.style.backgroundColor = "#f8fafc";
                      },
                      onMouseOut: e => {
                        if (!isExpanded) e.currentTarget.style.backgroundColor = "#ffffff";
                      },
                      children: [/*#__PURE__*/_jsxDEV("div", {
                        style: {
                          display: "flex",
                          alignItems: "center",
                          gap: "10px"
                        },
                        children: [/*#__PURE__*/_jsxDEV("span", {
                          style: {
                            fontWeight: "800",
                            color: "#1e293b",
                            fontSize: "13px"
                          },
                          children: ["Virtual User #", iter.iteration]
                        }, void 0, true, {
                          fileName: _jsxFileName,
                          lineNumber: 2909,
                          columnNumber: 29
                        }, this), /*#__PURE__*/_jsxDEV("span", {
                          style: {
                            fontSize: "10px",
                            backgroundColor: "#e2e8f0",
                            color: "#475569",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            fontWeight: "700"
                          },
                          children: iter.vu
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 2912,
                          columnNumber: 29
                        }, this), /*#__PURE__*/_jsxDEV("button", {
                          onClick: (e) => {
                            e.stopPropagation();
                            setShowTimeForIter(prev => ({
                              ...prev,
                              [iter.iteration]: !prev[iter.iteration]
                            }));
                          },
                          style: {
                            background: showTimeForIter[iter.iteration] ? "FD6101" : "#eff6ff",
                            border: showTimeForIter[iter.iteration] ? "1px solid FD6101" : "1px solid #bfdbfe",
                            borderRadius: "50%",
                            width: "18px",
                            height: "18px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            fontSize: "10px",
                            color: showTimeForIter[iter.iteration] ? "#ffffff" : "FD6101",
                            fontWeight: "800",
                            padding: 0,
                            marginLeft: "8px",
                            lineHeight: 1
                          },
                          title: "View execution time",
                          children: "i"
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 2913,
                          columnNumber: 29
                        }, this), showTimeForIter[iter.iteration] && /*#__PURE__*/_jsxDEV("span", {
                          style: {
                            marginLeft: "8px",
                            background: "#dbeafe",
                            color: "#1e40af",
                            fontSize: "11px",
                            fontWeight: "700",
                            padding: "2px 8px",
                            borderRadius: "12px",
                            border: "1px solid #bfdbfe"
                          },
                          children: (() => {
                            const totalMs = iter.steps.reduce((acc, st) => acc + st.response_time, 0);
                            const totalSec = (totalMs / 1000).toFixed(3);
                            return `${totalMs} ms (${totalSec}s)`;
                          })()
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 2914,
                          columnNumber: 29
                        }, this)]
                      }, void 0, true, {
                        fileName: _jsxFileName,
                        lineNumber: 2908,
                        columnNumber: 27
                      }, this), /*#__PURE__*/_jsxDEV("div", {
                        style: {
                          display: "flex",
                          alignItems: "center",
                          gap: "12px"
                        },
                        children: [/*#__PURE__*/_jsxDEV("span", {
                          style: {
                            fontSize: "11px",
                            fontWeight: "700",
                            borderRadius: "12px",
                            padding: "4px 10px",
                            backgroundColor: iter.status === "passed" ? "#d1fae5" : "#fee2e2",
                            color: iter.status === "passed" ? "#065f46" : "#dc2626",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px"
                          },
                          children: iter.status === "passed" ? "✓ Passed" : "✗ Failed"
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 2925,
                          columnNumber: 29
                        }, this), /*#__PURE__*/_jsxDEV("span", {
                          style: {
                            color: "#94a3b8",
                            fontSize: "14px",
                            transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.2s"
                          },
                          children: "\u25BC"
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 2938,
                          columnNumber: 29
                        }, this)]
                      }, void 0, true, {
                        fileName: _jsxFileName,
                        lineNumber: 2924,
                        columnNumber: 27
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName,
                      lineNumber: 2894,
                      columnNumber: 25
                    }, this), isExpanded && /*#__PURE__*/_jsxDEV("div", {
                      style: {
                        padding: "16px",
                        borderTop: "1px solid #cbd5e1",
                        background: "#f8fafc"
                      },
                      children: /*#__PURE__*/_jsxDEV("table", {
                        style: {
                          width: "100%",
                          borderCollapse: "collapse",
                          fontSize: "12px",
                          borderRadius: "8px",
                          overflow: "hidden"
                        },
                        children: [/*#__PURE__*/_jsxDEV("thead", {
                          children: /*#__PURE__*/_jsxDEV("tr", {
                            style: {
                              background: "#ede9fe",
                              textAlign: "left"
                            },
                            children: [/*#__PURE__*/_jsxDEV("th", {
                              style: {
                                padding: "10px 14px",
                                color: "#4f46e5",
                                fontWeight: "700",
                                fontSize: "11px",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em"
                              },
                              children: "Step"
                            }, void 0, false, {
                              fileName: _jsxFileName,
                              lineNumber: 2950,
                              columnNumber: 35
                            }, this), /*#__PURE__*/_jsxDEV("th", {
                              style: {
                                padding: "10px 14px",
                                color: "#4f46e5",
                                fontWeight: "700",
                                fontSize: "11px",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em"
                              },
                              children: "Expected"
                            }, void 0, false, {
                              fileName: _jsxFileName,
                              lineNumber: 2951,
                              columnNumber: 35
                            }, this), /*#__PURE__*/_jsxDEV("th", {
                              style: {
                                padding: "10px 14px",
                                color: "#4f46e5",
                                fontWeight: "700",
                                fontSize: "11px",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em"
                              },
                              children: "Actual"
                            }, void 0, false, {
                              fileName: _jsxFileName,
                              lineNumber: 2952,
                              columnNumber: 35
                            }, this), /*#__PURE__*/_jsxDEV("th", {
                              style: {
                                padding: "10px 14px",
                                color: "#4f46e5",
                                fontWeight: "700",
                                fontSize: "11px",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em"
                              },
                              children: "Failure Reason"
                            }, void 0, false, {
                              fileName: _jsxFileName,
                              lineNumber: 2953,
                              columnNumber: 35
                            }, this), /*#__PURE__*/_jsxDEV("th", {
                              style: {
                                padding: "10px 14px",
                                color: "#4f46e5",
                                fontWeight: "700",
                                fontSize: "11px",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em",
                                textAlign: "center"
                              },
                              children: "AI Suggestion"
                            }, void 0, false, {
                              fileName: _jsxFileName,
                              lineNumber: 2954,
                              columnNumber: 35
                            }, this)]
                          }, void 0, true, {
                            fileName: _jsxFileName,
                            lineNumber: 2949,
                            columnNumber: 33
                          }, this)
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 2948,
                          columnNumber: 31
                        }, this), /*#__PURE__*/_jsxDEV("tbody", {
                          children: iter.steps.map((st, sidx) => {
                            const meta = getStepMeta(st);
                            const isPassed = st.status === "passed";
                            const rowBg = sidx % 2 === 0 ? "#ffffff" : "#f8fafc";
                            return /*#__PURE__*/_jsxDEV("tr", {
                              style: {
                                borderBottom: "1px solid #e2e8f0",
                                background: rowBg,
                                transition: "background 0.15s"
                              },
                              onMouseEnter: e => e.currentTarget.style.background = "#f0f9ff",
                              onMouseLeave: e => e.currentTarget.style.background = rowBg,
                              children: [/*#__PURE__*/_jsxDEV("td", {
                                style: {
                                  padding: "10px 14px"
                                },
                                children: [/*#__PURE__*/_jsxDEV("div", {
                                  style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px"
                                  },
                                  children: [/*#__PURE__*/_jsxDEV("span", {
                                    style: {
                                      display: "inline-block",
                                      width: "8px",
                                      height: "8px",
                                      borderRadius: "50%",
                                      background: isPassed ? "#22c55e" : "#ef4444",
                                      flexShrink: 0
                                    }
                                  }, void 0, false, {
                                    fileName: _jsxFileName,
                                    lineNumber: 2969,
                                    columnNumber: 43
                                  }, this), /*#__PURE__*/_jsxDEV("span", {
                                    style: {
                                      fontWeight: "700",
                                      color: "#0f172a"
                                    },
                                    children: st.name
                                  }, void 0, false, {
                                    fileName: _jsxFileName,
                                    lineNumber: 2970,
                                    columnNumber: 43
                                  }, this)]
                                }, void 0, true, {
                                  fileName: _jsxFileName,
                                  lineNumber: 2968,
                                  columnNumber: 41
                                }, this), /*#__PURE__*/_jsxDEV("div", {
                                  style: {
                                    fontSize: "10px",
                                    color: "#94a3b8",
                                    marginTop: "3px",
                                    paddingLeft: "16px"
                                  },
                                  children: [st.method, " ", st.path || "/", " \xA0\xB7\xA0 ", st.response_time, " ms"]
                                }, void 0, true, {
                                  fileName: _jsxFileName,
                                  lineNumber: 2972,
                                  columnNumber: 41
                                }, this)]
                              }, void 0, true, {
                                fileName: _jsxFileName,
                                lineNumber: 2967,
                                columnNumber: 39
                              }, this), /*#__PURE__*/_jsxDEV("td", {
                                style: {
                                  padding: "10px 14px"
                                },
                                children: /*#__PURE__*/_jsxDEV("span", {
                                  style: {
                                    display: "inline-block",
                                    padding: "3px 8px",
                                    borderRadius: "6px",
                                    background: "#dcfce7",
                                    color: "#15803d",
                                    fontWeight: "700",
                                    fontSize: "11px"
                                  },
                                  children: meta.expected
                                }, void 0, false, {
                                  fileName: _jsxFileName,
                                  lineNumber: 2977,
                                  columnNumber: 41
                                }, this)
                              }, void 0, false, {
                                fileName: _jsxFileName,
                                lineNumber: 2976,
                                columnNumber: 39
                              }, this), /*#__PURE__*/_jsxDEV("td", {
                                style: {
                                  padding: "10px 14px"
                                },
                                children: /*#__PURE__*/_jsxDEV("span", {
                                  style: {
                                    display: "inline-block",
                                    padding: "3px 8px",
                                    borderRadius: "6px",
                                    background: isPassed ? "#dcfce7" : "#fee2e2",
                                    color: isPassed ? "#15803d" : "#dc2626",
                                    fontWeight: "700",
                                    fontSize: "11px"
                                  },
                                  children: meta.actual
                                }, void 0, false, {
                                  fileName: _jsxFileName,
                                  lineNumber: 2982,
                                  columnNumber: 41
                                }, this)
                              }, void 0, false, {
                                fileName: _jsxFileName,
                                lineNumber: 2981,
                                columnNumber: 39
                              }, this), /*#__PURE__*/_jsxDEV("td", {
                                style: {
                                  padding: "10px 14px",
                                  color: isPassed ? "#94a3b8" : "#b45309",
                                  fontWeight: isPassed ? "400" : "600",
                                  fontSize: "12px"
                                },
                                children: meta.failureReason
                              }, void 0, false, {
                                fileName: _jsxFileName,
                                lineNumber: 2986,
                                columnNumber: 39
                              }, this), /*#__PURE__*/_jsxDEV("td", {
                                style: {
                                  padding: "10px 14px",
                                  maxWidth: "240px"
                                },
                                children: isPassed ? /*#__PURE__*/_jsxDEV("span", {
                                  style: {
                                    color: "#94a3b8",
                                    fontSize: "12px"
                                  },
                                  children: "\u2014"
                                }, void 0, false, {
                                  fileName: _jsxFileName,
                                  lineNumber: 2991,
                                  columnNumber: 43
                                }, this) : /*#__PURE__*/_jsxDEV("div", {
                                  style: {
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: "6px"
                                  },
                                  children: [/*#__PURE__*/_jsxDEV("span", {
                                    style: {
                                      fontSize: "13px",
                                      flexShrink: 0
                                    },
                                    children: "\uD83E\uDD16"
                                  }, void 0, false, {
                                    fileName: _jsxFileName,
                                    lineNumber: 2994,
                                    columnNumber: 45
                                  }, this), /*#__PURE__*/_jsxDEV("span", {
                                    style: {
                                      color: "#4f46e5",
                                      fontWeight: "600",
                                      fontSize: "11px",
                                      lineHeight: "1.5"
                                    },
                                    children: meta.aiSuggestion
                                  }, void 0, false, {
                                    fileName: _jsxFileName,
                                    lineNumber: 2995,
                                    columnNumber: 45
                                  }, this)]
                                }, void 0, true, {
                                  fileName: _jsxFileName,
                                  lineNumber: 2993,
                                  columnNumber: 43
                                }, this)
                              }, void 0, false, {
                                fileName: _jsxFileName,
                                lineNumber: 2989,
                                columnNumber: 39
                              }, this)]
                            }, sidx, true, {
                              fileName: _jsxFileName,
                              lineNumber: 2963,
                              columnNumber: 37
                            }, this);
                          })
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 2957,
                          columnNumber: 31
                        }, this)]
                      }, void 0, true, {
                        fileName: _jsxFileName,
                        lineNumber: 2947,
                        columnNumber: 29
                      }, this)
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 2946,
                      columnNumber: 27
                    }, this)]
                  }, iter.iteration, true, {
                    fileName: _jsxFileName,
                    lineNumber: 2883,
                    columnNumber: 23
                  }, this);
                });
              })(),
              (() => {
                const itemsPerPage = 50;
                const totalPages = Math.ceil(filteredIterations.length / itemsPerPage);
                if (totalPages <= 1) return null;
                return /*#__PURE__*/_jsxDEV("div", {
                  style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "12px",
                    marginTop: "16px",
                    padding: "12px 0 4px 0",
                    borderTop: "1px solid #e2e8f0"
                  },
                  children: [/*#__PURE__*/_jsxDEV("button", {
                    className: "btn-secondary",
                    disabled: logPage === 1,
                    onClick: (e) => { e.stopPropagation(); setLogPage(prev => Math.max(1, prev - 1)); },
                    style: { padding: "4px 10px", fontSize: "12px" },
                    children: "Previous"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2884,
                    columnNumber: 23
                  }, this), /*#__PURE__*/_jsxDEV("span", {
                    style: { fontSize: "12px", color: "var(--text-muted)", fontWeight: "700" },
                    children: `Page ${logPage} of ${totalPages}`
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2885,
                    columnNumber: 23
                  }, this), /*#__PURE__*/_jsxDEV("button", {
                    className: "btn-secondary",
                    disabled: logPage === totalPages,
                    onClick: (e) => { e.stopPropagation(); setLogPage(prev => Math.min(totalPages, prev + 1)); },
                    style: { padding: "4px 10px", fontSize: "12px" },
                    children: "Next"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 2886,
                    columnNumber: 23
                  }, this)]
                }, "pagination_controls", true, {
                  fileName: _jsxFileName,
                  lineNumber: 2887,
                  columnNumber: 23
                }, this);
              })()
            ]
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 2879,
            columnNumber: 17
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 2872,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 2741,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName,
      lineNumber: 2727,
      columnNumber: 9
    }, this), showIterationModal && selectedReport && /*#__PURE__*/_jsxDEV("div", {
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(15, 23, 42, 0.65)",
        backdropFilter: "blur(6px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        animation: "fadeIn 0.2s ease-out"
      },
      children: /*#__PURE__*/_jsxDEV("div", {
        style: {
          background: "#ffffff",
          width: "90%",
          maxWidth: "1000px",
          height: "85vh",
          borderRadius: "16px",
          boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          border: "1px solid #cbd5e1"
        },
        children: [/*#__PURE__*/_jsxDEV("div", {
          style: {
            padding: "20px 24px",
            borderBottom: "1px solid #e2e8f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#f8fafc"
          },
          children: [/*#__PURE__*/_jsxDEV("div", {
            children: [/*#__PURE__*/_jsxDEV("h3", {
              style: {
                margin: 0,
                fontSize: "18px",
                fontWeight: "800",
                color: "#0f172a",
                display: "flex",
                alignItems: "center",
                gap: "8px"
              },
              children: "\uD83D\uDCCA Detailed Request Virtual Users Log (Updated Diagnostic View)"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 3055,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("p", {
              style: {
                margin: "4px 0 0 0",
                fontSize: "12px",
                color: "var(--text-muted)"
              },
              children: ["Showing request virtual users from test run: ", /*#__PURE__*/_jsxDEV("strong", {
                children: getMemorableId(selectedReport.run_id)
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 3059,
                columnNumber: 61
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 3058,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 3054,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("button", {
            onClick: () => setShowIterationModal(false),
            style: {
              background: "transparent",
              border: "none",
              fontSize: "24px",
              color: "#94a3b8",
              cursor: "pointer",
              padding: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              transition: "background 0.2s, color 0.2s"
            },
            onMouseOver: e => {
              e.currentTarget.style.background = "#fee2e2";
              e.currentTarget.style.color = "#ef4444";
            },
            onMouseOut: e => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.color = "#94a3b8";
            },
            children: "\xD7"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 3062,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 3046,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            padding: "16px 24px",
            background: "#ffffff",
            borderBottom: "1px solid #f1f5f9",
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1.2fr",
            gap: "16px"
          },
          children: [(() => {
            const realVuCount = selectedReport?.summary?.vu_count || selectedDefinition?.vu_count || 50;
            const errRate = selectedReport?.summary?.error_rate || 0.0;
            const failedCount = Math.round((errRate / 100) * realVuCount);
            const passedCount = realVuCount - failedCount;
            return [/*#__PURE__*/_jsxDEV("div", {
              style: {
                background: "#f8fafc",
                padding: "12px 16px",
                borderRadius: "8px",
                border: "1px solid #e2e8f0"
              },
              children: [/*#__PURE__*/_jsxDEV("span", {
                style: {
                  fontSize: "11px",
                  color: "var(--text-muted)",
                  fontWeight: "600",
                  textTransform: "uppercase"
                },
                children: "Total Virtual Users"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2802,
                columnNumber: 17
              }, this), /*#__PURE__*/_jsxDEV("h4", {
                style: {
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#1e293b",
                  margin: "4px 0 0 0"
                },
                children: realVuCount
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2803,
                columnNumber: 17
              }, this)]
            }, "tot_vus", true, {
              fileName: _jsxFileName,
              lineNumber: 2801,
              columnNumber: 15
            }, this), /*#__PURE__*/_jsxDEV("div", {
              style: {
                background: "#ecfdf5",
                padding: "12px 16px",
                borderRadius: "8px",
                border: "1px solid #a7f3d0"
              },
              children: [/*#__PURE__*/_jsxDEV("span", {
                style: {
                  fontSize: "11px",
                  color: "#065f46",
                  fontWeight: "600",
                  textTransform: "uppercase"
                },
                children: "Passed"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2806,
                columnNumber: 17
              }, this), /*#__PURE__*/_jsxDEV("h4", {
                style: {
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#047857",
                  margin: "4px 0 0 0"
                },
                children: passedCount
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2807,
                columnNumber: 17
              }, this)]
            }, "passed_vus", true, {
              fileName: _jsxFileName,
              lineNumber: 2805,
              columnNumber: 15
            }, this), /*#__PURE__*/_jsxDEV("div", {
              style: {
                background: "#fef2f2",
                padding: "12px 16px",
                borderRadius: "8px",
                border: "1px solid #fecaca"
              },
              children: [/*#__PURE__*/_jsxDEV("span", {
                style: {
                  fontSize: "11px",
                  color: "#991b1b",
                  fontWeight: "600",
                  textTransform: "uppercase"
                },
                children: "Failed"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2812,
                columnNumber: 17
              }, this), /*#__PURE__*/_jsxDEV("h4", {
                style: {
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#dc2626",
                  margin: "4px 0 0 0"
                },
                children: failedCount
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 2813,
                columnNumber: 17
              }, this)]
            }, "failed_vus", true, {
              fileName: _jsxFileName,
              lineNumber: 2811,
              columnNumber: 15
            }, this)];
          })(), , /*#__PURE__*/_jsxDEV("div", {
            style: {
              background: "#eff6ff",
              padding: "12px 16px",
              borderRadius: "8px",
              border: "1px solid #bfdbfe"
            },
            children: [/*#__PURE__*/_jsxDEV("span", {
              style: {
                fontSize: "11px",
                color: "#1e40af",
                fontWeight: "600",
                textTransform: "uppercase"
              },
              children: "Total VUs Run Time"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2812,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("h4", {
              style: {
                fontSize: "20px",
                fontWeight: "800",
                color: "#1e3a8a",
                margin: "4px 0 0 0"
              },
              children: `${(iterationsList.reduce((sum, iter) => sum + iter.steps.reduce((acc, st) => acc + st.response_time, 0), 0) / 1000).toFixed(2)}s`
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 2813,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 2814,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 2793,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            padding: "12px 24px",
            background: "#f8fafc",
            borderBottom: "1px solid #e2e8f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          },
          children: [/*#__PURE__*/_jsxDEV("div", {
            style: {
              display: "flex",
              gap: "8px"
            },
            children: [/*#__PURE__*/_jsxDEV("button", {
              onClick: () => { setIterationFilter("all"); setLogPage(1); },
              style: {
                padding: "6px 12px",
                borderRadius: "6px",
                border: iterationFilter === "all" ? "1px solid #4f46e5" : "1px solid #cbd5e1",
                background: iterationFilter === "all" ? "#f5f3ff" : "#ffffff",
                color: iterationFilter === "all" ? "#4f46e5" : "#64748b",
                fontSize: "12px",
                fontWeight: "600",
                cursor: "pointer"
              },
              children: ["All Virtual Users (", selectedReport?.summary?.vu_count || selectedDefinition?.vu_count || iterationsList.length, ")"]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 3127,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("button", {
              onClick: () => { setIterationFilter("failed"); setLogPage(1); },
              style: {
                padding: "6px 12px",
                borderRadius: "6px",
                border: iterationFilter === "failed" ? "1px solid #ef4444" : "1px solid #cbd5e1",
                background: iterationFilter === "failed" ? "#fef2f2" : "#ffffff",
                color: iterationFilter === "failed" ? "#ef4444" : "#64748b",
                fontSize: "12px",
                fontWeight: "600",
                cursor: "pointer"
              },
              children: ["Failed Virtual Users Only (", (() => { const rv = selectedReport?.summary?.vu_count || selectedDefinition?.vu_count || iterationsList.length; const er = selectedReport?.summary?.error_rate || 0; return Math.round((er / 100) * rv); })(), ")"]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 3142,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 3126,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("span", {
            style: {
              fontSize: "12px",
              color: "var(--text-muted)"
            },
            children: "Click on any virtual user row below to expand request step details."
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 3158,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 3118,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            flex: 1,
            overflowY: "auto",
            padding: "20px 24px"
          },
          children: filteredIterations.length === 0 ? /*#__PURE__*/_jsxDEV("div", {
            style: {
              textAlign: "center",
              padding: "40px 0",
              color: "#64748b"
            },
            children: [/*#__PURE__*/_jsxDEV("span", {
              style: {
                fontSize: "36px"
              },
              children: "\uD83D\uDD0D"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 3167,
              columnNumber: 19
            }, this), /*#__PURE__*/_jsxDEV("p", {
              style: {
                marginTop: "12px",
                fontWeight: "600"
              },
              children: "No virtual users match the active filter criteria."
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 3168,
              columnNumber: 19
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 3166,
            columnNumber: 17
          }, this) : /*#__PURE__*/_jsxDEV("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "8px"
            },
            children: [
              (() => {
                const itemsPerPage = 50;
                const startIndex = (logPage - 1) * itemsPerPage;
                const paginatedItems = filteredIterations.slice(startIndex, startIndex + itemsPerPage);
                return paginatedItems.map(iter => {
                  const isExpanded = !!expandedIterations[iter.iteration];
                  return /*#__PURE__*/_jsxDEV("div", {
                    style: {
                      border: isExpanded ? "1px solid #818cf8" : "1px solid #e2e8f0",
                      borderRadius: "8px",
                      overflow: "hidden",
                      background: "#ffffff",
                      transition: "border-color 0.2s"
                    },
                    children: [/*#__PURE__*/_jsxDEV("div", {
                      onClick: () => toggleIterationExpanded(iter.iteration),
                      style: {
                        padding: "12px 18px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                        background: isExpanded ? "#f5f3ff" : "#ffffff",
                        transition: "background-color 0.2s"
                      },
                      onMouseOver: e => {
                        if (!isExpanded) e.currentTarget.style.backgroundColor = "#f8fafc";
                      },
                      onMouseOut: e => {
                        if (!isExpanded) e.currentTarget.style.backgroundColor = "#ffffff";
                      },
                      children: [/*#__PURE__*/_jsxDEV("div", {
                        style: {
                          display: "flex",
                          alignItems: "center",
                          gap: "10px"
                        },
                        children: [/*#__PURE__*/_jsxDEV("span", {
                          style: {
                            fontWeight: "800",
                            color: "#1e293b",
                            fontSize: "13px"
                          },
                          children: ["Virtual User #", iter.iteration]
                        }, void 0, true, {
                          fileName: _jsxFileName,
                          lineNumber: 3201,
                          columnNumber: 29
                        }, this), /*#__PURE__*/_jsxDEV("span", {
                          style: {
                            fontSize: "10px",
                            backgroundColor: "#e2e8f0",
                            color: "#475569",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            fontWeight: "700"
                          },
                          children: iter.vu
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 3204,
                          columnNumber: 29
                        }, this), /*#__PURE__*/_jsxDEV("button", {
                          onClick: (e) => {
                            e.stopPropagation();
                            setShowTimeForIter(prev => ({
                              ...prev,
                              [iter.iteration]: !prev[iter.iteration]
                            }));
                          },
                          style: {
                            background: showTimeForIter[iter.iteration] ? "FD6101" : "#eff6ff",
                            border: showTimeForIter[iter.iteration] ? "1px solid FD6101" : "1px solid #bfdbfe",
                            borderRadius: "50%",
                            width: "18px",
                            height: "18px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            fontSize: "10px",
                            color: showTimeForIter[iter.iteration] ? "#ffffff" : "FD6101",
                            fontWeight: "800",
                            padding: 0,
                            marginLeft: "8px",
                            lineHeight: 1
                          },
                          title: "View execution time",
                          children: "i"
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 3205,
                          columnNumber: 29
                        }, this), showTimeForIter[iter.iteration] && /*#__PURE__*/_jsxDEV("span", {
                          style: {
                            marginLeft: "8px",
                            background: "#dbeafe",
                            color: "#1e40af",
                            fontSize: "11px",
                            fontWeight: "700",
                            padding: "2px 8px",
                            borderRadius: "12px",
                            border: "1px solid #bfdbfe"
                          },
                          children: (() => {
                            const totalMs = iter.steps.reduce((acc, st) => acc + st.response_time, 0);
                            const totalSec = (totalMs / 1000).toFixed(3);
                            return `${totalMs} ms (${totalSec}s)`;
                          })()
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 3206,
                          columnNumber: 29
                        }, this)]
                      }, void 0, true, {
                        fileName: _jsxFileName,
                        lineNumber: 3200,
                        columnNumber: 27
                      }, this), /*#__PURE__*/_jsxDEV("div", {
                        style: {
                          display: "flex",
                          alignItems: "center",
                          gap: "12px"
                        },
                        children: [/*#__PURE__*/_jsxDEV("span", {
                          style: {
                            fontSize: "11px",
                            fontWeight: "700",
                            borderRadius: "12px",
                            padding: "4px 10px",
                            backgroundColor: iter.status === "passed" ? "#d1fae5" : "#fee2e2",
                            color: iter.status === "passed" ? "#065f46" : "#dc2626",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px"
                          },
                          children: iter.status === "passed" ? "✓ Passed" : "✗ Failed"
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 3217,
                          columnNumber: 29
                        }, this), /*#__PURE__*/_jsxDEV("span", {
                          style: {
                            color: "#94a3b8",
                            fontSize: "14px",
                            transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.2s"
                          },
                          children: "\u25BC"
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 3230,
                          columnNumber: 29
                        }, this)]
                      }, void 0, true, {
                        fileName: _jsxFileName,
                        lineNumber: 3216,
                        columnNumber: 27
                      }, this)]
                    }, void 0, true, {
                      fileName: _jsxFileName,
                      lineNumber: 3186,
                      columnNumber: 25
                    }, this), isExpanded && /*#__PURE__*/_jsxDEV("div", {
                      style: {
                        padding: "16px",
                        borderTop: "1px solid #cbd5e1",
                        background: "#f8fafc"
                      },
                      children: /*#__PURE__*/_jsxDEV("table", {
                        style: {
                          width: "100%",
                          borderCollapse: "collapse",
                          fontSize: "12px",
                          borderRadius: "8px",
                          overflow: "hidden"
                        },
                        children: [/*#__PURE__*/_jsxDEV("thead", {
                          children: /*#__PURE__*/_jsxDEV("tr", {
                            style: {
                              background: "#ede9fe",
                              textAlign: "left"
                            },
                            children: [/*#__PURE__*/_jsxDEV("th", {
                              style: {
                                padding: "10px 14px",
                                color: "#4f46e5",
                                fontWeight: "700",
                                fontSize: "11px",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em"
                              },
                              children: "Step"
                            }, void 0, false, {
                              fileName: _jsxFileName,
                              lineNumber: 3242,
                              columnNumber: 35
                            }, this), /*#__PURE__*/_jsxDEV("th", {
                              style: {
                                padding: "10px 14px",
                                color: "#4f46e5",
                                fontWeight: "700",
                                fontSize: "11px",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em"
                              },
                              children: "Expected"
                            }, void 0, false, {
                              fileName: _jsxFileName,
                              lineNumber: 3243,
                              columnNumber: 35
                            }, this), /*#__PURE__*/_jsxDEV("th", {
                              style: {
                                padding: "10px 14px",
                                color: "#4f46e5",
                                fontWeight: "700",
                                fontSize: "11px",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em"
                              },
                              children: "Actual"
                            }, void 0, false, {
                              fileName: _jsxFileName,
                              lineNumber: 3244,
                              columnNumber: 35
                            }, this), /*#__PURE__*/_jsxDEV("th", {
                              style: {
                                padding: "10px 14px",
                                color: "#4f46e5",
                                fontWeight: "700",
                                fontSize: "11px",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em"
                              },
                              children: "Failure Reason"
                            }, void 0, false, {
                              fileName: _jsxFileName,
                              lineNumber: 3245,
                              columnNumber: 35
                            }, this), /*#__PURE__*/_jsxDEV("th", {
                              style: {
                                padding: "10px 14px",
                                color: "#4f46e5",
                                fontWeight: "700",
                                fontSize: "11px",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em",
                                textAlign: "center"
                              },
                              children: "AI Suggestion"
                            }, void 0, false, {
                              fileName: _jsxFileName,
                              lineNumber: 3246,
                              columnNumber: 35
                            }, this)]
                          }, void 0, true, {
                            fileName: _jsxFileName,
                            lineNumber: 3241,
                            columnNumber: 33
                          }, this)
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 3240,
                          columnNumber: 31
                        }, this), /*#__PURE__*/_jsxDEV("tbody", {
                          children: iter.steps.map((st, sidx) => {
                            const meta = getStepMeta(st);
                            const isPassed = st.status === "passed";
                            const rowBg = sidx % 2 === 0 ? "#ffffff" : "#f8fafc";
                            return /*#__PURE__*/_jsxDEV("tr", {
                              style: {
                                borderBottom: "1px solid #e2e8f0",
                                background: rowBg,
                                transition: "background 0.15s"
                              },
                              onMouseEnter: e => e.currentTarget.style.background = "#f0f9ff",
                              onMouseLeave: e => e.currentTarget.style.background = rowBg,
                              children: [/*#__PURE__*/_jsxDEV("td", {
                                style: {
                                  padding: "10px 14px"
                                },
                                children: [/*#__PURE__*/_jsxDEV("div", {
                                  style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px"
                                  },
                                  children: [/*#__PURE__*/_jsxDEV("span", {
                                    style: {
                                      display: "inline-block",
                                      width: "8px",
                                      height: "8px",
                                      borderRadius: "50%",
                                      background: isPassed ? "#22c55e" : "#ef4444",
                                      flexShrink: 0
                                    }
                                  }, void 0, false, {
                                    fileName: _jsxFileName,
                                    lineNumber: 3261,
                                    columnNumber: 43
                                  }, this), /*#__PURE__*/_jsxDEV("span", {
                                    style: {
                                      fontWeight: "700",
                                      color: "#0f172a"
                                    },
                                    children: st.name
                                  }, void 0, false, {
                                    fileName: _jsxFileName,
                                    lineNumber: 3262,
                                    columnNumber: 43
                                  }, this)]
                                }, void 0, true, {
                                  fileName: _jsxFileName,
                                  lineNumber: 3260,
                                  columnNumber: 41
                                }, this), /*#__PURE__*/_jsxDEV("div", {
                                  style: {
                                    fontSize: "10px",
                                    color: "#94a3b8",
                                    marginTop: "3px",
                                    paddingLeft: "16px"
                                  },
                                  children: [st.method, " ", st.path || "/", " \xA0\xB7\xA0 ", st.response_time, " ms"]
                                }, void 0, true, {
                                  fileName: _jsxFileName,
                                  lineNumber: 3264,
                                  columnNumber: 41
                                }, this)]
                              }, void 0, true, {
                                fileName: _jsxFileName,
                                lineNumber: 3259,
                                columnNumber: 39
                              }, this), /*#__PURE__*/_jsxDEV("td", {
                                style: {
                                  padding: "10px 14px"
                                },
                                children: /*#__PURE__*/_jsxDEV("span", {
                                  style: {
                                    display: "inline-block",
                                    padding: "3px 8px",
                                    borderRadius: "6px",
                                    background: "#dcfce7",
                                    color: "#15803d",
                                    fontWeight: "700",
                                    fontSize: "11px"
                                  },
                                  children: meta.expected
                                }, void 0, false, {
                                  fileName: _jsxFileName,
                                  lineNumber: 3269,
                                  columnNumber: 41
                                }, this)
                              }, void 0, false, {
                                fileName: _jsxFileName,
                                lineNumber: 3268,
                                columnNumber: 39
                              }, this), /*#__PURE__*/_jsxDEV("td", {
                                style: {
                                  padding: "10px 14px"
                                },
                                children: /*#__PURE__*/_jsxDEV("span", {
                                  style: {
                                    display: "inline-block",
                                    padding: "3px 8px",
                                    borderRadius: "6px",
                                    background: isPassed ? "#dcfce7" : "#fee2e2",
                                    color: isPassed ? "#15803d" : "#dc2626",
                                    fontWeight: "700",
                                    fontSize: "11px"
                                  },
                                  children: meta.actual
                                }, void 0, false, {
                                  fileName: _jsxFileName,
                                  lineNumber: 3274,
                                  columnNumber: 41
                                }, this)
                              }, void 0, false, {
                                fileName: _jsxFileName,
                                lineNumber: 3273,
                                columnNumber: 39
                              }, this), /*#__PURE__*/_jsxDEV("td", {
                                style: {
                                  padding: "10px 14px",
                                  color: isPassed ? "#94a3b8" : "#b45309",
                                  fontWeight: isPassed ? "400" : "600",
                                  fontSize: "12px"
                                },
                                children: meta.failureReason
                              }, void 0, false, {
                                fileName: _jsxFileName,
                                lineNumber: 3278,
                                columnNumber: 39
                              }, this), /*#__PURE__*/_jsxDEV("td", {
                                style: {
                                  padding: "10px 14px",
                                  maxWidth: "240px"
                                },
                                children: isPassed ? /*#__PURE__*/_jsxDEV("span", {
                                  style: {
                                    color: "#94a3b8",
                                    fontSize: "12px"
                                  },
                                  children: "\u2014"
                                }, void 0, false, {
                                  fileName: _jsxFileName,
                                  lineNumber: 3283,
                                  columnNumber: 43
                                }, this) : /*#__PURE__*/_jsxDEV("div", {
                                  style: {
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: "6px"
                                  },
                                  children: [/*#__PURE__*/_jsxDEV("span", {
                                    style: {
                                      fontSize: "13px",
                                      flexShrink: 0
                                    },
                                    children: "\uD83E\uDD16"
                                  }, void 0, false, {
                                    fileName: _jsxFileName,
                                    lineNumber: 3286,
                                    columnNumber: 45
                                  }, this), /*#__PURE__*/_jsxDEV("span", {
                                    style: {
                                      color: "#4f46e5",
                                      fontWeight: "600",
                                      fontSize: "11px",
                                      lineHeight: "1.5"
                                    },
                                    children: meta.aiSuggestion
                                  }, void 0, false, {
                                    fileName: _jsxFileName,
                                    lineNumber: 3287,
                                    columnNumber: 45
                                  }, this)]
                                }, void 0, true, {
                                  fileName: _jsxFileName,
                                  lineNumber: 3285,
                                  columnNumber: 43
                                }, this)
                              }, void 0, false, {
                                fileName: _jsxFileName,
                                lineNumber: 3281,
                                columnNumber: 39
                              }, this)]
                            }, sidx, true, {
                              fileName: _jsxFileName,
                              lineNumber: 3255,
                              columnNumber: 37
                            }, this);
                          })
                        }, void 0, false, {
                          fileName: _jsxFileName,
                          lineNumber: 3249,
                          columnNumber: 31
                        }, this)]
                      }, void 0, true, {
                        fileName: _jsxFileName,
                        lineNumber: 3239,
                        columnNumber: 29
                      }, this)
                    }, void 0, false, {
                      fileName: _jsxFileName,
                      lineNumber: 3238,
                      columnNumber: 27
                    }, this)]
                  }, iter.iteration, true, {
                    fileName: _jsxFileName,
                    lineNumber: 3175,
                    columnNumber: 23
                  }, this);
                });
              })(),
              (() => {
                const itemsPerPage = 50;
                const totalPages = Math.ceil(filteredIterations.length / itemsPerPage);
                if (totalPages <= 1) return null;
                return /*#__PURE__*/_jsxDEV("div", {
                  style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "12px",
                    marginTop: "16px",
                    padding: "12px 0 4px 0",
                    borderTop: "1px solid #e2e8f0"
                  },
                  children: [/*#__PURE__*/_jsxDEV("button", {
                    className: "btn-secondary",
                    disabled: logPage === 1,
                    onClick: (e) => { e.stopPropagation(); setLogPage(prev => Math.max(1, prev - 1)); },
                    style: { padding: "4px 10px", fontSize: "12px" },
                    children: "Previous"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 3176,
                    columnNumber: 23
                  }, this), /*#__PURE__*/_jsxDEV("span", {
                    style: { fontSize: "12px", color: "var(--text-muted)", fontWeight: "700" },
                    children: `Page ${logPage} of ${totalPages}`
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 3177,
                    columnNumber: 23
                  }, this), /*#__PURE__*/_jsxDEV("button", {
                    className: "btn-secondary",
                    disabled: logPage === totalPages,
                    onClick: (e) => { e.stopPropagation(); setLogPage(prev => Math.min(totalPages, prev + 1)); },
                    style: { padding: "4px 10px", fontSize: "12px" },
                    children: "Next"
                  }, void 0, false, {
                    fileName: _jsxFileName,
                    lineNumber: 3178,
                    columnNumber: 23
                  }, this)]
                }, "pagination_controls", true, {
                  fileName: _jsxFileName,
                  lineNumber: 3179,
                  columnNumber: 23
                }, this);
              })()
            ]
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 3171,
            columnNumber: 17
          }, this)
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 3164,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 3033,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName,
      lineNumber: 3019,
      columnNumber: 9
    }, this), showLaunchConfirmModal && definitionToLaunch && /*#__PURE__*/_jsxDEV("div", {
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(15, 23, 42, 0.65)",
        backdropFilter: "blur(6px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10000,
        animation: "fadeIn 0.2s ease-out"
      },
      children: /*#__PURE__*/_jsxDEV("div", {
        style: {
          background: "#ffffff",
          width: "95%",
          maxWidth: "500px",
          borderRadius: "16px",
          boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          overflow: "hidden",
          border: "1px solid #cbd5e1"
        },
        children: [/*#__PURE__*/_jsxDEV("div", {
          style: {
            background: "#fffbeb",
            borderBottom: "1px solid #fef3c7",
            padding: "16px 20px",
            display: "flex",
            alignItems: "center",
            gap: "12px"
          },
          children: [/*#__PURE__*/_jsxDEV("span", {
            style: {
              fontSize: "24px"
            },
            children: "\u26A0\uFE0F"
          }, void 0, false, {
            fileName: _jsxFileName,
            lineNumber: 3344,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("div", {
            children: [/*#__PURE__*/_jsxDEV("h4", {
              style: {
                margin: 0,
                color: "#b45309",
                fontWeight: "800",
                fontSize: "14px"
              },
              children: "Load Test Authorization"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 3346,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("p", {
              style: {
                margin: "2px 0 0 0",
                fontSize: "12px",
                color: "#d97706"
              },
              children: "High-impact traffic simulation execution"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 3347,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 3345,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 3336,
          columnNumber: 13
        }, this), /*#__PURE__*/_jsxDEV("div", {
          style: {
            padding: "24px"
          },
          children: [/*#__PURE__*/_jsxDEV("p", {
            style: {
              margin: "0 0 16px 0",
              fontSize: "13px",
              color: "#475569",
              lineHeight: "1.5"
            },
            children: ["You are about to launch a concurrent load test using the scenario: ", /*#__PURE__*/_jsxDEV("strong", {
              style: {
                color: "#1e293b"
              },
              children: definitionToLaunch.name
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 3354,
              columnNumber: 84
            }, this), "."]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 3353,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("div", {
            style: {
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
              borderRadius: "8px",
              padding: "14px",
              fontSize: "12px",
              color: "#334155",
              marginBottom: "20px",
              display: "flex",
              flexDirection: "column",
              gap: "6px"
            },
            children: [/*#__PURE__*/_jsxDEV("div", {
              children: ["\uD83C\uDFAF ", /*#__PURE__*/_jsxDEV("strong", {
                children: "Target URL:"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 3369,
                columnNumber: 25
              }, this), " ", /*#__PURE__*/_jsxDEV("code", {
                children: definitionToLaunch.target_url
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 3369,
                columnNumber: 54
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 3369,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("div", {
              children: ["\uD83D\uDC65 ", /*#__PURE__*/_jsxDEV("strong", {
                children: "Concurrency:"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 3370,
                columnNumber: 25
              }, this), " ", /*#__PURE__*/_jsxDEV("code", {
                children: [definitionToLaunch.vu_count, " VUs"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 3370,
                columnNumber: 55
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 3370,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("div", {
              children: ["\u23F1\uFE0F ", /*#__PURE__*/_jsxDEV("strong", {
                children: "Steady Duration:"
              }, void 0, false, {
                fileName: _jsxFileName,
                lineNumber: 3371,
                columnNumber: 25
              }, this), " ", /*#__PURE__*/_jsxDEV("code", {
                children: [definitionToLaunch.steady_state_duration, " seconds"]
              }, void 0, true, {
                fileName: _jsxFileName,
                lineNumber: 3371,
                columnNumber: 59
              }, this)]
            }, void 0, true, {
              fileName: _jsxFileName,
              lineNumber: 3371,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 3357,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("div", {
            style: {
              display: "flex",
              gap: "10px",
              alignItems: "flex-start",
              marginBottom: "20px"
            },
            children: [/*#__PURE__*/_jsxDEV("input", {
              type: "checkbox",
              id: "custom-auth-checkbox",
              checked: isAuthorizedChecked,
              style: {
                width: "18px",
                height: "18px",
                cursor: "pointer",
                marginTop: "2px"
              },
              onChange: e => setIsAuthorizedChecked(e.target.checked)
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 3375,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("label", {
              htmlFor: "custom-auth-checkbox",
              style: {
                fontSize: "12px",
                color: "#475569",
                cursor: "pointer",
                lineHeight: "1.4",
                fontWeight: "600"
              },
              children: "I confirm that I possess explicit legal authorization to load test the target system."
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 3382,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 3374,
            columnNumber: 15
          }, this), /*#__PURE__*/_jsxDEV("div", {
            style: {
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px"
            },
            children: [/*#__PURE__*/_jsxDEV("button", {
              onClick: () => {
                setShowLaunchConfirmModal(false);
                setDefinitionToLaunch(null);
                setIsAuthorizedChecked(false);
              },
              style: {
                padding: "8px 16px",
                borderRadius: "6px",
                border: "1px solid #cbd5e1",
                background: "#ffffff",
                color: "#475569",
                fontWeight: "700",
                cursor: "pointer",
                fontSize: "12px"
              },
              children: "Cancel"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 3389,
              columnNumber: 17
            }, this), /*#__PURE__*/_jsxDEV("button", {
              id: "confirm-launch-btn",
              disabled: !isAuthorizedChecked,
              onClick: executeLaunchLoad,
              style: {
                padding: "8px 16px",
                borderRadius: "6px",
                border: "none",
                background: "#d97706",
                color: "#ffffff",
                fontWeight: "700",
                cursor: isAuthorizedChecked ? "pointer" : "not-allowed",
                fontSize: "12px",
                opacity: isAuthorizedChecked ? "1" : "0.5"
              },
              children: "\uD83D\uDE80 Confirm & Launch"
            }, void 0, false, {
              fileName: _jsxFileName,
              lineNumber: 3408,
              columnNumber: 17
            }, this)]
          }, void 0, true, {
            fileName: _jsxFileName,
            lineNumber: 3388,
            columnNumber: 15
          }, this)]
        }, void 0, true, {
          fileName: _jsxFileName,
          lineNumber: 3352,
          columnNumber: 13
        }, this)]
      }, void 0, true, {
        fileName: _jsxFileName,
        lineNumber: 3326,
        columnNumber: 11
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName,
      lineNumber: 3312,
      columnNumber: 9
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName,
    lineNumber: 1033,
    columnNumber: 5
  }, this);
}
_s2(LoadTesting, "EAKkXPLVbbCKs+LWuLIPlU8ZSho=");
_c2 = LoadTesting;
_s(LoadTesting, "0YhgxjidVJW3QWZ5mIe6KueHeo8=");
_c = LoadTesting;
var _c;
$RefreshReg$(_c, "LoadTesting");
var _c2;
$RefreshReg$(_c2, "LoadTesting");

